{
    "package": "@energysage/es-ds-styles",
    "version": "4.1.0",
    "breakpoints": {
        "xs": "0",
        "sm": "576px",
        "md": "768px",
        "lg": "992px",
        "xl": "1200px",
        "xxl": "1900px"
    },
    "categories": [
        {
            "name": "align",
            "source": "scss/utilities/_align.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "align-baseline",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-baseline",
                            "atRules": [],
                            "declarations": [
                                "vertical-align: baseline !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-bottom",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-bottom",
                            "atRules": [],
                            "declarations": [
                                "vertical-align: bottom !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-middle",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-middle",
                            "atRules": [],
                            "declarations": [
                                "vertical-align: middle !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-text-bottom",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-text-bottom",
                            "atRules": [],
                            "declarations": [
                                "vertical-align: text-bottom !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-text-top",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-text-top",
                            "atRules": [],
                            "declarations": [
                                "vertical-align: text-top !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-top",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-top",
                            "atRules": [],
                            "declarations": [
                                "vertical-align: top !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "background",
            "source": "scss/utilities/_background.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "bg-black",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-black",
                            "atRules": [],
                            "declarations": [
                                "background-color: #000 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-blue",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-blue",
                            "atRules": [],
                            "declarations": [
                                "background-color: #2e46b9 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-blue-50",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-blue-50",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ddedff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-blue-100",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-blue-100",
                            "atRules": [],
                            "declarations": [
                                "background-color: #c8dfff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-blue-200",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-blue-200",
                            "atRules": [],
                            "declarations": [
                                "background-color: #a7c9ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-blue-300",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-blue-300",
                            "atRules": [],
                            "declarations": [
                                "background-color: #85b2ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-blue-400",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-blue-400",
                            "atRules": [],
                            "declarations": [
                                "background-color: #688aea !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-blue-500",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-blue-500",
                            "atRules": [],
                            "declarations": [
                                "background-color: #4a62d4 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-blue-600",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-blue-600",
                            "atRules": [],
                            "declarations": [
                                "background-color: #2e46b9 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-blue-700",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-blue-700",
                            "atRules": [],
                            "declarations": [
                                "background-color: #1d3297 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-blue-800",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-blue-800",
                            "atRules": [],
                            "declarations": [
                                "background-color: #162676 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-blue-900",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-blue-900",
                            "atRules": [],
                            "declarations": [
                                "background-color: #1b1763 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-dark-blue",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-dark-blue",
                            "atRules": [],
                            "declarations": [
                                "background-color: #1b1763 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-error-50",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-error-50",
                            "atRules": [],
                            "declarations": [
                                "background-color: #f7d7db !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-error-500",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-error-500",
                            "atRules": [],
                            "declarations": [
                                "background-color: #efa6af !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-error-900",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-error-900",
                            "atRules": [],
                            "declarations": [
                                "background-color: #de3c50 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-50",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-gray-50",
                            "atRules": [],
                            "declarations": [
                                "background-color: #f1f3fb !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-100",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-gray-100",
                            "atRules": [],
                            "declarations": [
                                "background-color: #eaecf4 !important"
                            ]
                        },
                        {
                            "selector": ".bg-gray-100",
                            "atRules": [],
                            "declarations": [
                                "background-color: #eaecf4 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-150",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-gray-150",
                            "atRules": [],
                            "declarations": [
                                "background-color: #eaecf4 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-200",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-gray-200",
                            "atRules": [],
                            "declarations": [
                                "background-color: #dfe1eb !important"
                            ]
                        },
                        {
                            "selector": ".bg-gray-200",
                            "atRules": [],
                            "declarations": [
                                "background-color: #dfe1eb !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-300",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-gray-300",
                            "atRules": [],
                            "declarations": [
                                "background-color: #cfd1df !important"
                            ]
                        },
                        {
                            "selector": ".bg-gray-300",
                            "atRules": [],
                            "declarations": [
                                "background-color: #cfd1df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-400",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-gray-400",
                            "atRules": [],
                            "declarations": [
                                "background-color: #a7aaba !important"
                            ]
                        },
                        {
                            "selector": ".bg-gray-400",
                            "atRules": [],
                            "declarations": [
                                "background-color: #a7aaba !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-500",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-gray-500",
                            "atRules": [],
                            "declarations": [
                                "background-color: #878999 !important"
                            ]
                        },
                        {
                            "selector": ".bg-gray-500",
                            "atRules": [],
                            "declarations": [
                                "background-color: #878999 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-600",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-gray-600",
                            "atRules": [],
                            "declarations": [
                                "background-color: #646776 !important"
                            ]
                        },
                        {
                            "selector": ".bg-gray-600",
                            "atRules": [],
                            "declarations": [
                                "background-color: #646776 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-700",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-gray-700",
                            "atRules": [],
                            "declarations": [
                                "background-color: #515362 !important"
                            ]
                        },
                        {
                            "selector": ".bg-gray-700",
                            "atRules": [],
                            "declarations": [
                                "background-color: #515362 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-800",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-gray-800",
                            "atRules": [],
                            "declarations": [
                                "background-color: #323543 !important"
                            ]
                        },
                        {
                            "selector": ".bg-gray-800",
                            "atRules": [],
                            "declarations": [
                                "background-color: #323543 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-900",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-gray-900",
                            "atRules": [],
                            "declarations": [
                                "background-color: #222633 !important"
                            ]
                        },
                        {
                            "selector": ".bg-gray-900",
                            "atRules": [],
                            "declarations": [
                                "background-color: #222633 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-medium-blue",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-medium-blue",
                            "atRules": [],
                            "declarations": [
                                "background-color: #85b2ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-orange-50",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-orange-50",
                            "atRules": [],
                            "declarations": [
                                "background-color: #fff3df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-orange-100",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-orange-100",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ffe7ca !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-orange-200",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-orange-200",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ffdbb5 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-orange-300",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-orange-300",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ffcea0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-orange-400",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-orange-400",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ffc28b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-orange-500",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-orange-500",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ffb67b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-orange-600",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-orange-600",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ffaa66 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-orange-700",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-orange-700",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ff9d51 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-orange-800",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-orange-800",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ff9133 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-orange-900",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-orange-900",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ed7c2b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-soft-blue",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-soft-blue",
                            "atRules": [],
                            "declarations": [
                                "background-color: #c8dfff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-success-50",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-success-50",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ccedd8 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-success-500",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-success-500",
                            "atRules": [],
                            "declarations": [
                                "background-color: #80ce97 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-success-900",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-success-900",
                            "atRules": [],
                            "declarations": [
                                "background-color: #00a759 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-transparent",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-transparent",
                            "atRules": [],
                            "declarations": [
                                "background-color: transparent !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-warm-orange",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-warm-orange",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ff9133 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-warning-50",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-warning-50",
                            "atRules": [],
                            "declarations": [
                                "background-color: #f8efca !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-warning-500",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-warning-500",
                            "atRules": [],
                            "declarations": [
                                "background-color: #f4df83 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-warning-900",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-warning-900",
                            "atRules": [],
                            "declarations": [
                                "background-color: #f4ca11 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-white",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".bg-white",
                            "atRules": [],
                            "declarations": [
                                "background-color: #fff !important"
                            ]
                        },
                        {
                            "selector": ".bg-white",
                            "atRules": [],
                            "declarations": [
                                "background-color: #fff !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "borders",
            "source": "scss/utilities/_borders.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "border",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border",
                            "atRules": [],
                            "declarations": [
                                "border: 1px solid #cfd1df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-0",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-0",
                            "atRules": [],
                            "declarations": [
                                "border: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-blue-50",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-blue-50",
                            "atRules": [],
                            "declarations": [
                                "border-color: #ddedff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-blue-100",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-blue-100",
                            "atRules": [],
                            "declarations": [
                                "border-color: #c8dfff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-blue-200",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-blue-200",
                            "atRules": [],
                            "declarations": [
                                "border-color: #a7c9ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-blue-300",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-blue-300",
                            "atRules": [],
                            "declarations": [
                                "border-color: #85b2ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-blue-400",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-blue-400",
                            "atRules": [],
                            "declarations": [
                                "border-color: #688aea !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-blue-500",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-blue-500",
                            "atRules": [],
                            "declarations": [
                                "border-color: #4a62d4 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-blue-600",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-blue-600",
                            "atRules": [],
                            "declarations": [
                                "border-color: #2e46b9 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-blue-700",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-blue-700",
                            "atRules": [],
                            "declarations": [
                                "border-color: #1d3297 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-blue-800",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-blue-800",
                            "atRules": [],
                            "declarations": [
                                "border-color: #162676 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-blue-900",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-blue-900",
                            "atRules": [],
                            "declarations": [
                                "border-color: #1b1763 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-bottom",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-bottom",
                            "atRules": [],
                            "declarations": [
                                "border-bottom: 1px solid #cfd1df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-bottom-0",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-bottom-0",
                            "atRules": [],
                            "declarations": [
                                "border-bottom: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-dark-blue",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-dark-blue",
                            "atRules": [],
                            "declarations": [
                                "border-color: #1b1763 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-left",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-left",
                            "atRules": [],
                            "declarations": [
                                "border-left: 1px solid #cfd1df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-left-0",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-left-0",
                            "atRules": [],
                            "declarations": [
                                "border-left: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-medium-blue",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-medium-blue",
                            "atRules": [],
                            "declarations": [
                                "border-color: #85b2ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-right",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-right",
                            "atRules": [],
                            "declarations": [
                                "border-right: 1px solid #cfd1df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-right-0",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-right-0",
                            "atRules": [],
                            "declarations": [
                                "border-right: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-soft-blue",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-soft-blue",
                            "atRules": [],
                            "declarations": [
                                "border-color: #c8dfff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-top",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-top",
                            "atRules": [],
                            "declarations": [
                                "border-top: 1px solid #cfd1df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-top-0",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-top-0",
                            "atRules": [],
                            "declarations": [
                                "border-top: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-warm-orange",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-warm-orange",
                            "atRules": [],
                            "declarations": [
                                "border-color: #ff9133 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-white",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-white",
                            "atRules": [],
                            "declarations": [
                                "border-color: #fff !important"
                            ]
                        },
                        {
                            "selector": ".border-white",
                            "atRules": [],
                            "declarations": [
                                "border-color: #fff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "rounded",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".rounded",
                            "atRules": [],
                            "declarations": [
                                "border-radius: 0.75rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "rounded-0",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".rounded-0",
                            "atRules": [],
                            "declarations": [
                                "border-radius: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "rounded-bottom",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".rounded-bottom",
                            "atRules": [],
                            "declarations": [
                                "border-bottom-right-radius: 0.75rem !important",
                                "border-bottom-left-radius: 0.75rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "rounded-circle",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".rounded-circle",
                            "atRules": [],
                            "declarations": [
                                "border-radius: 50% !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "rounded-left",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".rounded-left",
                            "atRules": [],
                            "declarations": [
                                "border-top-left-radius: 0.75rem !important",
                                "border-bottom-left-radius: 0.75rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "rounded-lg",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".rounded-lg",
                            "atRules": [],
                            "declarations": [
                                "border-radius: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "rounded-pill",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".rounded-pill",
                            "atRules": [],
                            "declarations": [
                                "border-radius: 50rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "rounded-right",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".rounded-right",
                            "atRules": [],
                            "declarations": [
                                "border-top-right-radius: 0.75rem !important",
                                "border-bottom-right-radius: 0.75rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "rounded-sm",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".rounded-sm",
                            "atRules": [],
                            "declarations": [
                                "border-radius: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "rounded-top",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".rounded-top",
                            "atRules": [],
                            "declarations": [
                                "border-top-left-radius: 0.75rem !important",
                                "border-top-right-radius: 0.75rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "rounded-xs",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".rounded-xs",
                            "atRules": [],
                            "declarations": [
                                "border-radius: 0.25rem !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "clearfix",
            "source": "scss/utilities/_clearfix.scss",
            "allClassesUseImportant": false,
            "classes": [
                {
                    "name": "clearfix",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".clearfix::after",
                            "atRules": [],
                            "declarations": [
                                "display: block",
                                "clear: both",
                                "content: \"\""
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "code",
            "source": "scss/_code.scss",
            "allClassesUseImportant": false,
            "classes": [
                {
                    "name": "pre-scrollable",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".pre-scrollable",
                            "atRules": [],
                            "declarations": [
                                "max-height: 340px",
                                "overflow-y: scroll"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "display",
            "source": "scss/utilities/_display.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "d-block",
                    "display": "d-*-block",
                    "variants": [
                        "d-sm-block",
                        "d-md-block",
                        "d-lg-block",
                        "d-xl-block",
                        "d-xxl-block"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-block",
                            "atRules": [],
                            "declarations": [
                                "display: block !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-flex",
                    "display": "d-*-flex",
                    "variants": [
                        "d-sm-flex",
                        "d-md-flex",
                        "d-lg-flex",
                        "d-xl-flex",
                        "d-xxl-flex"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-flex",
                            "atRules": [],
                            "declarations": [
                                "display: flex !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-inline",
                    "display": "d-*-inline",
                    "variants": [
                        "d-sm-inline",
                        "d-md-inline",
                        "d-lg-inline",
                        "d-xl-inline",
                        "d-xxl-inline"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-inline",
                            "atRules": [],
                            "declarations": [
                                "display: inline !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-inline-block",
                    "display": "d-*-inline-block",
                    "variants": [
                        "d-sm-inline-block",
                        "d-md-inline-block",
                        "d-lg-inline-block",
                        "d-xl-inline-block",
                        "d-xxl-inline-block"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-inline-block",
                            "atRules": [],
                            "declarations": [
                                "display: inline-block !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-inline-flex",
                    "display": "d-*-inline-flex",
                    "variants": [
                        "d-sm-inline-flex",
                        "d-md-inline-flex",
                        "d-lg-inline-flex",
                        "d-xl-inline-flex",
                        "d-xxl-inline-flex"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-inline-flex",
                            "atRules": [],
                            "declarations": [
                                "display: inline-flex !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-none",
                    "display": "d-*-none",
                    "variants": [
                        "d-sm-none",
                        "d-md-none",
                        "d-lg-none",
                        "d-xl-none",
                        "d-xxl-none"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-none",
                            "atRules": [],
                            "declarations": [
                                "display: none !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-print-block",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-print-block",
                            "atRules": [
                                "@media print"
                            ],
                            "declarations": [
                                "display: block !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-print-flex",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-print-flex",
                            "atRules": [
                                "@media print"
                            ],
                            "declarations": [
                                "display: flex !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-print-inline",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-print-inline",
                            "atRules": [
                                "@media print"
                            ],
                            "declarations": [
                                "display: inline !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-print-inline-block",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-print-inline-block",
                            "atRules": [
                                "@media print"
                            ],
                            "declarations": [
                                "display: inline-block !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-print-inline-flex",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-print-inline-flex",
                            "atRules": [
                                "@media print"
                            ],
                            "declarations": [
                                "display: inline-flex !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-print-none",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-print-none",
                            "atRules": [
                                "@media print"
                            ],
                            "declarations": [
                                "display: none !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-print-table",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-print-table",
                            "atRules": [
                                "@media print"
                            ],
                            "declarations": [
                                "display: table !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-print-table-cell",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-print-table-cell",
                            "atRules": [
                                "@media print"
                            ],
                            "declarations": [
                                "display: table-cell !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-print-table-row",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-print-table-row",
                            "atRules": [
                                "@media print"
                            ],
                            "declarations": [
                                "display: table-row !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-table",
                    "display": "d-*-table",
                    "variants": [
                        "d-sm-table",
                        "d-md-table",
                        "d-lg-table",
                        "d-xl-table",
                        "d-xxl-table"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-table",
                            "atRules": [],
                            "declarations": [
                                "display: table !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-table-cell",
                    "display": "d-*-table-cell",
                    "variants": [
                        "d-sm-table-cell",
                        "d-md-table-cell",
                        "d-lg-table-cell",
                        "d-xl-table-cell",
                        "d-xxl-table-cell"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-table-cell",
                            "atRules": [],
                            "declarations": [
                                "display: table-cell !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "d-table-row",
                    "display": "d-*-table-row",
                    "variants": [
                        "d-sm-table-row",
                        "d-md-table-row",
                        "d-lg-table-row",
                        "d-xl-table-row",
                        "d-xxl-table-row"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".d-table-row",
                            "atRules": [],
                            "declarations": [
                                "display: table-row !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "embed",
            "source": "scss/utilities/_embed.scss",
            "allClassesUseImportant": false,
            "classes": [
                {
                    "name": "embed-responsive",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".embed-responsive",
                            "atRules": [],
                            "declarations": [
                                "position: relative",
                                "display: block",
                                "width: 100%",
                                "padding: 0",
                                "overflow: hidden"
                            ]
                        },
                        {
                            "selector": ".embed-responsive::before",
                            "atRules": [],
                            "declarations": [
                                "display: block",
                                "content: \"\""
                            ]
                        },
                        {
                            "selector": ".embed-responsive iframe",
                            "atRules": [],
                            "declarations": [
                                "position: absolute",
                                "top: 0",
                                "bottom: 0",
                                "left: 0",
                                "width: 100%",
                                "height: 100%",
                                "border: 0"
                            ]
                        },
                        {
                            "selector": ".embed-responsive embed",
                            "atRules": [],
                            "declarations": [
                                "position: absolute",
                                "top: 0",
                                "bottom: 0",
                                "left: 0",
                                "width: 100%",
                                "height: 100%",
                                "border: 0"
                            ]
                        },
                        {
                            "selector": ".embed-responsive object",
                            "atRules": [],
                            "declarations": [
                                "position: absolute",
                                "top: 0",
                                "bottom: 0",
                                "left: 0",
                                "width: 100%",
                                "height: 100%",
                                "border: 0"
                            ]
                        },
                        {
                            "selector": ".embed-responsive video",
                            "atRules": [],
                            "declarations": [
                                "position: absolute",
                                "top: 0",
                                "bottom: 0",
                                "left: 0",
                                "width: 100%",
                                "height: 100%",
                                "border: 0"
                            ]
                        }
                    ]
                },
                {
                    "name": "embed-responsive-1by1",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".embed-responsive-1by1::before",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 100%"
                            ]
                        }
                    ]
                },
                {
                    "name": "embed-responsive-4by3",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".embed-responsive-4by3::before",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 75%"
                            ]
                        }
                    ]
                },
                {
                    "name": "embed-responsive-16by9",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".embed-responsive-16by9::before",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 56.25%"
                            ]
                        }
                    ]
                },
                {
                    "name": "embed-responsive-21by9",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".embed-responsive-21by9::before",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 42.85714286%"
                            ]
                        }
                    ]
                },
                {
                    "name": "embed-responsive-item",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".embed-responsive .embed-responsive-item",
                            "atRules": [],
                            "declarations": [
                                "position: absolute",
                                "top: 0",
                                "bottom: 0",
                                "left: 0",
                                "width: 100%",
                                "height: 100%",
                                "border: 0"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "flex",
            "source": "scss/utilities/_flex.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "align-content-around",
                    "display": "align-content-*-around",
                    "variants": [
                        "align-content-sm-around",
                        "align-content-md-around",
                        "align-content-lg-around",
                        "align-content-xl-around",
                        "align-content-xxl-around"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-content-around",
                            "atRules": [],
                            "declarations": [
                                "align-content: space-around !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-content-between",
                    "display": "align-content-*-between",
                    "variants": [
                        "align-content-sm-between",
                        "align-content-md-between",
                        "align-content-lg-between",
                        "align-content-xl-between",
                        "align-content-xxl-between"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-content-between",
                            "atRules": [],
                            "declarations": [
                                "align-content: space-between !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-content-center",
                    "display": "align-content-*-center",
                    "variants": [
                        "align-content-sm-center",
                        "align-content-md-center",
                        "align-content-lg-center",
                        "align-content-xl-center",
                        "align-content-xxl-center"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-content-center",
                            "atRules": [],
                            "declarations": [
                                "align-content: center !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-content-end",
                    "display": "align-content-*-end",
                    "variants": [
                        "align-content-sm-end",
                        "align-content-md-end",
                        "align-content-lg-end",
                        "align-content-xl-end",
                        "align-content-xxl-end"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-content-end",
                            "atRules": [],
                            "declarations": [
                                "align-content: flex-end !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-content-start",
                    "display": "align-content-*-start",
                    "variants": [
                        "align-content-sm-start",
                        "align-content-md-start",
                        "align-content-lg-start",
                        "align-content-xl-start",
                        "align-content-xxl-start"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-content-start",
                            "atRules": [],
                            "declarations": [
                                "align-content: flex-start !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-content-stretch",
                    "display": "align-content-*-stretch",
                    "variants": [
                        "align-content-sm-stretch",
                        "align-content-md-stretch",
                        "align-content-lg-stretch",
                        "align-content-xl-stretch",
                        "align-content-xxl-stretch"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-content-stretch",
                            "atRules": [],
                            "declarations": [
                                "align-content: stretch !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-items-baseline",
                    "display": "align-items-*-baseline",
                    "variants": [
                        "align-items-sm-baseline",
                        "align-items-md-baseline",
                        "align-items-lg-baseline",
                        "align-items-xl-baseline",
                        "align-items-xxl-baseline"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-items-baseline",
                            "atRules": [],
                            "declarations": [
                                "align-items: baseline !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-items-center",
                    "display": "align-items-*-center",
                    "variants": [
                        "align-items-sm-center",
                        "align-items-md-center",
                        "align-items-lg-center",
                        "align-items-xl-center",
                        "align-items-xxl-center"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-items-center",
                            "atRules": [],
                            "declarations": [
                                "align-items: center !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-items-end",
                    "display": "align-items-*-end",
                    "variants": [
                        "align-items-sm-end",
                        "align-items-md-end",
                        "align-items-lg-end",
                        "align-items-xl-end",
                        "align-items-xxl-end"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-items-end",
                            "atRules": [],
                            "declarations": [
                                "align-items: flex-end !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-items-start",
                    "display": "align-items-*-start",
                    "variants": [
                        "align-items-sm-start",
                        "align-items-md-start",
                        "align-items-lg-start",
                        "align-items-xl-start",
                        "align-items-xxl-start"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-items-start",
                            "atRules": [],
                            "declarations": [
                                "align-items: flex-start !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-items-stretch",
                    "display": "align-items-*-stretch",
                    "variants": [
                        "align-items-sm-stretch",
                        "align-items-md-stretch",
                        "align-items-lg-stretch",
                        "align-items-xl-stretch",
                        "align-items-xxl-stretch"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-items-stretch",
                            "atRules": [],
                            "declarations": [
                                "align-items: stretch !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-self-auto",
                    "display": "align-self-*-auto",
                    "variants": [
                        "align-self-sm-auto",
                        "align-self-md-auto",
                        "align-self-lg-auto",
                        "align-self-xl-auto",
                        "align-self-xxl-auto"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-self-auto",
                            "atRules": [],
                            "declarations": [
                                "align-self: auto !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-self-baseline",
                    "display": "align-self-*-baseline",
                    "variants": [
                        "align-self-sm-baseline",
                        "align-self-md-baseline",
                        "align-self-lg-baseline",
                        "align-self-xl-baseline",
                        "align-self-xxl-baseline"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-self-baseline",
                            "atRules": [],
                            "declarations": [
                                "align-self: baseline !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-self-center",
                    "display": "align-self-*-center",
                    "variants": [
                        "align-self-sm-center",
                        "align-self-md-center",
                        "align-self-lg-center",
                        "align-self-xl-center",
                        "align-self-xxl-center"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-self-center",
                            "atRules": [],
                            "declarations": [
                                "align-self: center !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-self-end",
                    "display": "align-self-*-end",
                    "variants": [
                        "align-self-sm-end",
                        "align-self-md-end",
                        "align-self-lg-end",
                        "align-self-xl-end",
                        "align-self-xxl-end"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-self-end",
                            "atRules": [],
                            "declarations": [
                                "align-self: flex-end !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-self-start",
                    "display": "align-self-*-start",
                    "variants": [
                        "align-self-sm-start",
                        "align-self-md-start",
                        "align-self-lg-start",
                        "align-self-xl-start",
                        "align-self-xxl-start"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-self-start",
                            "atRules": [],
                            "declarations": [
                                "align-self: flex-start !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "align-self-stretch",
                    "display": "align-self-*-stretch",
                    "variants": [
                        "align-self-sm-stretch",
                        "align-self-md-stretch",
                        "align-self-lg-stretch",
                        "align-self-xl-stretch",
                        "align-self-xxl-stretch"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".align-self-stretch",
                            "atRules": [],
                            "declarations": [
                                "align-self: stretch !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "flex-column",
                    "display": "flex-*-column",
                    "variants": [
                        "flex-sm-column",
                        "flex-md-column",
                        "flex-lg-column",
                        "flex-xl-column",
                        "flex-xxl-column"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".flex-column",
                            "atRules": [],
                            "declarations": [
                                "flex-direction: column !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "flex-column-reverse",
                    "display": "flex-*-column-reverse",
                    "variants": [
                        "flex-sm-column-reverse",
                        "flex-md-column-reverse",
                        "flex-lg-column-reverse",
                        "flex-xl-column-reverse",
                        "flex-xxl-column-reverse"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".flex-column-reverse",
                            "atRules": [],
                            "declarations": [
                                "flex-direction: column-reverse !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "flex-fill",
                    "display": "flex-*-fill",
                    "variants": [
                        "flex-sm-fill",
                        "flex-md-fill",
                        "flex-lg-fill",
                        "flex-xl-fill",
                        "flex-xxl-fill"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".flex-fill",
                            "atRules": [],
                            "declarations": [
                                "flex: 1 1 auto !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "flex-grow-0",
                    "display": "flex-*-grow-0",
                    "variants": [
                        "flex-sm-grow-0",
                        "flex-md-grow-0",
                        "flex-lg-grow-0",
                        "flex-xl-grow-0",
                        "flex-xxl-grow-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".flex-grow-0",
                            "atRules": [],
                            "declarations": [
                                "flex-grow: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "flex-grow-1",
                    "display": "flex-*-grow-1",
                    "variants": [
                        "flex-sm-grow-1",
                        "flex-md-grow-1",
                        "flex-lg-grow-1",
                        "flex-xl-grow-1",
                        "flex-xxl-grow-1"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".flex-grow-1",
                            "atRules": [],
                            "declarations": [
                                "flex-grow: 1 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "flex-nowrap",
                    "display": "flex-*-nowrap",
                    "variants": [
                        "flex-sm-nowrap",
                        "flex-md-nowrap",
                        "flex-lg-nowrap",
                        "flex-xl-nowrap",
                        "flex-xxl-nowrap"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".flex-nowrap",
                            "atRules": [],
                            "declarations": [
                                "flex-wrap: nowrap !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "flex-row",
                    "display": "flex-*-row",
                    "variants": [
                        "flex-sm-row",
                        "flex-md-row",
                        "flex-lg-row",
                        "flex-xl-row",
                        "flex-xxl-row"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".flex-row",
                            "atRules": [],
                            "declarations": [
                                "flex-direction: row !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "flex-row-reverse",
                    "display": "flex-*-row-reverse",
                    "variants": [
                        "flex-sm-row-reverse",
                        "flex-md-row-reverse",
                        "flex-lg-row-reverse",
                        "flex-xl-row-reverse",
                        "flex-xxl-row-reverse"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".flex-row-reverse",
                            "atRules": [],
                            "declarations": [
                                "flex-direction: row-reverse !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "flex-shrink-0",
                    "display": "flex-*-shrink-0",
                    "variants": [
                        "flex-sm-shrink-0",
                        "flex-md-shrink-0",
                        "flex-lg-shrink-0",
                        "flex-xl-shrink-0",
                        "flex-xxl-shrink-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".flex-shrink-0",
                            "atRules": [],
                            "declarations": [
                                "flex-shrink: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "flex-shrink-1",
                    "display": "flex-*-shrink-1",
                    "variants": [
                        "flex-sm-shrink-1",
                        "flex-md-shrink-1",
                        "flex-lg-shrink-1",
                        "flex-xl-shrink-1",
                        "flex-xxl-shrink-1"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".flex-shrink-1",
                            "atRules": [],
                            "declarations": [
                                "flex-shrink: 1 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "flex-wrap",
                    "display": "flex-*-wrap",
                    "variants": [
                        "flex-sm-wrap",
                        "flex-md-wrap",
                        "flex-lg-wrap",
                        "flex-xl-wrap",
                        "flex-xxl-wrap"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".flex-wrap",
                            "atRules": [],
                            "declarations": [
                                "flex-wrap: wrap !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "flex-wrap-reverse",
                    "display": "flex-*-wrap-reverse",
                    "variants": [
                        "flex-sm-wrap-reverse",
                        "flex-md-wrap-reverse",
                        "flex-lg-wrap-reverse",
                        "flex-xl-wrap-reverse",
                        "flex-xxl-wrap-reverse"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".flex-wrap-reverse",
                            "atRules": [],
                            "declarations": [
                                "flex-wrap: wrap-reverse !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "justify-content-around",
                    "display": "justify-content-*-around",
                    "variants": [
                        "justify-content-sm-around",
                        "justify-content-md-around",
                        "justify-content-lg-around",
                        "justify-content-xl-around",
                        "justify-content-xxl-around"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".justify-content-around",
                            "atRules": [],
                            "declarations": [
                                "justify-content: space-around !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "justify-content-between",
                    "display": "justify-content-*-between",
                    "variants": [
                        "justify-content-sm-between",
                        "justify-content-md-between",
                        "justify-content-lg-between",
                        "justify-content-xl-between",
                        "justify-content-xxl-between"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".justify-content-between",
                            "atRules": [],
                            "declarations": [
                                "justify-content: space-between !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "justify-content-center",
                    "display": "justify-content-*-center",
                    "variants": [
                        "justify-content-sm-center",
                        "justify-content-md-center",
                        "justify-content-lg-center",
                        "justify-content-xl-center",
                        "justify-content-xxl-center"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".justify-content-center",
                            "atRules": [],
                            "declarations": [
                                "justify-content: center !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "justify-content-end",
                    "display": "justify-content-*-end",
                    "variants": [
                        "justify-content-sm-end",
                        "justify-content-md-end",
                        "justify-content-lg-end",
                        "justify-content-xl-end",
                        "justify-content-xxl-end"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".justify-content-end",
                            "atRules": [],
                            "declarations": [
                                "justify-content: flex-end !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "justify-content-start",
                    "display": "justify-content-*-start",
                    "variants": [
                        "justify-content-sm-start",
                        "justify-content-md-start",
                        "justify-content-lg-start",
                        "justify-content-xl-start",
                        "justify-content-xxl-start"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".justify-content-start",
                            "atRules": [],
                            "declarations": [
                                "justify-content: flex-start !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "float",
            "source": "scss/utilities/_float.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "float-left",
                    "display": "float-*-left",
                    "variants": [
                        "float-sm-left",
                        "float-md-left",
                        "float-lg-left",
                        "float-xl-left",
                        "float-xxl-left"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".float-left",
                            "atRules": [],
                            "declarations": [
                                "float: left !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "float-none",
                    "display": "float-*-none",
                    "variants": [
                        "float-sm-none",
                        "float-md-none",
                        "float-lg-none",
                        "float-xl-none",
                        "float-xxl-none"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".float-none",
                            "atRules": [],
                            "declarations": [
                                "float: none !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "float-right",
                    "display": "float-*-right",
                    "variants": [
                        "float-sm-right",
                        "float-md-right",
                        "float-lg-right",
                        "float-xl-right",
                        "float-xxl-right"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".float-right",
                            "atRules": [],
                            "declarations": [
                                "float: right !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "images",
            "source": "scss/_images.scss",
            "allClassesUseImportant": false,
            "classes": [
                {
                    "name": "figure",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".figure",
                            "atRules": [],
                            "declarations": [
                                "display: inline-block"
                            ]
                        }
                    ]
                },
                {
                    "name": "figure-caption",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".figure-caption",
                            "atRules": [],
                            "declarations": [
                                "font-size: 90%",
                                "color: #646776"
                            ]
                        }
                    ]
                },
                {
                    "name": "figure-img",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".figure-img",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 0.5rem",
                                "line-height: 1"
                            ]
                        }
                    ]
                },
                {
                    "name": "img-fluid",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".img-fluid",
                            "atRules": [],
                            "declarations": [
                                "max-width: 100%",
                                "height: auto"
                            ]
                        }
                    ]
                },
                {
                    "name": "img-thumbnail",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".img-thumbnail",
                            "atRules": [],
                            "declarations": [
                                "padding: 0.25rem",
                                "background-color: #fff",
                                "border: 1px solid #cfd1df",
                                "border-radius: 0.75rem",
                                "max-width: 100%",
                                "height: auto"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "interactions",
            "source": "scss/utilities/_interactions.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "user-select-all",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".user-select-all",
                            "atRules": [],
                            "declarations": [
                                "user-select: all !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "user-select-auto",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".user-select-auto",
                            "atRules": [],
                            "declarations": [
                                "user-select: auto !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "user-select-none",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".user-select-none",
                            "atRules": [],
                            "declarations": [
                                "user-select: none !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "margin",
            "source": "scss/utilities/_spacing.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "m-0",
                    "display": "m-*-0",
                    "variants": [
                        "m-sm-0",
                        "m-md-0",
                        "m-lg-0",
                        "m-xl-0",
                        "m-xxl-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-0",
                            "atRules": [],
                            "declarations": [
                                "margin: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-25",
                    "display": "m-*-25",
                    "variants": [
                        "m-sm-25",
                        "m-md-25",
                        "m-lg-25",
                        "m-xl-25",
                        "m-xxl-25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-25",
                            "atRules": [],
                            "declarations": [
                                "margin: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-50",
                    "display": "m-*-50",
                    "variants": [
                        "m-sm-50",
                        "m-md-50",
                        "m-lg-50",
                        "m-xl-50",
                        "m-xxl-50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-50",
                            "atRules": [],
                            "declarations": [
                                "margin: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-100",
                    "display": "m-*-100",
                    "variants": [
                        "m-sm-100",
                        "m-md-100",
                        "m-lg-100",
                        "m-xl-100",
                        "m-xxl-100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-100",
                            "atRules": [],
                            "declarations": [
                                "margin: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-150",
                    "display": "m-*-150",
                    "variants": [
                        "m-sm-150",
                        "m-md-150",
                        "m-lg-150",
                        "m-xl-150",
                        "m-xxl-150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-150",
                            "atRules": [],
                            "declarations": [
                                "margin: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-200",
                    "display": "m-*-200",
                    "variants": [
                        "m-sm-200",
                        "m-md-200",
                        "m-lg-200",
                        "m-xl-200",
                        "m-xxl-200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-200",
                            "atRules": [],
                            "declarations": [
                                "margin: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-300",
                    "display": "m-*-300",
                    "variants": [
                        "m-sm-300",
                        "m-md-300",
                        "m-lg-300",
                        "m-xl-300",
                        "m-xxl-300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-300",
                            "atRules": [],
                            "declarations": [
                                "margin: 3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-400",
                    "display": "m-*-400",
                    "variants": [
                        "m-sm-400",
                        "m-md-400",
                        "m-lg-400",
                        "m-xl-400",
                        "m-xxl-400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-400",
                            "atRules": [],
                            "declarations": [
                                "margin: 4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-500",
                    "display": "m-*-500",
                    "variants": [
                        "m-sm-500",
                        "m-md-500",
                        "m-lg-500",
                        "m-xl-500",
                        "m-xxl-500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-500",
                            "atRules": [],
                            "declarations": [
                                "margin: 5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-600",
                    "display": "m-*-600",
                    "variants": [
                        "m-sm-600",
                        "m-md-600",
                        "m-lg-600",
                        "m-xl-600",
                        "m-xxl-600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-600",
                            "atRules": [],
                            "declarations": [
                                "margin: 6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-800",
                    "display": "m-*-800",
                    "variants": [
                        "m-sm-800",
                        "m-md-800",
                        "m-lg-800",
                        "m-xl-800",
                        "m-xxl-800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-800",
                            "atRules": [],
                            "declarations": [
                                "margin: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-auto",
                    "display": "m-*-auto",
                    "variants": [
                        "m-sm-auto",
                        "m-md-auto",
                        "m-lg-auto",
                        "m-xl-auto",
                        "m-xxl-auto"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-auto",
                            "atRules": [],
                            "declarations": [
                                "margin: auto !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n25",
                    "display": "m-*-n25",
                    "variants": [
                        "m-sm-n25",
                        "m-md-n25",
                        "m-lg-n25",
                        "m-xl-n25",
                        "m-xxl-n25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-n25",
                            "atRules": [],
                            "declarations": [
                                "margin: -0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n50",
                    "display": "m-*-n50",
                    "variants": [
                        "m-sm-n50",
                        "m-md-n50",
                        "m-lg-n50",
                        "m-xl-n50",
                        "m-xxl-n50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-n50",
                            "atRules": [],
                            "declarations": [
                                "margin: -0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n100",
                    "display": "m-*-n100",
                    "variants": [
                        "m-sm-n100",
                        "m-md-n100",
                        "m-lg-n100",
                        "m-xl-n100",
                        "m-xxl-n100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-n100",
                            "atRules": [],
                            "declarations": [
                                "margin: -1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n150",
                    "display": "m-*-n150",
                    "variants": [
                        "m-sm-n150",
                        "m-md-n150",
                        "m-lg-n150",
                        "m-xl-n150",
                        "m-xxl-n150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-n150",
                            "atRules": [],
                            "declarations": [
                                "margin: -1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n200",
                    "display": "m-*-n200",
                    "variants": [
                        "m-sm-n200",
                        "m-md-n200",
                        "m-lg-n200",
                        "m-xl-n200",
                        "m-xxl-n200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-n200",
                            "atRules": [],
                            "declarations": [
                                "margin: -2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n300",
                    "display": "m-*-n300",
                    "variants": [
                        "m-sm-n300",
                        "m-md-n300",
                        "m-lg-n300",
                        "m-xl-n300",
                        "m-xxl-n300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-n300",
                            "atRules": [],
                            "declarations": [
                                "margin: -3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n400",
                    "display": "m-*-n400",
                    "variants": [
                        "m-sm-n400",
                        "m-md-n400",
                        "m-lg-n400",
                        "m-xl-n400",
                        "m-xxl-n400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-n400",
                            "atRules": [],
                            "declarations": [
                                "margin: -4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n500",
                    "display": "m-*-n500",
                    "variants": [
                        "m-sm-n500",
                        "m-md-n500",
                        "m-lg-n500",
                        "m-xl-n500",
                        "m-xxl-n500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-n500",
                            "atRules": [],
                            "declarations": [
                                "margin: -5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n600",
                    "display": "m-*-n600",
                    "variants": [
                        "m-sm-n600",
                        "m-md-n600",
                        "m-lg-n600",
                        "m-xl-n600",
                        "m-xxl-n600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-n600",
                            "atRules": [],
                            "declarations": [
                                "margin: -6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n800",
                    "display": "m-*-n800",
                    "variants": [
                        "m-sm-n800",
                        "m-md-n800",
                        "m-lg-n800",
                        "m-xl-n800",
                        "m-xxl-n800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".m-n800",
                            "atRules": [],
                            "declarations": [
                                "margin: -8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-0",
                    "display": "mb-*-0",
                    "variants": [
                        "mb-sm-0",
                        "mb-md-0",
                        "mb-lg-0",
                        "mb-xl-0",
                        "mb-xxl-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-0",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-25",
                    "display": "mb-*-25",
                    "variants": [
                        "mb-sm-25",
                        "mb-md-25",
                        "mb-lg-25",
                        "mb-xl-25",
                        "mb-xxl-25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-25",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-50",
                    "display": "mb-*-50",
                    "variants": [
                        "mb-sm-50",
                        "mb-md-50",
                        "mb-lg-50",
                        "mb-xl-50",
                        "mb-xxl-50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-50",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-100",
                    "display": "mb-*-100",
                    "variants": [
                        "mb-sm-100",
                        "mb-md-100",
                        "mb-lg-100",
                        "mb-xl-100",
                        "mb-xxl-100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-100",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-150",
                    "display": "mb-*-150",
                    "variants": [
                        "mb-sm-150",
                        "mb-md-150",
                        "mb-lg-150",
                        "mb-xl-150",
                        "mb-xxl-150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-150",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-200",
                    "display": "mb-*-200",
                    "variants": [
                        "mb-sm-200",
                        "mb-md-200",
                        "mb-lg-200",
                        "mb-xl-200",
                        "mb-xxl-200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-200",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-300",
                    "display": "mb-*-300",
                    "variants": [
                        "mb-sm-300",
                        "mb-md-300",
                        "mb-lg-300",
                        "mb-xl-300",
                        "mb-xxl-300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-300",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-400",
                    "display": "mb-*-400",
                    "variants": [
                        "mb-sm-400",
                        "mb-md-400",
                        "mb-lg-400",
                        "mb-xl-400",
                        "mb-xxl-400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-400",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-500",
                    "display": "mb-*-500",
                    "variants": [
                        "mb-sm-500",
                        "mb-md-500",
                        "mb-lg-500",
                        "mb-xl-500",
                        "mb-xxl-500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-500",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-600",
                    "display": "mb-*-600",
                    "variants": [
                        "mb-sm-600",
                        "mb-md-600",
                        "mb-lg-600",
                        "mb-xl-600",
                        "mb-xxl-600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-600",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-800",
                    "display": "mb-*-800",
                    "variants": [
                        "mb-sm-800",
                        "mb-md-800",
                        "mb-lg-800",
                        "mb-xl-800",
                        "mb-xxl-800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-800",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-auto",
                    "display": "mb-*-auto",
                    "variants": [
                        "mb-sm-auto",
                        "mb-md-auto",
                        "mb-lg-auto",
                        "mb-xl-auto",
                        "mb-xxl-auto"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-auto",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: auto !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n25",
                    "display": "mb-*-n25",
                    "variants": [
                        "mb-sm-n25",
                        "mb-md-n25",
                        "mb-lg-n25",
                        "mb-xl-n25",
                        "mb-xxl-n25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-n25",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n50",
                    "display": "mb-*-n50",
                    "variants": [
                        "mb-sm-n50",
                        "mb-md-n50",
                        "mb-lg-n50",
                        "mb-xl-n50",
                        "mb-xxl-n50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-n50",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n100",
                    "display": "mb-*-n100",
                    "variants": [
                        "mb-sm-n100",
                        "mb-md-n100",
                        "mb-lg-n100",
                        "mb-xl-n100",
                        "mb-xxl-n100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-n100",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n150",
                    "display": "mb-*-n150",
                    "variants": [
                        "mb-sm-n150",
                        "mb-md-n150",
                        "mb-lg-n150",
                        "mb-xl-n150",
                        "mb-xxl-n150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-n150",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n200",
                    "display": "mb-*-n200",
                    "variants": [
                        "mb-sm-n200",
                        "mb-md-n200",
                        "mb-lg-n200",
                        "mb-xl-n200",
                        "mb-xxl-n200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-n200",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n300",
                    "display": "mb-*-n300",
                    "variants": [
                        "mb-sm-n300",
                        "mb-md-n300",
                        "mb-lg-n300",
                        "mb-xl-n300",
                        "mb-xxl-n300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-n300",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n400",
                    "display": "mb-*-n400",
                    "variants": [
                        "mb-sm-n400",
                        "mb-md-n400",
                        "mb-lg-n400",
                        "mb-xl-n400",
                        "mb-xxl-n400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-n400",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n500",
                    "display": "mb-*-n500",
                    "variants": [
                        "mb-sm-n500",
                        "mb-md-n500",
                        "mb-lg-n500",
                        "mb-xl-n500",
                        "mb-xxl-n500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-n500",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n600",
                    "display": "mb-*-n600",
                    "variants": [
                        "mb-sm-n600",
                        "mb-md-n600",
                        "mb-lg-n600",
                        "mb-xl-n600",
                        "mb-xxl-n600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-n600",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n800",
                    "display": "mb-*-n800",
                    "variants": [
                        "mb-sm-n800",
                        "mb-md-n800",
                        "mb-lg-n800",
                        "mb-xl-n800",
                        "mb-xxl-n800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mb-n800",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-0",
                    "display": "ml-*-0",
                    "variants": [
                        "ml-sm-0",
                        "ml-md-0",
                        "ml-lg-0",
                        "ml-xl-0",
                        "ml-xxl-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-0",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-25",
                    "display": "ml-*-25",
                    "variants": [
                        "ml-sm-25",
                        "ml-md-25",
                        "ml-lg-25",
                        "ml-xl-25",
                        "ml-xxl-25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-25",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-50",
                    "display": "ml-*-50",
                    "variants": [
                        "ml-sm-50",
                        "ml-md-50",
                        "ml-lg-50",
                        "ml-xl-50",
                        "ml-xxl-50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-50",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-100",
                    "display": "ml-*-100",
                    "variants": [
                        "ml-sm-100",
                        "ml-md-100",
                        "ml-lg-100",
                        "ml-xl-100",
                        "ml-xxl-100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-100",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-150",
                    "display": "ml-*-150",
                    "variants": [
                        "ml-sm-150",
                        "ml-md-150",
                        "ml-lg-150",
                        "ml-xl-150",
                        "ml-xxl-150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-150",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-200",
                    "display": "ml-*-200",
                    "variants": [
                        "ml-sm-200",
                        "ml-md-200",
                        "ml-lg-200",
                        "ml-xl-200",
                        "ml-xxl-200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-200",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-300",
                    "display": "ml-*-300",
                    "variants": [
                        "ml-sm-300",
                        "ml-md-300",
                        "ml-lg-300",
                        "ml-xl-300",
                        "ml-xxl-300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-300",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-400",
                    "display": "ml-*-400",
                    "variants": [
                        "ml-sm-400",
                        "ml-md-400",
                        "ml-lg-400",
                        "ml-xl-400",
                        "ml-xxl-400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-400",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-500",
                    "display": "ml-*-500",
                    "variants": [
                        "ml-sm-500",
                        "ml-md-500",
                        "ml-lg-500",
                        "ml-xl-500",
                        "ml-xxl-500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-500",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-600",
                    "display": "ml-*-600",
                    "variants": [
                        "ml-sm-600",
                        "ml-md-600",
                        "ml-lg-600",
                        "ml-xl-600",
                        "ml-xxl-600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-600",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-800",
                    "display": "ml-*-800",
                    "variants": [
                        "ml-sm-800",
                        "ml-md-800",
                        "ml-lg-800",
                        "ml-xl-800",
                        "ml-xxl-800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-800",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-auto",
                    "display": "ml-*-auto",
                    "variants": [
                        "ml-sm-auto",
                        "ml-md-auto",
                        "ml-lg-auto",
                        "ml-xl-auto",
                        "ml-xxl-auto"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-auto",
                            "atRules": [],
                            "declarations": [
                                "margin-left: auto !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n25",
                    "display": "ml-*-n25",
                    "variants": [
                        "ml-sm-n25",
                        "ml-md-n25",
                        "ml-lg-n25",
                        "ml-xl-n25",
                        "ml-xxl-n25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-n25",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n50",
                    "display": "ml-*-n50",
                    "variants": [
                        "ml-sm-n50",
                        "ml-md-n50",
                        "ml-lg-n50",
                        "ml-xl-n50",
                        "ml-xxl-n50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-n50",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n100",
                    "display": "ml-*-n100",
                    "variants": [
                        "ml-sm-n100",
                        "ml-md-n100",
                        "ml-lg-n100",
                        "ml-xl-n100",
                        "ml-xxl-n100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-n100",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n150",
                    "display": "ml-*-n150",
                    "variants": [
                        "ml-sm-n150",
                        "ml-md-n150",
                        "ml-lg-n150",
                        "ml-xl-n150",
                        "ml-xxl-n150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-n150",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n200",
                    "display": "ml-*-n200",
                    "variants": [
                        "ml-sm-n200",
                        "ml-md-n200",
                        "ml-lg-n200",
                        "ml-xl-n200",
                        "ml-xxl-n200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-n200",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n300",
                    "display": "ml-*-n300",
                    "variants": [
                        "ml-sm-n300",
                        "ml-md-n300",
                        "ml-lg-n300",
                        "ml-xl-n300",
                        "ml-xxl-n300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-n300",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n400",
                    "display": "ml-*-n400",
                    "variants": [
                        "ml-sm-n400",
                        "ml-md-n400",
                        "ml-lg-n400",
                        "ml-xl-n400",
                        "ml-xxl-n400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-n400",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n500",
                    "display": "ml-*-n500",
                    "variants": [
                        "ml-sm-n500",
                        "ml-md-n500",
                        "ml-lg-n500",
                        "ml-xl-n500",
                        "ml-xxl-n500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-n500",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n600",
                    "display": "ml-*-n600",
                    "variants": [
                        "ml-sm-n600",
                        "ml-md-n600",
                        "ml-lg-n600",
                        "ml-xl-n600",
                        "ml-xxl-n600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-n600",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n800",
                    "display": "ml-*-n800",
                    "variants": [
                        "ml-sm-n800",
                        "ml-md-n800",
                        "ml-lg-n800",
                        "ml-xl-n800",
                        "ml-xxl-n800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".ml-n800",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-0",
                    "display": "mr-*-0",
                    "variants": [
                        "mr-sm-0",
                        "mr-md-0",
                        "mr-lg-0",
                        "mr-xl-0",
                        "mr-xxl-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-0",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-25",
                    "display": "mr-*-25",
                    "variants": [
                        "mr-sm-25",
                        "mr-md-25",
                        "mr-lg-25",
                        "mr-xl-25",
                        "mr-xxl-25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-25",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-50",
                    "display": "mr-*-50",
                    "variants": [
                        "mr-sm-50",
                        "mr-md-50",
                        "mr-lg-50",
                        "mr-xl-50",
                        "mr-xxl-50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-50",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-100",
                    "display": "mr-*-100",
                    "variants": [
                        "mr-sm-100",
                        "mr-md-100",
                        "mr-lg-100",
                        "mr-xl-100",
                        "mr-xxl-100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-100",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-150",
                    "display": "mr-*-150",
                    "variants": [
                        "mr-sm-150",
                        "mr-md-150",
                        "mr-lg-150",
                        "mr-xl-150",
                        "mr-xxl-150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-150",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-200",
                    "display": "mr-*-200",
                    "variants": [
                        "mr-sm-200",
                        "mr-md-200",
                        "mr-lg-200",
                        "mr-xl-200",
                        "mr-xxl-200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-200",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-300",
                    "display": "mr-*-300",
                    "variants": [
                        "mr-sm-300",
                        "mr-md-300",
                        "mr-lg-300",
                        "mr-xl-300",
                        "mr-xxl-300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-300",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-400",
                    "display": "mr-*-400",
                    "variants": [
                        "mr-sm-400",
                        "mr-md-400",
                        "mr-lg-400",
                        "mr-xl-400",
                        "mr-xxl-400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-400",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-500",
                    "display": "mr-*-500",
                    "variants": [
                        "mr-sm-500",
                        "mr-md-500",
                        "mr-lg-500",
                        "mr-xl-500",
                        "mr-xxl-500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-500",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-600",
                    "display": "mr-*-600",
                    "variants": [
                        "mr-sm-600",
                        "mr-md-600",
                        "mr-lg-600",
                        "mr-xl-600",
                        "mr-xxl-600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-600",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-800",
                    "display": "mr-*-800",
                    "variants": [
                        "mr-sm-800",
                        "mr-md-800",
                        "mr-lg-800",
                        "mr-xl-800",
                        "mr-xxl-800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-800",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-auto",
                    "display": "mr-*-auto",
                    "variants": [
                        "mr-sm-auto",
                        "mr-md-auto",
                        "mr-lg-auto",
                        "mr-xl-auto",
                        "mr-xxl-auto"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-auto",
                            "atRules": [],
                            "declarations": [
                                "margin-right: auto !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n25",
                    "display": "mr-*-n25",
                    "variants": [
                        "mr-sm-n25",
                        "mr-md-n25",
                        "mr-lg-n25",
                        "mr-xl-n25",
                        "mr-xxl-n25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-n25",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n50",
                    "display": "mr-*-n50",
                    "variants": [
                        "mr-sm-n50",
                        "mr-md-n50",
                        "mr-lg-n50",
                        "mr-xl-n50",
                        "mr-xxl-n50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-n50",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n100",
                    "display": "mr-*-n100",
                    "variants": [
                        "mr-sm-n100",
                        "mr-md-n100",
                        "mr-lg-n100",
                        "mr-xl-n100",
                        "mr-xxl-n100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-n100",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n150",
                    "display": "mr-*-n150",
                    "variants": [
                        "mr-sm-n150",
                        "mr-md-n150",
                        "mr-lg-n150",
                        "mr-xl-n150",
                        "mr-xxl-n150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-n150",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n200",
                    "display": "mr-*-n200",
                    "variants": [
                        "mr-sm-n200",
                        "mr-md-n200",
                        "mr-lg-n200",
                        "mr-xl-n200",
                        "mr-xxl-n200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-n200",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n300",
                    "display": "mr-*-n300",
                    "variants": [
                        "mr-sm-n300",
                        "mr-md-n300",
                        "mr-lg-n300",
                        "mr-xl-n300",
                        "mr-xxl-n300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-n300",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n400",
                    "display": "mr-*-n400",
                    "variants": [
                        "mr-sm-n400",
                        "mr-md-n400",
                        "mr-lg-n400",
                        "mr-xl-n400",
                        "mr-xxl-n400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-n400",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n500",
                    "display": "mr-*-n500",
                    "variants": [
                        "mr-sm-n500",
                        "mr-md-n500",
                        "mr-lg-n500",
                        "mr-xl-n500",
                        "mr-xxl-n500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-n500",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n600",
                    "display": "mr-*-n600",
                    "variants": [
                        "mr-sm-n600",
                        "mr-md-n600",
                        "mr-lg-n600",
                        "mr-xl-n600",
                        "mr-xxl-n600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-n600",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n800",
                    "display": "mr-*-n800",
                    "variants": [
                        "mr-sm-n800",
                        "mr-md-n800",
                        "mr-lg-n800",
                        "mr-xl-n800",
                        "mr-xxl-n800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mr-n800",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-0",
                    "display": "mt-*-0",
                    "variants": [
                        "mt-sm-0",
                        "mt-md-0",
                        "mt-lg-0",
                        "mt-xl-0",
                        "mt-xxl-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-0",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-25",
                    "display": "mt-*-25",
                    "variants": [
                        "mt-sm-25",
                        "mt-md-25",
                        "mt-lg-25",
                        "mt-xl-25",
                        "mt-xxl-25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-25",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-50",
                    "display": "mt-*-50",
                    "variants": [
                        "mt-sm-50",
                        "mt-md-50",
                        "mt-lg-50",
                        "mt-xl-50",
                        "mt-xxl-50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-50",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-100",
                    "display": "mt-*-100",
                    "variants": [
                        "mt-sm-100",
                        "mt-md-100",
                        "mt-lg-100",
                        "mt-xl-100",
                        "mt-xxl-100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-100",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-150",
                    "display": "mt-*-150",
                    "variants": [
                        "mt-sm-150",
                        "mt-md-150",
                        "mt-lg-150",
                        "mt-xl-150",
                        "mt-xxl-150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-150",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-200",
                    "display": "mt-*-200",
                    "variants": [
                        "mt-sm-200",
                        "mt-md-200",
                        "mt-lg-200",
                        "mt-xl-200",
                        "mt-xxl-200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-200",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-300",
                    "display": "mt-*-300",
                    "variants": [
                        "mt-sm-300",
                        "mt-md-300",
                        "mt-lg-300",
                        "mt-xl-300",
                        "mt-xxl-300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-300",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-400",
                    "display": "mt-*-400",
                    "variants": [
                        "mt-sm-400",
                        "mt-md-400",
                        "mt-lg-400",
                        "mt-xl-400",
                        "mt-xxl-400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-400",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-500",
                    "display": "mt-*-500",
                    "variants": [
                        "mt-sm-500",
                        "mt-md-500",
                        "mt-lg-500",
                        "mt-xl-500",
                        "mt-xxl-500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-500",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-600",
                    "display": "mt-*-600",
                    "variants": [
                        "mt-sm-600",
                        "mt-md-600",
                        "mt-lg-600",
                        "mt-xl-600",
                        "mt-xxl-600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-600",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-800",
                    "display": "mt-*-800",
                    "variants": [
                        "mt-sm-800",
                        "mt-md-800",
                        "mt-lg-800",
                        "mt-xl-800",
                        "mt-xxl-800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-800",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-auto",
                    "display": "mt-*-auto",
                    "variants": [
                        "mt-sm-auto",
                        "mt-md-auto",
                        "mt-lg-auto",
                        "mt-xl-auto",
                        "mt-xxl-auto"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-auto",
                            "atRules": [],
                            "declarations": [
                                "margin-top: auto !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n25",
                    "display": "mt-*-n25",
                    "variants": [
                        "mt-sm-n25",
                        "mt-md-n25",
                        "mt-lg-n25",
                        "mt-xl-n25",
                        "mt-xxl-n25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-n25",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n50",
                    "display": "mt-*-n50",
                    "variants": [
                        "mt-sm-n50",
                        "mt-md-n50",
                        "mt-lg-n50",
                        "mt-xl-n50",
                        "mt-xxl-n50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-n50",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n100",
                    "display": "mt-*-n100",
                    "variants": [
                        "mt-sm-n100",
                        "mt-md-n100",
                        "mt-lg-n100",
                        "mt-xl-n100",
                        "mt-xxl-n100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-n100",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n150",
                    "display": "mt-*-n150",
                    "variants": [
                        "mt-sm-n150",
                        "mt-md-n150",
                        "mt-lg-n150",
                        "mt-xl-n150",
                        "mt-xxl-n150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-n150",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n200",
                    "display": "mt-*-n200",
                    "variants": [
                        "mt-sm-n200",
                        "mt-md-n200",
                        "mt-lg-n200",
                        "mt-xl-n200",
                        "mt-xxl-n200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-n200",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n300",
                    "display": "mt-*-n300",
                    "variants": [
                        "mt-sm-n300",
                        "mt-md-n300",
                        "mt-lg-n300",
                        "mt-xl-n300",
                        "mt-xxl-n300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-n300",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n400",
                    "display": "mt-*-n400",
                    "variants": [
                        "mt-sm-n400",
                        "mt-md-n400",
                        "mt-lg-n400",
                        "mt-xl-n400",
                        "mt-xxl-n400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-n400",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n500",
                    "display": "mt-*-n500",
                    "variants": [
                        "mt-sm-n500",
                        "mt-md-n500",
                        "mt-lg-n500",
                        "mt-xl-n500",
                        "mt-xxl-n500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-n500",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n600",
                    "display": "mt-*-n600",
                    "variants": [
                        "mt-sm-n600",
                        "mt-md-n600",
                        "mt-lg-n600",
                        "mt-xl-n600",
                        "mt-xxl-n600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-n600",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n800",
                    "display": "mt-*-n800",
                    "variants": [
                        "mt-sm-n800",
                        "mt-md-n800",
                        "mt-lg-n800",
                        "mt-xl-n800",
                        "mt-xxl-n800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mt-n800",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-0",
                    "display": "mx-*-0",
                    "variants": [
                        "mx-sm-0",
                        "mx-md-0",
                        "mx-lg-0",
                        "mx-xl-0",
                        "mx-xxl-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-0",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 0 !important"
                            ]
                        },
                        {
                            "selector": ".mx-0",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-25",
                    "display": "mx-*-25",
                    "variants": [
                        "mx-sm-25",
                        "mx-md-25",
                        "mx-lg-25",
                        "mx-xl-25",
                        "mx-xxl-25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-25",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 0.25rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-25",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-50",
                    "display": "mx-*-50",
                    "variants": [
                        "mx-sm-50",
                        "mx-md-50",
                        "mx-lg-50",
                        "mx-xl-50",
                        "mx-xxl-50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-50",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 0.5rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-50",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-100",
                    "display": "mx-*-100",
                    "variants": [
                        "mx-sm-100",
                        "mx-md-100",
                        "mx-lg-100",
                        "mx-xl-100",
                        "mx-xxl-100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-100",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 1rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-100",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-150",
                    "display": "mx-*-150",
                    "variants": [
                        "mx-sm-150",
                        "mx-md-150",
                        "mx-lg-150",
                        "mx-xl-150",
                        "mx-xxl-150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-150",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 1.5rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-150",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-200",
                    "display": "mx-*-200",
                    "variants": [
                        "mx-sm-200",
                        "mx-md-200",
                        "mx-lg-200",
                        "mx-xl-200",
                        "mx-xxl-200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-200",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 2rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-200",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-300",
                    "display": "mx-*-300",
                    "variants": [
                        "mx-sm-300",
                        "mx-md-300",
                        "mx-lg-300",
                        "mx-xl-300",
                        "mx-xxl-300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-300",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 3rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-300",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-400",
                    "display": "mx-*-400",
                    "variants": [
                        "mx-sm-400",
                        "mx-md-400",
                        "mx-lg-400",
                        "mx-xl-400",
                        "mx-xxl-400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-400",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 4rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-400",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-500",
                    "display": "mx-*-500",
                    "variants": [
                        "mx-sm-500",
                        "mx-md-500",
                        "mx-lg-500",
                        "mx-xl-500",
                        "mx-xxl-500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-500",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 5rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-500",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-600",
                    "display": "mx-*-600",
                    "variants": [
                        "mx-sm-600",
                        "mx-md-600",
                        "mx-lg-600",
                        "mx-xl-600",
                        "mx-xxl-600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-600",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 6rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-600",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-800",
                    "display": "mx-*-800",
                    "variants": [
                        "mx-sm-800",
                        "mx-md-800",
                        "mx-lg-800",
                        "mx-xl-800",
                        "mx-xxl-800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-800",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 8rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-800",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-auto",
                    "display": "mx-*-auto",
                    "variants": [
                        "mx-sm-auto",
                        "mx-md-auto",
                        "mx-lg-auto",
                        "mx-xl-auto",
                        "mx-xxl-auto"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-auto",
                            "atRules": [],
                            "declarations": [
                                "margin-right: auto !important"
                            ]
                        },
                        {
                            "selector": ".mx-auto",
                            "atRules": [],
                            "declarations": [
                                "margin-left: auto !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n25",
                    "display": "mx-*-n25",
                    "variants": [
                        "mx-sm-n25",
                        "mx-md-n25",
                        "mx-lg-n25",
                        "mx-xl-n25",
                        "mx-xxl-n25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-n25",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -0.25rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n25",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n50",
                    "display": "mx-*-n50",
                    "variants": [
                        "mx-sm-n50",
                        "mx-md-n50",
                        "mx-lg-n50",
                        "mx-xl-n50",
                        "mx-xxl-n50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-n50",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -0.5rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n50",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n100",
                    "display": "mx-*-n100",
                    "variants": [
                        "mx-sm-n100",
                        "mx-md-n100",
                        "mx-lg-n100",
                        "mx-xl-n100",
                        "mx-xxl-n100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-n100",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -1rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n100",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n150",
                    "display": "mx-*-n150",
                    "variants": [
                        "mx-sm-n150",
                        "mx-md-n150",
                        "mx-lg-n150",
                        "mx-xl-n150",
                        "mx-xxl-n150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-n150",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -1.5rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n150",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n200",
                    "display": "mx-*-n200",
                    "variants": [
                        "mx-sm-n200",
                        "mx-md-n200",
                        "mx-lg-n200",
                        "mx-xl-n200",
                        "mx-xxl-n200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-n200",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -2rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n200",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n300",
                    "display": "mx-*-n300",
                    "variants": [
                        "mx-sm-n300",
                        "mx-md-n300",
                        "mx-lg-n300",
                        "mx-xl-n300",
                        "mx-xxl-n300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-n300",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -3rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n300",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n400",
                    "display": "mx-*-n400",
                    "variants": [
                        "mx-sm-n400",
                        "mx-md-n400",
                        "mx-lg-n400",
                        "mx-xl-n400",
                        "mx-xxl-n400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-n400",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -4rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n400",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n500",
                    "display": "mx-*-n500",
                    "variants": [
                        "mx-sm-n500",
                        "mx-md-n500",
                        "mx-lg-n500",
                        "mx-xl-n500",
                        "mx-xxl-n500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-n500",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -5rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n500",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n600",
                    "display": "mx-*-n600",
                    "variants": [
                        "mx-sm-n600",
                        "mx-md-n600",
                        "mx-lg-n600",
                        "mx-xl-n600",
                        "mx-xxl-n600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-n600",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -6rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n600",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n800",
                    "display": "mx-*-n800",
                    "variants": [
                        "mx-sm-n800",
                        "mx-md-n800",
                        "mx-lg-n800",
                        "mx-xl-n800",
                        "mx-xxl-n800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mx-n800",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -8rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n800",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-0",
                    "display": "my-*-0",
                    "variants": [
                        "my-sm-0",
                        "my-md-0",
                        "my-lg-0",
                        "my-xl-0",
                        "my-xxl-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-0",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 0 !important"
                            ]
                        },
                        {
                            "selector": ".my-0",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-25",
                    "display": "my-*-25",
                    "variants": [
                        "my-sm-25",
                        "my-md-25",
                        "my-lg-25",
                        "my-xl-25",
                        "my-xxl-25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-25",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 0.25rem !important"
                            ]
                        },
                        {
                            "selector": ".my-25",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-50",
                    "display": "my-*-50",
                    "variants": [
                        "my-sm-50",
                        "my-md-50",
                        "my-lg-50",
                        "my-xl-50",
                        "my-xxl-50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-50",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 0.5rem !important"
                            ]
                        },
                        {
                            "selector": ".my-50",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-100",
                    "display": "my-*-100",
                    "variants": [
                        "my-sm-100",
                        "my-md-100",
                        "my-lg-100",
                        "my-xl-100",
                        "my-xxl-100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-100",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 1rem !important"
                            ]
                        },
                        {
                            "selector": ".my-100",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-150",
                    "display": "my-*-150",
                    "variants": [
                        "my-sm-150",
                        "my-md-150",
                        "my-lg-150",
                        "my-xl-150",
                        "my-xxl-150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-150",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 1.5rem !important"
                            ]
                        },
                        {
                            "selector": ".my-150",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-200",
                    "display": "my-*-200",
                    "variants": [
                        "my-sm-200",
                        "my-md-200",
                        "my-lg-200",
                        "my-xl-200",
                        "my-xxl-200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-200",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 2rem !important"
                            ]
                        },
                        {
                            "selector": ".my-200",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-300",
                    "display": "my-*-300",
                    "variants": [
                        "my-sm-300",
                        "my-md-300",
                        "my-lg-300",
                        "my-xl-300",
                        "my-xxl-300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-300",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 3rem !important"
                            ]
                        },
                        {
                            "selector": ".my-300",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-400",
                    "display": "my-*-400",
                    "variants": [
                        "my-sm-400",
                        "my-md-400",
                        "my-lg-400",
                        "my-xl-400",
                        "my-xxl-400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-400",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 4rem !important"
                            ]
                        },
                        {
                            "selector": ".my-400",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-500",
                    "display": "my-*-500",
                    "variants": [
                        "my-sm-500",
                        "my-md-500",
                        "my-lg-500",
                        "my-xl-500",
                        "my-xxl-500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-500",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 5rem !important"
                            ]
                        },
                        {
                            "selector": ".my-500",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-600",
                    "display": "my-*-600",
                    "variants": [
                        "my-sm-600",
                        "my-md-600",
                        "my-lg-600",
                        "my-xl-600",
                        "my-xxl-600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-600",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 6rem !important"
                            ]
                        },
                        {
                            "selector": ".my-600",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-800",
                    "display": "my-*-800",
                    "variants": [
                        "my-sm-800",
                        "my-md-800",
                        "my-lg-800",
                        "my-xl-800",
                        "my-xxl-800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-800",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 8rem !important"
                            ]
                        },
                        {
                            "selector": ".my-800",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-auto",
                    "display": "my-*-auto",
                    "variants": [
                        "my-sm-auto",
                        "my-md-auto",
                        "my-lg-auto",
                        "my-xl-auto",
                        "my-xxl-auto"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-auto",
                            "atRules": [],
                            "declarations": [
                                "margin-top: auto !important"
                            ]
                        },
                        {
                            "selector": ".my-auto",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: auto !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n25",
                    "display": "my-*-n25",
                    "variants": [
                        "my-sm-n25",
                        "my-md-n25",
                        "my-lg-n25",
                        "my-xl-n25",
                        "my-xxl-n25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-n25",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -0.25rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n25",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n50",
                    "display": "my-*-n50",
                    "variants": [
                        "my-sm-n50",
                        "my-md-n50",
                        "my-lg-n50",
                        "my-xl-n50",
                        "my-xxl-n50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-n50",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -0.5rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n50",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n100",
                    "display": "my-*-n100",
                    "variants": [
                        "my-sm-n100",
                        "my-md-n100",
                        "my-lg-n100",
                        "my-xl-n100",
                        "my-xxl-n100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-n100",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -1rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n100",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n150",
                    "display": "my-*-n150",
                    "variants": [
                        "my-sm-n150",
                        "my-md-n150",
                        "my-lg-n150",
                        "my-xl-n150",
                        "my-xxl-n150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-n150",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -1.5rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n150",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n200",
                    "display": "my-*-n200",
                    "variants": [
                        "my-sm-n200",
                        "my-md-n200",
                        "my-lg-n200",
                        "my-xl-n200",
                        "my-xxl-n200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-n200",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -2rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n200",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n300",
                    "display": "my-*-n300",
                    "variants": [
                        "my-sm-n300",
                        "my-md-n300",
                        "my-lg-n300",
                        "my-xl-n300",
                        "my-xxl-n300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-n300",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -3rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n300",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n400",
                    "display": "my-*-n400",
                    "variants": [
                        "my-sm-n400",
                        "my-md-n400",
                        "my-lg-n400",
                        "my-xl-n400",
                        "my-xxl-n400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-n400",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -4rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n400",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n500",
                    "display": "my-*-n500",
                    "variants": [
                        "my-sm-n500",
                        "my-md-n500",
                        "my-lg-n500",
                        "my-xl-n500",
                        "my-xxl-n500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-n500",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -5rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n500",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n600",
                    "display": "my-*-n600",
                    "variants": [
                        "my-sm-n600",
                        "my-md-n600",
                        "my-lg-n600",
                        "my-xl-n600",
                        "my-xxl-n600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-n600",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -6rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n600",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n800",
                    "display": "my-*-n800",
                    "variants": [
                        "my-sm-n800",
                        "my-md-n800",
                        "my-lg-n800",
                        "my-xl-n800",
                        "my-xxl-n800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".my-n800",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -8rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n800",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -8rem !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "order",
            "source": "scss/_grid.scss",
            "allClassesUseImportant": false,
            "classes": [
                {
                    "name": "order-0",
                    "display": "order-*-0",
                    "variants": [
                        "order-sm-0",
                        "order-md-0",
                        "order-lg-0",
                        "order-xl-0",
                        "order-xxl-0"
                    ],
                    "important": false,
                    "rules": [
                        {
                            "selector": ".order-0",
                            "atRules": [],
                            "declarations": [
                                "order: 0"
                            ]
                        }
                    ]
                },
                {
                    "name": "order-1",
                    "display": "order-*-1",
                    "variants": [
                        "order-sm-1",
                        "order-md-1",
                        "order-lg-1",
                        "order-xl-1",
                        "order-xxl-1"
                    ],
                    "important": false,
                    "rules": [
                        {
                            "selector": ".order-1",
                            "atRules": [],
                            "declarations": [
                                "order: 1"
                            ]
                        }
                    ]
                },
                {
                    "name": "order-2",
                    "display": "order-*-2",
                    "variants": [
                        "order-sm-2",
                        "order-md-2",
                        "order-lg-2",
                        "order-xl-2",
                        "order-xxl-2"
                    ],
                    "important": false,
                    "rules": [
                        {
                            "selector": ".order-2",
                            "atRules": [],
                            "declarations": [
                                "order: 2"
                            ]
                        }
                    ]
                },
                {
                    "name": "order-3",
                    "display": "order-*-3",
                    "variants": [
                        "order-sm-3",
                        "order-md-3",
                        "order-lg-3",
                        "order-xl-3",
                        "order-xxl-3"
                    ],
                    "important": false,
                    "rules": [
                        {
                            "selector": ".order-3",
                            "atRules": [],
                            "declarations": [
                                "order: 3"
                            ]
                        }
                    ]
                },
                {
                    "name": "order-4",
                    "display": "order-*-4",
                    "variants": [
                        "order-sm-4",
                        "order-md-4",
                        "order-lg-4",
                        "order-xl-4",
                        "order-xxl-4"
                    ],
                    "important": false,
                    "rules": [
                        {
                            "selector": ".order-4",
                            "atRules": [],
                            "declarations": [
                                "order: 4"
                            ]
                        }
                    ]
                },
                {
                    "name": "order-5",
                    "display": "order-*-5",
                    "variants": [
                        "order-sm-5",
                        "order-md-5",
                        "order-lg-5",
                        "order-xl-5",
                        "order-xxl-5"
                    ],
                    "important": false,
                    "rules": [
                        {
                            "selector": ".order-5",
                            "atRules": [],
                            "declarations": [
                                "order: 5"
                            ]
                        }
                    ]
                },
                {
                    "name": "order-6",
                    "display": "order-*-6",
                    "variants": [
                        "order-sm-6",
                        "order-md-6",
                        "order-lg-6",
                        "order-xl-6",
                        "order-xxl-6"
                    ],
                    "important": false,
                    "rules": [
                        {
                            "selector": ".order-6",
                            "atRules": [],
                            "declarations": [
                                "order: 6"
                            ]
                        }
                    ]
                },
                {
                    "name": "order-7",
                    "display": "order-*-7",
                    "variants": [
                        "order-sm-7",
                        "order-md-7",
                        "order-lg-7",
                        "order-xl-7",
                        "order-xxl-7"
                    ],
                    "important": false,
                    "rules": [
                        {
                            "selector": ".order-7",
                            "atRules": [],
                            "declarations": [
                                "order: 7"
                            ]
                        }
                    ]
                },
                {
                    "name": "order-8",
                    "display": "order-*-8",
                    "variants": [
                        "order-sm-8",
                        "order-md-8",
                        "order-lg-8",
                        "order-xl-8",
                        "order-xxl-8"
                    ],
                    "important": false,
                    "rules": [
                        {
                            "selector": ".order-8",
                            "atRules": [],
                            "declarations": [
                                "order: 8"
                            ]
                        }
                    ]
                },
                {
                    "name": "order-9",
                    "display": "order-*-9",
                    "variants": [
                        "order-sm-9",
                        "order-md-9",
                        "order-lg-9",
                        "order-xl-9",
                        "order-xxl-9"
                    ],
                    "important": false,
                    "rules": [
                        {
                            "selector": ".order-9",
                            "atRules": [],
                            "declarations": [
                                "order: 9"
                            ]
                        }
                    ]
                },
                {
                    "name": "order-10",
                    "display": "order-*-10",
                    "variants": [
                        "order-sm-10",
                        "order-md-10",
                        "order-lg-10",
                        "order-xl-10",
                        "order-xxl-10"
                    ],
                    "important": false,
                    "rules": [
                        {
                            "selector": ".order-10",
                            "atRules": [],
                            "declarations": [
                                "order: 10"
                            ]
                        }
                    ]
                },
                {
                    "name": "order-11",
                    "display": "order-*-11",
                    "variants": [
                        "order-sm-11",
                        "order-md-11",
                        "order-lg-11",
                        "order-xl-11",
                        "order-xxl-11"
                    ],
                    "important": false,
                    "rules": [
                        {
                            "selector": ".order-11",
                            "atRules": [],
                            "declarations": [
                                "order: 11"
                            ]
                        }
                    ]
                },
                {
                    "name": "order-12",
                    "display": "order-*-12",
                    "variants": [
                        "order-sm-12",
                        "order-md-12",
                        "order-lg-12",
                        "order-xl-12",
                        "order-xxl-12"
                    ],
                    "important": false,
                    "rules": [
                        {
                            "selector": ".order-12",
                            "atRules": [],
                            "declarations": [
                                "order: 12"
                            ]
                        }
                    ]
                },
                {
                    "name": "order-first",
                    "display": "order-*-first",
                    "variants": [
                        "order-sm-first",
                        "order-md-first",
                        "order-lg-first",
                        "order-xl-first",
                        "order-xxl-first"
                    ],
                    "important": false,
                    "rules": [
                        {
                            "selector": ".order-first",
                            "atRules": [],
                            "declarations": [
                                "order: -1"
                            ]
                        }
                    ]
                },
                {
                    "name": "order-last",
                    "display": "order-*-last",
                    "variants": [
                        "order-sm-last",
                        "order-md-last",
                        "order-lg-last",
                        "order-xl-last",
                        "order-xxl-last"
                    ],
                    "important": false,
                    "rules": [
                        {
                            "selector": ".order-last",
                            "atRules": [],
                            "declarations": [
                                "order: 13"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "overflow",
            "source": "scss/utilities/_overflow.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "overflow-auto",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".overflow-auto",
                            "atRules": [],
                            "declarations": [
                                "overflow: auto !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "overflow-hidden",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".overflow-hidden",
                            "atRules": [],
                            "declarations": [
                                "overflow: hidden !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "overflow-visible",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".overflow-visible",
                            "atRules": [],
                            "declarations": [
                                "overflow: visible !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "padding",
            "source": "scss/utilities/_spacing.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "p-0",
                    "display": "p-*-0",
                    "variants": [
                        "p-sm-0",
                        "p-md-0",
                        "p-lg-0",
                        "p-xl-0",
                        "p-xxl-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".p-0",
                            "atRules": [],
                            "declarations": [
                                "padding: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-25",
                    "display": "p-*-25",
                    "variants": [
                        "p-sm-25",
                        "p-md-25",
                        "p-lg-25",
                        "p-xl-25",
                        "p-xxl-25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".p-25",
                            "atRules": [],
                            "declarations": [
                                "padding: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-50",
                    "display": "p-*-50",
                    "variants": [
                        "p-sm-50",
                        "p-md-50",
                        "p-lg-50",
                        "p-xl-50",
                        "p-xxl-50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".p-50",
                            "atRules": [],
                            "declarations": [
                                "padding: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-100",
                    "display": "p-*-100",
                    "variants": [
                        "p-sm-100",
                        "p-md-100",
                        "p-lg-100",
                        "p-xl-100",
                        "p-xxl-100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".p-100",
                            "atRules": [],
                            "declarations": [
                                "padding: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-150",
                    "display": "p-*-150",
                    "variants": [
                        "p-sm-150",
                        "p-md-150",
                        "p-lg-150",
                        "p-xl-150",
                        "p-xxl-150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".p-150",
                            "atRules": [],
                            "declarations": [
                                "padding: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-200",
                    "display": "p-*-200",
                    "variants": [
                        "p-sm-200",
                        "p-md-200",
                        "p-lg-200",
                        "p-xl-200",
                        "p-xxl-200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".p-200",
                            "atRules": [],
                            "declarations": [
                                "padding: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-300",
                    "display": "p-*-300",
                    "variants": [
                        "p-sm-300",
                        "p-md-300",
                        "p-lg-300",
                        "p-xl-300",
                        "p-xxl-300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".p-300",
                            "atRules": [],
                            "declarations": [
                                "padding: 3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-400",
                    "display": "p-*-400",
                    "variants": [
                        "p-sm-400",
                        "p-md-400",
                        "p-lg-400",
                        "p-xl-400",
                        "p-xxl-400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".p-400",
                            "atRules": [],
                            "declarations": [
                                "padding: 4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-500",
                    "display": "p-*-500",
                    "variants": [
                        "p-sm-500",
                        "p-md-500",
                        "p-lg-500",
                        "p-xl-500",
                        "p-xxl-500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".p-500",
                            "atRules": [],
                            "declarations": [
                                "padding: 5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-600",
                    "display": "p-*-600",
                    "variants": [
                        "p-sm-600",
                        "p-md-600",
                        "p-lg-600",
                        "p-xl-600",
                        "p-xxl-600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".p-600",
                            "atRules": [],
                            "declarations": [
                                "padding: 6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-800",
                    "display": "p-*-800",
                    "variants": [
                        "p-sm-800",
                        "p-md-800",
                        "p-lg-800",
                        "p-xl-800",
                        "p-xxl-800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".p-800",
                            "atRules": [],
                            "declarations": [
                                "padding: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-0",
                    "display": "pb-*-0",
                    "variants": [
                        "pb-sm-0",
                        "pb-md-0",
                        "pb-lg-0",
                        "pb-xl-0",
                        "pb-xxl-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pb-0",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-25",
                    "display": "pb-*-25",
                    "variants": [
                        "pb-sm-25",
                        "pb-md-25",
                        "pb-lg-25",
                        "pb-xl-25",
                        "pb-xxl-25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pb-25",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-50",
                    "display": "pb-*-50",
                    "variants": [
                        "pb-sm-50",
                        "pb-md-50",
                        "pb-lg-50",
                        "pb-xl-50",
                        "pb-xxl-50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pb-50",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-100",
                    "display": "pb-*-100",
                    "variants": [
                        "pb-sm-100",
                        "pb-md-100",
                        "pb-lg-100",
                        "pb-xl-100",
                        "pb-xxl-100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pb-100",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-150",
                    "display": "pb-*-150",
                    "variants": [
                        "pb-sm-150",
                        "pb-md-150",
                        "pb-lg-150",
                        "pb-xl-150",
                        "pb-xxl-150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pb-150",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-200",
                    "display": "pb-*-200",
                    "variants": [
                        "pb-sm-200",
                        "pb-md-200",
                        "pb-lg-200",
                        "pb-xl-200",
                        "pb-xxl-200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pb-200",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-300",
                    "display": "pb-*-300",
                    "variants": [
                        "pb-sm-300",
                        "pb-md-300",
                        "pb-lg-300",
                        "pb-xl-300",
                        "pb-xxl-300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pb-300",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-400",
                    "display": "pb-*-400",
                    "variants": [
                        "pb-sm-400",
                        "pb-md-400",
                        "pb-lg-400",
                        "pb-xl-400",
                        "pb-xxl-400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pb-400",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-500",
                    "display": "pb-*-500",
                    "variants": [
                        "pb-sm-500",
                        "pb-md-500",
                        "pb-lg-500",
                        "pb-xl-500",
                        "pb-xxl-500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pb-500",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-600",
                    "display": "pb-*-600",
                    "variants": [
                        "pb-sm-600",
                        "pb-md-600",
                        "pb-lg-600",
                        "pb-xl-600",
                        "pb-xxl-600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pb-600",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-800",
                    "display": "pb-*-800",
                    "variants": [
                        "pb-sm-800",
                        "pb-md-800",
                        "pb-lg-800",
                        "pb-xl-800",
                        "pb-xxl-800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pb-800",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-0",
                    "display": "pl-*-0",
                    "variants": [
                        "pl-sm-0",
                        "pl-md-0",
                        "pl-lg-0",
                        "pl-xl-0",
                        "pl-xxl-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pl-0",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-25",
                    "display": "pl-*-25",
                    "variants": [
                        "pl-sm-25",
                        "pl-md-25",
                        "pl-lg-25",
                        "pl-xl-25",
                        "pl-xxl-25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pl-25",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-50",
                    "display": "pl-*-50",
                    "variants": [
                        "pl-sm-50",
                        "pl-md-50",
                        "pl-lg-50",
                        "pl-xl-50",
                        "pl-xxl-50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pl-50",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-100",
                    "display": "pl-*-100",
                    "variants": [
                        "pl-sm-100",
                        "pl-md-100",
                        "pl-lg-100",
                        "pl-xl-100",
                        "pl-xxl-100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pl-100",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-150",
                    "display": "pl-*-150",
                    "variants": [
                        "pl-sm-150",
                        "pl-md-150",
                        "pl-lg-150",
                        "pl-xl-150",
                        "pl-xxl-150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pl-150",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-200",
                    "display": "pl-*-200",
                    "variants": [
                        "pl-sm-200",
                        "pl-md-200",
                        "pl-lg-200",
                        "pl-xl-200",
                        "pl-xxl-200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pl-200",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-300",
                    "display": "pl-*-300",
                    "variants": [
                        "pl-sm-300",
                        "pl-md-300",
                        "pl-lg-300",
                        "pl-xl-300",
                        "pl-xxl-300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pl-300",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-400",
                    "display": "pl-*-400",
                    "variants": [
                        "pl-sm-400",
                        "pl-md-400",
                        "pl-lg-400",
                        "pl-xl-400",
                        "pl-xxl-400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pl-400",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-500",
                    "display": "pl-*-500",
                    "variants": [
                        "pl-sm-500",
                        "pl-md-500",
                        "pl-lg-500",
                        "pl-xl-500",
                        "pl-xxl-500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pl-500",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-600",
                    "display": "pl-*-600",
                    "variants": [
                        "pl-sm-600",
                        "pl-md-600",
                        "pl-lg-600",
                        "pl-xl-600",
                        "pl-xxl-600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pl-600",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-800",
                    "display": "pl-*-800",
                    "variants": [
                        "pl-sm-800",
                        "pl-md-800",
                        "pl-lg-800",
                        "pl-xl-800",
                        "pl-xxl-800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pl-800",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-0",
                    "display": "pr-*-0",
                    "variants": [
                        "pr-sm-0",
                        "pr-md-0",
                        "pr-lg-0",
                        "pr-xl-0",
                        "pr-xxl-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pr-0",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-25",
                    "display": "pr-*-25",
                    "variants": [
                        "pr-sm-25",
                        "pr-md-25",
                        "pr-lg-25",
                        "pr-xl-25",
                        "pr-xxl-25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pr-25",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-50",
                    "display": "pr-*-50",
                    "variants": [
                        "pr-sm-50",
                        "pr-md-50",
                        "pr-lg-50",
                        "pr-xl-50",
                        "pr-xxl-50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pr-50",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-100",
                    "display": "pr-*-100",
                    "variants": [
                        "pr-sm-100",
                        "pr-md-100",
                        "pr-lg-100",
                        "pr-xl-100",
                        "pr-xxl-100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pr-100",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-150",
                    "display": "pr-*-150",
                    "variants": [
                        "pr-sm-150",
                        "pr-md-150",
                        "pr-lg-150",
                        "pr-xl-150",
                        "pr-xxl-150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pr-150",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-200",
                    "display": "pr-*-200",
                    "variants": [
                        "pr-sm-200",
                        "pr-md-200",
                        "pr-lg-200",
                        "pr-xl-200",
                        "pr-xxl-200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pr-200",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-300",
                    "display": "pr-*-300",
                    "variants": [
                        "pr-sm-300",
                        "pr-md-300",
                        "pr-lg-300",
                        "pr-xl-300",
                        "pr-xxl-300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pr-300",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-400",
                    "display": "pr-*-400",
                    "variants": [
                        "pr-sm-400",
                        "pr-md-400",
                        "pr-lg-400",
                        "pr-xl-400",
                        "pr-xxl-400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pr-400",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-500",
                    "display": "pr-*-500",
                    "variants": [
                        "pr-sm-500",
                        "pr-md-500",
                        "pr-lg-500",
                        "pr-xl-500",
                        "pr-xxl-500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pr-500",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-600",
                    "display": "pr-*-600",
                    "variants": [
                        "pr-sm-600",
                        "pr-md-600",
                        "pr-lg-600",
                        "pr-xl-600",
                        "pr-xxl-600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pr-600",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-800",
                    "display": "pr-*-800",
                    "variants": [
                        "pr-sm-800",
                        "pr-md-800",
                        "pr-lg-800",
                        "pr-xl-800",
                        "pr-xxl-800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pr-800",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-0",
                    "display": "pt-*-0",
                    "variants": [
                        "pt-sm-0",
                        "pt-md-0",
                        "pt-lg-0",
                        "pt-xl-0",
                        "pt-xxl-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pt-0",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-25",
                    "display": "pt-*-25",
                    "variants": [
                        "pt-sm-25",
                        "pt-md-25",
                        "pt-lg-25",
                        "pt-xl-25",
                        "pt-xxl-25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pt-25",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-50",
                    "display": "pt-*-50",
                    "variants": [
                        "pt-sm-50",
                        "pt-md-50",
                        "pt-lg-50",
                        "pt-xl-50",
                        "pt-xxl-50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pt-50",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-100",
                    "display": "pt-*-100",
                    "variants": [
                        "pt-sm-100",
                        "pt-md-100",
                        "pt-lg-100",
                        "pt-xl-100",
                        "pt-xxl-100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pt-100",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-150",
                    "display": "pt-*-150",
                    "variants": [
                        "pt-sm-150",
                        "pt-md-150",
                        "pt-lg-150",
                        "pt-xl-150",
                        "pt-xxl-150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pt-150",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-200",
                    "display": "pt-*-200",
                    "variants": [
                        "pt-sm-200",
                        "pt-md-200",
                        "pt-lg-200",
                        "pt-xl-200",
                        "pt-xxl-200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pt-200",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-300",
                    "display": "pt-*-300",
                    "variants": [
                        "pt-sm-300",
                        "pt-md-300",
                        "pt-lg-300",
                        "pt-xl-300",
                        "pt-xxl-300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pt-300",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-400",
                    "display": "pt-*-400",
                    "variants": [
                        "pt-sm-400",
                        "pt-md-400",
                        "pt-lg-400",
                        "pt-xl-400",
                        "pt-xxl-400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pt-400",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-500",
                    "display": "pt-*-500",
                    "variants": [
                        "pt-sm-500",
                        "pt-md-500",
                        "pt-lg-500",
                        "pt-xl-500",
                        "pt-xxl-500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pt-500",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-600",
                    "display": "pt-*-600",
                    "variants": [
                        "pt-sm-600",
                        "pt-md-600",
                        "pt-lg-600",
                        "pt-xl-600",
                        "pt-xxl-600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pt-600",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-800",
                    "display": "pt-*-800",
                    "variants": [
                        "pt-sm-800",
                        "pt-md-800",
                        "pt-lg-800",
                        "pt-xl-800",
                        "pt-xxl-800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".pt-800",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-0",
                    "display": "px-*-0",
                    "variants": [
                        "px-sm-0",
                        "px-md-0",
                        "px-lg-0",
                        "px-xl-0",
                        "px-xxl-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".px-0",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 0 !important"
                            ]
                        },
                        {
                            "selector": ".px-0",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-25",
                    "display": "px-*-25",
                    "variants": [
                        "px-sm-25",
                        "px-md-25",
                        "px-lg-25",
                        "px-xl-25",
                        "px-xxl-25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".px-25",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 0.25rem !important"
                            ]
                        },
                        {
                            "selector": ".px-25",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-50",
                    "display": "px-*-50",
                    "variants": [
                        "px-sm-50",
                        "px-md-50",
                        "px-lg-50",
                        "px-xl-50",
                        "px-xxl-50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".px-50",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 0.5rem !important"
                            ]
                        },
                        {
                            "selector": ".px-50",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-100",
                    "display": "px-*-100",
                    "variants": [
                        "px-sm-100",
                        "px-md-100",
                        "px-lg-100",
                        "px-xl-100",
                        "px-xxl-100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".px-100",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 1rem !important"
                            ]
                        },
                        {
                            "selector": ".px-100",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-150",
                    "display": "px-*-150",
                    "variants": [
                        "px-sm-150",
                        "px-md-150",
                        "px-lg-150",
                        "px-xl-150",
                        "px-xxl-150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".px-150",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 1.5rem !important"
                            ]
                        },
                        {
                            "selector": ".px-150",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-200",
                    "display": "px-*-200",
                    "variants": [
                        "px-sm-200",
                        "px-md-200",
                        "px-lg-200",
                        "px-xl-200",
                        "px-xxl-200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".px-200",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 2rem !important"
                            ]
                        },
                        {
                            "selector": ".px-200",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-300",
                    "display": "px-*-300",
                    "variants": [
                        "px-sm-300",
                        "px-md-300",
                        "px-lg-300",
                        "px-xl-300",
                        "px-xxl-300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".px-300",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 3rem !important"
                            ]
                        },
                        {
                            "selector": ".px-300",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-400",
                    "display": "px-*-400",
                    "variants": [
                        "px-sm-400",
                        "px-md-400",
                        "px-lg-400",
                        "px-xl-400",
                        "px-xxl-400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".px-400",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 4rem !important"
                            ]
                        },
                        {
                            "selector": ".px-400",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-500",
                    "display": "px-*-500",
                    "variants": [
                        "px-sm-500",
                        "px-md-500",
                        "px-lg-500",
                        "px-xl-500",
                        "px-xxl-500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".px-500",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 5rem !important"
                            ]
                        },
                        {
                            "selector": ".px-500",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-600",
                    "display": "px-*-600",
                    "variants": [
                        "px-sm-600",
                        "px-md-600",
                        "px-lg-600",
                        "px-xl-600",
                        "px-xxl-600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".px-600",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 6rem !important"
                            ]
                        },
                        {
                            "selector": ".px-600",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-800",
                    "display": "px-*-800",
                    "variants": [
                        "px-sm-800",
                        "px-md-800",
                        "px-lg-800",
                        "px-xl-800",
                        "px-xxl-800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".px-800",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 8rem !important"
                            ]
                        },
                        {
                            "selector": ".px-800",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-0",
                    "display": "py-*-0",
                    "variants": [
                        "py-sm-0",
                        "py-md-0",
                        "py-lg-0",
                        "py-xl-0",
                        "py-xxl-0"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".py-0",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 0 !important"
                            ]
                        },
                        {
                            "selector": ".py-0",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-25",
                    "display": "py-*-25",
                    "variants": [
                        "py-sm-25",
                        "py-md-25",
                        "py-lg-25",
                        "py-xl-25",
                        "py-xxl-25"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".py-25",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 0.25rem !important"
                            ]
                        },
                        {
                            "selector": ".py-25",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-50",
                    "display": "py-*-50",
                    "variants": [
                        "py-sm-50",
                        "py-md-50",
                        "py-lg-50",
                        "py-xl-50",
                        "py-xxl-50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".py-50",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 0.5rem !important"
                            ]
                        },
                        {
                            "selector": ".py-50",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-100",
                    "display": "py-*-100",
                    "variants": [
                        "py-sm-100",
                        "py-md-100",
                        "py-lg-100",
                        "py-xl-100",
                        "py-xxl-100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".py-100",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 1rem !important"
                            ]
                        },
                        {
                            "selector": ".py-100",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-150",
                    "display": "py-*-150",
                    "variants": [
                        "py-sm-150",
                        "py-md-150",
                        "py-lg-150",
                        "py-xl-150",
                        "py-xxl-150"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".py-150",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 1.5rem !important"
                            ]
                        },
                        {
                            "selector": ".py-150",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-200",
                    "display": "py-*-200",
                    "variants": [
                        "py-sm-200",
                        "py-md-200",
                        "py-lg-200",
                        "py-xl-200",
                        "py-xxl-200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".py-200",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 2rem !important"
                            ]
                        },
                        {
                            "selector": ".py-200",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-300",
                    "display": "py-*-300",
                    "variants": [
                        "py-sm-300",
                        "py-md-300",
                        "py-lg-300",
                        "py-xl-300",
                        "py-xxl-300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".py-300",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 3rem !important"
                            ]
                        },
                        {
                            "selector": ".py-300",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-400",
                    "display": "py-*-400",
                    "variants": [
                        "py-sm-400",
                        "py-md-400",
                        "py-lg-400",
                        "py-xl-400",
                        "py-xxl-400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".py-400",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 4rem !important"
                            ]
                        },
                        {
                            "selector": ".py-400",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-500",
                    "display": "py-*-500",
                    "variants": [
                        "py-sm-500",
                        "py-md-500",
                        "py-lg-500",
                        "py-xl-500",
                        "py-xxl-500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".py-500",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 5rem !important"
                            ]
                        },
                        {
                            "selector": ".py-500",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-600",
                    "display": "py-*-600",
                    "variants": [
                        "py-sm-600",
                        "py-md-600",
                        "py-lg-600",
                        "py-xl-600",
                        "py-xxl-600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".py-600",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 6rem !important"
                            ]
                        },
                        {
                            "selector": ".py-600",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 6rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-800",
                    "display": "py-*-800",
                    "variants": [
                        "py-sm-800",
                        "py-md-800",
                        "py-lg-800",
                        "py-xl-800",
                        "py-xxl-800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".py-800",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 8rem !important"
                            ]
                        },
                        {
                            "selector": ".py-800",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 8rem !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "position",
            "source": "scss/utilities/_position.scss",
            "allClassesUseImportant": false,
            "classes": [
                {
                    "name": "abs-center",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".abs-center",
                            "atRules": [],
                            "declarations": [
                                "left: 50%",
                                "top: 50%",
                                "transform: translateX(-50%) translateY(-50%)"
                            ]
                        }
                    ]
                },
                {
                    "name": "fixed-bottom",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".fixed-bottom",
                            "atRules": [],
                            "declarations": [
                                "position: fixed",
                                "right: 0",
                                "bottom: 0",
                                "left: 0",
                                "z-index: 1030"
                            ]
                        }
                    ]
                },
                {
                    "name": "fixed-top",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".fixed-top",
                            "atRules": [],
                            "declarations": [
                                "position: fixed",
                                "top: 0",
                                "right: 0",
                                "left: 0",
                                "z-index: 1030"
                            ]
                        }
                    ]
                },
                {
                    "name": "position-absolute",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".position-absolute",
                            "atRules": [],
                            "declarations": [
                                "position: absolute !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "position-fixed",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".position-fixed",
                            "atRules": [],
                            "declarations": [
                                "position: fixed !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "position-relative",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".position-relative",
                            "atRules": [],
                            "declarations": [
                                "position: relative !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "position-static",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".position-static",
                            "atRules": [],
                            "declarations": [
                                "position: static !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "position-sticky",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".position-sticky",
                            "atRules": [],
                            "declarations": [
                                "position: sticky !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "sticky-top",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".sticky-top",
                            "atRules": [
                                "@supports (position: sticky)"
                            ],
                            "declarations": [
                                "position: sticky",
                                "top: 0",
                                "z-index: 1020"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "screenreaders",
            "source": "scss/utilities/_screenreaders.scss",
            "allClassesUseImportant": false,
            "classes": [
                {
                    "name": "sr-only",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".sr-only",
                            "atRules": [],
                            "declarations": [
                                "position: absolute",
                                "width: 1px",
                                "height: 1px",
                                "padding: 0",
                                "margin: -1px",
                                "overflow: hidden",
                                "clip: rect(0, 0, 0, 0)",
                                "white-space: nowrap",
                                "border: 0"
                            ]
                        }
                    ]
                },
                {
                    "name": "sr-only-focusable",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".sr-only-focusable:active",
                            "atRules": [],
                            "declarations": [
                                "position: static",
                                "width: auto",
                                "height: auto",
                                "overflow: visible",
                                "clip: auto",
                                "white-space: normal"
                            ]
                        },
                        {
                            "selector": ".sr-only-focusable:focus",
                            "atRules": [],
                            "declarations": [
                                "position: static",
                                "width: auto",
                                "height: auto",
                                "overflow: visible",
                                "clip: auto",
                                "white-space: normal"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "shadows",
            "source": "scss/utilities/_shadows.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "shadow",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".shadow",
                            "atRules": [],
                            "declarations": [
                                "box-shadow: 0 4px 12px #cfd1df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "shadow-lg",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".shadow-lg",
                            "atRules": [],
                            "declarations": [
                                "box-shadow: 0 4px 12px #cfd1df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "shadow-none",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".shadow-none",
                            "atRules": [],
                            "declarations": [
                                "box-shadow: none !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "shadow-sm",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".shadow-sm",
                            "atRules": [],
                            "declarations": [
                                "box-shadow: 0 4px 12px #cfd1df !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "sizing",
            "source": "scss/utilities/_sizing.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "h-25",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".h-25",
                            "atRules": [],
                            "declarations": [
                                "height: 25% !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "h-50",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".h-50",
                            "atRules": [],
                            "declarations": [
                                "height: 50% !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "h-75",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".h-75",
                            "atRules": [],
                            "declarations": [
                                "height: 75% !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "h-100",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".h-100",
                            "atRules": [],
                            "declarations": [
                                "height: 100% !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "h-auto",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".h-auto",
                            "atRules": [],
                            "declarations": [
                                "height: auto !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mh-100",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mh-100",
                            "atRules": [],
                            "declarations": [
                                "max-height: 100% !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "min-vh-100",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".min-vh-100",
                            "atRules": [],
                            "declarations": [
                                "min-height: 100vh !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "min-vw-100",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".min-vw-100",
                            "atRules": [],
                            "declarations": [
                                "min-width: 100vw !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "min-width-4",
                    "display": "min-width-*-4",
                    "variants": [
                        "min-width-sm-4",
                        "min-width-md-4",
                        "min-width-lg-4",
                        "min-width-xl-4",
                        "min-width-xxl-4"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".min-width-4",
                            "atRules": [],
                            "declarations": [
                                "min-width: 4em !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "min-width-5",
                    "display": "min-width-*-5",
                    "variants": [
                        "min-width-sm-5",
                        "min-width-md-5",
                        "min-width-lg-5",
                        "min-width-xl-5",
                        "min-width-xxl-5"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".min-width-5",
                            "atRules": [],
                            "declarations": [
                                "min-width: 5em !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "min-width-6",
                    "display": "min-width-*-6",
                    "variants": [
                        "min-width-sm-6",
                        "min-width-md-6",
                        "min-width-lg-6",
                        "min-width-xl-6",
                        "min-width-xxl-6"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".min-width-6",
                            "atRules": [],
                            "declarations": [
                                "min-width: 6em !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "min-width-7",
                    "display": "min-width-*-7",
                    "variants": [
                        "min-width-sm-7",
                        "min-width-md-7",
                        "min-width-lg-7",
                        "min-width-xl-7",
                        "min-width-xxl-7"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".min-width-7",
                            "atRules": [],
                            "declarations": [
                                "min-width: 7em !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mw-100",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".mw-100",
                            "atRules": [],
                            "declarations": [
                                "max-width: 100% !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "vh-100",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".vh-100",
                            "atRules": [],
                            "declarations": [
                                "height: 100vh !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "vw-100",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".vw-100",
                            "atRules": [],
                            "declarations": [
                                "width: 100vw !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "w-25",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".w-25",
                            "atRules": [],
                            "declarations": [
                                "width: 25% !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "w-50",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".w-50",
                            "atRules": [],
                            "declarations": [
                                "width: 50% !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "w-75",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".w-75",
                            "atRules": [],
                            "declarations": [
                                "width: 75% !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "w-100",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".w-100",
                            "atRules": [],
                            "declarations": [
                                "width: 100% !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "w-auto",
                    "display": "w-*-auto",
                    "variants": [
                        "w-sm-auto",
                        "w-md-auto",
                        "w-lg-auto",
                        "w-xl-auto",
                        "w-xxl-auto"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".w-auto",
                            "atRules": [],
                            "declarations": [
                                "width: auto !important"
                            ]
                        },
                        {
                            "selector": ".w-auto",
                            "atRules": [],
                            "declarations": [
                                "width: auto !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "stretched link",
            "source": "scss/utilities/_stretched-link.scss",
            "allClassesUseImportant": false,
            "classes": [
                {
                    "name": "stretched-link",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".stretched-link::after",
                            "atRules": [],
                            "declarations": [
                                "position: absolute",
                                "top: 0",
                                "right: 0",
                                "bottom: 0",
                                "left: 0",
                                "z-index: 1",
                                "pointer-events: auto",
                                "content: \"\"",
                                "background-color: rgba(0, 0, 0, 0)"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "text color",
            "source": "scss/utilities/_text.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "text-black",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-black",
                            "atRules": [],
                            "declarations": [
                                "color: #000 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-blue",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-blue",
                            "atRules": [],
                            "declarations": [
                                "color: #2e46b9 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-blue-50",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-blue-50",
                            "atRules": [],
                            "declarations": [
                                "color: #ddedff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-blue-100",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-blue-100",
                            "atRules": [],
                            "declarations": [
                                "color: #c8dfff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-blue-200",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-blue-200",
                            "atRules": [],
                            "declarations": [
                                "color: #a7c9ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-blue-300",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-blue-300",
                            "atRules": [],
                            "declarations": [
                                "color: #85b2ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-blue-400",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-blue-400",
                            "atRules": [],
                            "declarations": [
                                "color: #688aea !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-blue-500",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-blue-500",
                            "atRules": [],
                            "declarations": [
                                "color: #4a62d4 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-blue-600",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-blue-600",
                            "atRules": [],
                            "declarations": [
                                "color: #2e46b9 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-blue-700",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-blue-700",
                            "atRules": [],
                            "declarations": [
                                "color: #1d3297 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-blue-800",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-blue-800",
                            "atRules": [],
                            "declarations": [
                                "color: #162676 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-blue-900",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-blue-900",
                            "atRules": [],
                            "declarations": [
                                "color: #1b1763 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-body",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-body",
                            "atRules": [],
                            "declarations": [
                                "color: #222633 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-dark-blue",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-dark-blue",
                            "atRules": [],
                            "declarations": [
                                "color: #1b1763 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray-100",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-gray-100",
                            "atRules": [],
                            "declarations": [
                                "color: #eaecf4 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray-150",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-gray-150",
                            "atRules": [],
                            "declarations": [
                                "color: #eaecf4 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray-200",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-gray-200",
                            "atRules": [],
                            "declarations": [
                                "color: #dfe1eb !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray-300",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-gray-300",
                            "atRules": [],
                            "declarations": [
                                "color: #cfd1df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray-400",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-gray-400",
                            "atRules": [],
                            "declarations": [
                                "color: #a7aaba !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray-500",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-gray-500",
                            "atRules": [],
                            "declarations": [
                                "color: #878999 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray-600",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-gray-600",
                            "atRules": [],
                            "declarations": [
                                "color: #646776 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray-700",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-gray-700",
                            "atRules": [],
                            "declarations": [
                                "color: #515362 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray-800",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-gray-800",
                            "atRules": [],
                            "declarations": [
                                "color: #323543 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray-900",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-gray-900",
                            "atRules": [],
                            "declarations": [
                                "color: #222633 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-medium-blue",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-medium-blue",
                            "atRules": [],
                            "declarations": [
                                "color: #85b2ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-muted",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-muted",
                            "atRules": [],
                            "declarations": [
                                "color: #646776 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-orange-50",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-orange-50",
                            "atRules": [],
                            "declarations": [
                                "color: #fff3df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-orange-100",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-orange-100",
                            "atRules": [],
                            "declarations": [
                                "color: #ffe7ca !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-orange-200",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-orange-200",
                            "atRules": [],
                            "declarations": [
                                "color: #ffdbb5 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-orange-300",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-orange-300",
                            "atRules": [],
                            "declarations": [
                                "color: #ffcea0 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-orange-400",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-orange-400",
                            "atRules": [],
                            "declarations": [
                                "color: #ffc28b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-orange-500",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-orange-500",
                            "atRules": [],
                            "declarations": [
                                "color: #ffb67b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-orange-600",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-orange-600",
                            "atRules": [],
                            "declarations": [
                                "color: #ffaa66 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-orange-700",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-orange-700",
                            "atRules": [],
                            "declarations": [
                                "color: #ff9d51 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-orange-800",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-orange-800",
                            "atRules": [],
                            "declarations": [
                                "color: #ff9133 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-orange-900",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-orange-900",
                            "atRules": [],
                            "declarations": [
                                "color: #ed7c2b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-reset",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-reset",
                            "atRules": [],
                            "declarations": [
                                "color: inherit !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-soft-blue",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-soft-blue",
                            "atRules": [],
                            "declarations": [
                                "color: #c8dfff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-warm-orange",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-warm-orange",
                            "atRules": [],
                            "declarations": [
                                "color: #ff9133 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-white",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-white",
                            "atRules": [],
                            "declarations": [
                                "color: #fff !important"
                            ]
                        },
                        {
                            "selector": ".text-white",
                            "atRules": [],
                            "declarations": [
                                "color: #fff !important"
                            ]
                        },
                        {
                            "selector": ".text-white",
                            "atRules": [],
                            "declarations": [
                                "color: #fff !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "text style",
            "source": "scss/utilities/_text.scss",
            "allClassesUseImportant": false,
            "classes": [
                {
                    "name": "font-italic",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-italic",
                            "atRules": [],
                            "declarations": [
                                "font-style: italic !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-50",
                    "display": "font-size-*-50",
                    "variants": [
                        "font-size-sm-50",
                        "font-size-md-50",
                        "font-size-lg-50",
                        "font-size-xl-50",
                        "font-size-xxl-50"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-50",
                            "atRules": [],
                            "declarations": [
                                "font-size: 0.75rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-50",
                            "atRules": [],
                            "declarations": [
                                "font-size: 0.75rem !important",
                                "line-height: 1.125rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-75",
                    "display": "font-size-*-75",
                    "variants": [
                        "font-size-sm-75",
                        "font-size-md-75",
                        "font-size-lg-75",
                        "font-size-xl-75",
                        "font-size-xxl-75"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-75",
                            "atRules": [],
                            "declarations": [
                                "font-size: 0.875rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-75",
                            "atRules": [],
                            "declarations": [
                                "font-size: 0.875rem !important",
                                "line-height: 1.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-100",
                    "display": "font-size-*-100",
                    "variants": [
                        "font-size-sm-100",
                        "font-size-md-100",
                        "font-size-lg-100",
                        "font-size-xl-100",
                        "font-size-xxl-100"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-100",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-100",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1rem !important",
                                "line-height: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-200",
                    "display": "font-size-*-200",
                    "variants": [
                        "font-size-sm-200",
                        "font-size-md-200",
                        "font-size-lg-200",
                        "font-size-xl-200",
                        "font-size-xxl-200"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-200",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.125rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-200",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.125rem !important",
                                "line-height: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-300",
                    "display": "font-size-*-300",
                    "variants": [
                        "font-size-sm-300",
                        "font-size-md-300",
                        "font-size-lg-300",
                        "font-size-xl-300",
                        "font-size-xxl-300"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-300",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.25rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-300",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.25rem !important",
                                "line-height: 1.75rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-400",
                    "display": "font-size-*-400",
                    "variants": [
                        "font-size-sm-400",
                        "font-size-md-400",
                        "font-size-lg-400",
                        "font-size-xl-400",
                        "font-size-xxl-400"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-400",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.5rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-400",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.5rem !important",
                                "line-height: 1.75rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-500",
                    "display": "font-size-*-500",
                    "variants": [
                        "font-size-sm-500",
                        "font-size-md-500",
                        "font-size-lg-500",
                        "font-size-xl-500",
                        "font-size-xxl-500"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-500",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.875rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-500",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.875rem !important",
                                "line-height: 2.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-600",
                    "display": "font-size-*-600",
                    "variants": [
                        "font-size-sm-600",
                        "font-size-md-600",
                        "font-size-lg-600",
                        "font-size-xl-600",
                        "font-size-xxl-600"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-600",
                            "atRules": [],
                            "declarations": [
                                "font-size: 2.375rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-600",
                            "atRules": [],
                            "declarations": [
                                "font-size: 2.375rem !important",
                                "line-height: 3rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-700",
                    "display": "font-size-*-700",
                    "variants": [
                        "font-size-sm-700",
                        "font-size-md-700",
                        "font-size-lg-700",
                        "font-size-xl-700",
                        "font-size-xxl-700"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-700",
                            "atRules": [],
                            "declarations": [
                                "font-size: 3rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-700",
                            "atRules": [],
                            "declarations": [
                                "font-size: 3rem !important",
                                "line-height: 3.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-800",
                    "display": "font-size-*-800",
                    "variants": [
                        "font-size-sm-800",
                        "font-size-md-800",
                        "font-size-lg-800",
                        "font-size-xl-800",
                        "font-size-xxl-800"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-800",
                            "atRules": [],
                            "declarations": [
                                "font-size: 3.375rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-800",
                            "atRules": [],
                            "declarations": [
                                "font-size: 3.375rem !important",
                                "line-height: 4rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-900",
                    "display": "font-size-*-900",
                    "variants": [
                        "font-size-sm-900",
                        "font-size-md-900",
                        "font-size-lg-900",
                        "font-size-xl-900",
                        "font-size-xxl-900"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-900",
                            "atRules": [],
                            "declarations": [
                                "font-size: 3.875rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-900",
                            "atRules": [],
                            "declarations": [
                                "font-size: 3.875rem !important",
                                "line-height: 4.375rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-base",
                    "display": "font-size-*-base",
                    "variants": [
                        "font-size-sm-base",
                        "font-size-md-base",
                        "font-size-lg-base",
                        "font-size-xl-base",
                        "font-size-xxl-base"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-base",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-base",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1rem !important",
                                "line-height: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-h1",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-h1",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.5rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-h1",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 2.375rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-h2",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-h2",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.25rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-h2",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 1.875rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-h3",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-h3",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.125rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-h3",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 1.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-h4",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-h4",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-h4",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 1.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-h5",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-h5",
                            "atRules": [],
                            "declarations": [
                                "font-size: 0.875rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-h5",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-h6",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-h6",
                            "atRules": [],
                            "declarations": [
                                "font-size: 0.875rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-h6",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-lg",
                    "display": "font-size-*-lg",
                    "variants": [
                        "font-size-sm-lg",
                        "font-size-md-lg",
                        "font-size-lg-lg",
                        "font-size-xl-lg",
                        "font-size-xxl-lg"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-lg",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.25rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-lg",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.25rem !important",
                                "line-height: 1.75rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-sm",
                    "display": "font-size-*-sm",
                    "variants": [
                        "font-size-sm-sm",
                        "font-size-md-sm",
                        "font-size-lg-sm",
                        "font-size-xl-sm",
                        "font-size-xxl-sm"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-sm",
                            "atRules": [],
                            "declarations": [
                                "font-size: 0.875rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-sm",
                            "atRules": [],
                            "declarations": [
                                "font-size: 0.875rem !important",
                                "line-height: 1.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-xs",
                    "display": "font-size-*-xs",
                    "variants": [
                        "font-size-sm-xs",
                        "font-size-md-xs",
                        "font-size-lg-xs",
                        "font-size-xl-xs",
                        "font-size-xxl-xs"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-size-xs",
                            "atRules": [],
                            "declarations": [
                                "font-size: 0.75rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-xs",
                            "atRules": [],
                            "declarations": [
                                "font-size: 0.75rem !important",
                                "line-height: 1.125rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-weight-bold",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-weight-bold",
                            "atRules": [],
                            "declarations": [
                                "font-weight: 600 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-weight-bolder",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-weight-bolder",
                            "atRules": [],
                            "declarations": [
                                "font-weight: 700 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-weight-boldest",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-weight-boldest",
                            "atRules": [],
                            "declarations": [
                                "font-weight: 800 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-weight-light",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-weight-light",
                            "atRules": [],
                            "declarations": [
                                "font-weight: 300 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-weight-lighter",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-weight-lighter",
                            "atRules": [],
                            "declarations": [
                                "font-weight: 200 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-weight-lightest",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-weight-lightest",
                            "atRules": [],
                            "declarations": [
                                "font-weight: lighter !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-weight-normal",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-weight-normal",
                            "atRules": [],
                            "declarations": [
                                "font-weight: 400 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-weight-semibold",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".font-weight-semibold",
                            "atRules": [],
                            "declarations": [
                                "font-weight: 500 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "line-height-base",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".line-height-base",
                            "atRules": [],
                            "declarations": [
                                "line-height: 1.5 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-break",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-break",
                            "atRules": [],
                            "declarations": [
                                "word-break: break-word !important",
                                "word-wrap: break-word !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-capitalize",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-capitalize",
                            "atRules": [],
                            "declarations": [
                                "text-transform: capitalize !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-center",
                    "display": "text-*-center",
                    "variants": [
                        "text-sm-center",
                        "text-md-center",
                        "text-lg-center",
                        "text-xl-center",
                        "text-xxl-center"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-center",
                            "atRules": [],
                            "declarations": [
                                "text-align: center !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-decoration-none",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-decoration-none",
                            "atRules": [],
                            "declarations": [
                                "text-decoration: none !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-hide",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".text-hide",
                            "atRules": [],
                            "declarations": [
                                "font: 0/0 a",
                                "color: transparent",
                                "text-shadow: none",
                                "background-color: transparent",
                                "border: 0"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-justify",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-justify",
                            "atRules": [],
                            "declarations": [
                                "text-align: justify !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-left",
                    "display": "text-*-left",
                    "variants": [
                        "text-sm-left",
                        "text-md-left",
                        "text-lg-left",
                        "text-xl-left",
                        "text-xxl-left"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-left",
                            "atRules": [],
                            "declarations": [
                                "text-align: left !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-lowercase",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-lowercase",
                            "atRules": [],
                            "declarations": [
                                "text-transform: lowercase !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-monospace",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-monospace",
                            "atRules": [],
                            "declarations": [
                                "font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-nowrap",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-nowrap",
                            "atRules": [],
                            "declarations": [
                                "white-space: nowrap !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-right",
                    "display": "text-*-right",
                    "variants": [
                        "text-sm-right",
                        "text-md-right",
                        "text-lg-right",
                        "text-xl-right",
                        "text-xxl-right"
                    ],
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-right",
                            "atRules": [],
                            "declarations": [
                                "text-align: right !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-truncate",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".text-truncate",
                            "atRules": [],
                            "declarations": [
                                "overflow: hidden",
                                "text-overflow: ellipsis",
                                "white-space: nowrap"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-uppercase",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-uppercase",
                            "atRules": [],
                            "declarations": [
                                "text-transform: uppercase !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-wrap",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-wrap",
                            "atRules": [],
                            "declarations": [
                                "white-space: normal !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "typography",
            "source": "scss/_type.scss",
            "allClassesUseImportant": false,
            "classes": [
                {
                    "name": "blockquote",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".blockquote",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 1rem",
                                "font-size: 1.25rem"
                            ]
                        }
                    ]
                },
                {
                    "name": "blockquote-footer",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".blockquote-footer",
                            "atRules": [],
                            "declarations": [
                                "display: block",
                                "font-size: 0.875em",
                                "color: #646776"
                            ]
                        },
                        {
                            "selector": ".blockquote-footer::before",
                            "atRules": [],
                            "declarations": [
                                "content: \"— \""
                            ]
                        }
                    ]
                },
                {
                    "name": "eyebrow",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".eyebrow",
                            "atRules": [],
                            "declarations": [
                                "color: #1b1763",
                                "font-size: 1rem",
                                "font-weight: 600",
                                "letter-spacing: 0.08rem",
                                "line-height: 1.5rem",
                                "margin-bottom: 0.5rem",
                                "text-transform: uppercase"
                            ]
                        }
                    ]
                },
                {
                    "name": "h1",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".h1",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 1rem",
                                "font-family: \"Plus Jakarta Sans\", \"Helvetica Neue\", Roboto, \"Segoe UI\", -apple-system, BlinkMacSystemFont, Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
                                "font-weight: 600",
                                "color: #222633"
                            ]
                        },
                        {
                            "selector": ".h1",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.5rem",
                                "line-height: 1.75rem"
                            ]
                        },
                        {
                            "selector": ".h1",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 2.375rem",
                                "line-height: 3rem"
                            ]
                        }
                    ]
                },
                {
                    "name": "h2",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".h2",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 1rem",
                                "font-family: \"Plus Jakarta Sans\", \"Helvetica Neue\", Roboto, \"Segoe UI\", -apple-system, BlinkMacSystemFont, Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
                                "font-weight: 600",
                                "color: #222633"
                            ]
                        },
                        {
                            "selector": ".h2",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.25rem",
                                "line-height: 1.75rem"
                            ]
                        },
                        {
                            "selector": ".h2",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 1.875rem",
                                "line-height: 2.25rem"
                            ]
                        }
                    ]
                },
                {
                    "name": "h3",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".h3",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 1rem",
                                "font-family: \"Plus Jakarta Sans\", \"Helvetica Neue\", Roboto, \"Segoe UI\", -apple-system, BlinkMacSystemFont, Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
                                "font-weight: 600",
                                "color: #222633"
                            ]
                        },
                        {
                            "selector": ".h3",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.125rem",
                                "line-height: 1.5rem"
                            ]
                        },
                        {
                            "selector": ".h3",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 1.5rem",
                                "line-height: 1.75rem"
                            ]
                        }
                    ]
                },
                {
                    "name": "h4",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".h4",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 1rem",
                                "font-family: \"Plus Jakarta Sans\", \"Helvetica Neue\", Roboto, \"Segoe UI\", -apple-system, BlinkMacSystemFont, Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
                                "font-weight: 600",
                                "color: #222633"
                            ]
                        },
                        {
                            "selector": ".h4",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1rem",
                                "line-height: 1.5rem"
                            ]
                        },
                        {
                            "selector": ".h4",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 1.25rem",
                                "line-height: 1.75rem"
                            ]
                        }
                    ]
                },
                {
                    "name": "h5",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".h5",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 1rem",
                                "font-family: \"Plus Jakarta Sans\", \"Helvetica Neue\", Roboto, \"Segoe UI\", -apple-system, BlinkMacSystemFont, Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
                                "font-weight: 600",
                                "color: #222633"
                            ]
                        },
                        {
                            "selector": ".h5",
                            "atRules": [],
                            "declarations": [
                                "font-size: 0.875rem",
                                "line-height: 1.25rem"
                            ]
                        },
                        {
                            "selector": ".h5",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 1rem",
                                "line-height: 1.5rem"
                            ]
                        }
                    ]
                },
                {
                    "name": "h6",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".h6",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 1rem",
                                "font-family: \"Plus Jakarta Sans\", \"Helvetica Neue\", Roboto, \"Segoe UI\", -apple-system, BlinkMacSystemFont, Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
                                "font-weight: 600",
                                "color: #222633"
                            ]
                        },
                        {
                            "selector": ".h6",
                            "atRules": [],
                            "declarations": [
                                "font-size: 0.875rem",
                                "line-height: 1.25rem"
                            ]
                        },
                        {
                            "selector": ".h6",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 1rem",
                                "line-height: 1.5rem"
                            ]
                        }
                    ]
                },
                {
                    "name": "initialism",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".initialism",
                            "atRules": [],
                            "declarations": [
                                "font-size: 90%",
                                "text-transform: uppercase"
                            ]
                        }
                    ]
                },
                {
                    "name": "lead",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".lead",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.25rem",
                                "font-weight: 300"
                            ]
                        }
                    ]
                },
                {
                    "name": "list-inline",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".list-inline",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 0",
                                "list-style: none"
                            ]
                        }
                    ]
                },
                {
                    "name": "list-inline-item",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".list-inline-item",
                            "atRules": [],
                            "declarations": [
                                "display: inline-block"
                            ]
                        },
                        {
                            "selector": ".list-inline-item:not(:last-child)",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 0.5rem"
                            ]
                        }
                    ]
                },
                {
                    "name": "list-unstyled",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".list-unstyled",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 0",
                                "list-style: none"
                            ]
                        },
                        {
                            "selector": ".list-unstyled li",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 0"
                            ]
                        }
                    ]
                },
                {
                    "name": "mark",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".mark",
                            "atRules": [],
                            "declarations": [
                                "padding: 0.2em",
                                "background-color: #fcf8e3"
                            ]
                        }
                    ]
                },
                {
                    "name": "post1",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".post1",
                            "atRules": [],
                            "declarations": [
                                "color: #222633",
                                "font-family: \"Plus Jakarta Sans\", \"Helvetica Neue\", Roboto, \"Segoe UI\", -apple-system, BlinkMacSystemFont, Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
                                "font-weight: 700",
                                "margin-bottom: 1rem"
                            ]
                        },
                        {
                            "selector": ".post1",
                            "atRules": [],
                            "declarations": [
                                "font-size: 3rem",
                                "line-height: 3.5rem"
                            ]
                        },
                        {
                            "selector": ".post1",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 3.875rem",
                                "line-height: 4.375rem"
                            ]
                        }
                    ]
                },
                {
                    "name": "post2",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".post2",
                            "atRules": [],
                            "declarations": [
                                "color: #222633",
                                "font-family: \"Plus Jakarta Sans\", \"Helvetica Neue\", Roboto, \"Segoe UI\", -apple-system, BlinkMacSystemFont, Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
                                "font-weight: 700",
                                "margin-bottom: 1rem"
                            ]
                        },
                        {
                            "selector": ".post2",
                            "atRules": [],
                            "declarations": [
                                "font-size: 2.375rem",
                                "line-height: 3rem"
                            ]
                        },
                        {
                            "selector": ".post2",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 3.375rem",
                                "line-height: 4rem"
                            ]
                        }
                    ]
                },
                {
                    "name": "post3",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".post3",
                            "atRules": [],
                            "declarations": [
                                "color: #222633",
                                "font-family: \"Plus Jakarta Sans\", \"Helvetica Neue\", Roboto, \"Segoe UI\", -apple-system, BlinkMacSystemFont, Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
                                "font-weight: 700",
                                "margin-bottom: 1rem"
                            ]
                        },
                        {
                            "selector": ".post3",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.875rem",
                                "line-height: 2.25rem"
                            ]
                        },
                        {
                            "selector": ".post3",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 3rem",
                                "line-height: 3.5rem"
                            ]
                        }
                    ]
                },
                {
                    "name": "small",
                    "important": false,
                    "rules": [
                        {
                            "selector": ".small",
                            "atRules": [],
                            "declarations": [
                                "font-size: 0.875em",
                                "font-weight: 400"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "visibility",
            "source": "scss/utilities/_visibility.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "invisible",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".invisible",
                            "atRules": [],
                            "declarations": [
                                "visibility: hidden !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "visible",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".visible",
                            "atRules": [],
                            "declarations": [
                                "visibility: visible !important"
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "deprecated": [
        {
            "name": "background",
            "source": "scss/utilities/_background.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "bg-cyan",
                    "important": true,
                    "replaceWith": "bg-dark-blue",
                    "rules": [
                        {
                            "selector": ".bg-cyan",
                            "atRules": [],
                            "declarations": [
                                "background-color: #1b1763 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-cyan-100",
                    "important": true,
                    "replaceWith": "bg-blue-50",
                    "rules": [
                        {
                            "selector": ".bg-cyan-100",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ddedff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-cyan-200",
                    "important": true,
                    "replaceWith": "bg-blue-100",
                    "rules": [
                        {
                            "selector": ".bg-cyan-200",
                            "atRules": [],
                            "declarations": [
                                "background-color: #c8dfff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-cyan-300",
                    "important": true,
                    "replaceWith": "bg-blue-200",
                    "rules": [
                        {
                            "selector": ".bg-cyan-300",
                            "atRules": [],
                            "declarations": [
                                "background-color: #a7c9ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-cyan-400",
                    "important": true,
                    "replaceWith": "bg-blue-500",
                    "rules": [
                        {
                            "selector": ".bg-cyan-400",
                            "atRules": [],
                            "declarations": [
                                "background-color: #4a62d4 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-cyan-500",
                    "important": true,
                    "replaceWith": "bg-blue-600",
                    "rules": [
                        {
                            "selector": ".bg-cyan-500",
                            "atRules": [],
                            "declarations": [
                                "background-color: #2e46b9 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-cyan-600",
                    "important": true,
                    "replaceWith": "bg-blue-700",
                    "rules": [
                        {
                            "selector": ".bg-cyan-600",
                            "atRules": [],
                            "declarations": [
                                "background-color: #1d3297 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-cyan-700",
                    "important": true,
                    "replaceWith": "bg-blue-800",
                    "rules": [
                        {
                            "selector": ".bg-cyan-700",
                            "atRules": [],
                            "declarations": [
                                "background-color: #162676 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-cyan-800",
                    "important": true,
                    "replaceWith": "bg-blue-900",
                    "rules": [
                        {
                            "selector": ".bg-cyan-800",
                            "atRules": [],
                            "declarations": [
                                "background-color: #1b1763 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-danger",
                    "important": true,
                    "replaceWith": "bg-error-900",
                    "rules": [
                        {
                            "selector": ".bg-danger",
                            "atRules": [],
                            "declarations": [
                                "background-color: #de3c50 !important"
                            ]
                        },
                        {
                            "selector": "a.bg-danger:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(77.4767801858%, 13.1114551084%, 21.0577915377%) !important"
                            ]
                        },
                        {
                            "selector": "a.bg-danger:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(77.4767801858%, 13.1114551084%, 21.0577915377%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-danger:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(77.4767801858%, 13.1114551084%, 21.0577915377%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-danger:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(77.4767801858%, 13.1114551084%, 21.0577915377%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-dark",
                    "important": true,
                    "replaceWith": "bg-gray-900",
                    "rules": [
                        {
                            "selector": ".bg-dark",
                            "atRules": [],
                            "declarations": [
                                "background-color: #222633 !important"
                            ]
                        },
                        {
                            "selector": "a.bg-dark:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(5.3333333333%, 5.9607843137%, 8%) !important"
                            ]
                        },
                        {
                            "selector": "a.bg-dark:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(5.3333333333%, 5.9607843137%, 8%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-dark:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(5.3333333333%, 5.9607843137%, 8%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-dark:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(5.3333333333%, 5.9607843137%, 8%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray",
                    "important": true,
                    "replaceWith": "bg-gray-900",
                    "rules": [
                        {
                            "selector": ".bg-gray",
                            "atRules": [],
                            "declarations": [
                                "background-color: #222633 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-1000",
                    "important": true,
                    "replaceWith": "bg-gray-900",
                    "rules": [
                        {
                            "selector": ".bg-gray-1000",
                            "atRules": [],
                            "declarations": [
                                "background-color: #222633 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-1100",
                    "important": true,
                    "replaceWith": "bg-gray-900",
                    "rules": [
                        {
                            "selector": ".bg-gray-1100",
                            "atRules": [],
                            "declarations": [
                                "background-color: #222633 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-1200",
                    "important": true,
                    "replaceWith": "bg-gray-900",
                    "rules": [
                        {
                            "selector": ".bg-gray-1200",
                            "atRules": [],
                            "declarations": [
                                "background-color: #222633 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-blue",
                    "important": true,
                    "replaceWith": "bg-soft-blue",
                    "rules": [
                        {
                            "selector": ".bg-gray-blue",
                            "atRules": [],
                            "declarations": [
                                "background-color: #c8dfff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-gray-dark",
                    "important": true,
                    "replaceWith": "bg-gray-800",
                    "rules": [
                        {
                            "selector": ".bg-gray-dark",
                            "atRules": [],
                            "declarations": [
                                "background-color: #323543 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-green",
                    "important": true,
                    "replaceWith": "bg-success-900",
                    "rules": [
                        {
                            "selector": ".bg-green",
                            "atRules": [],
                            "declarations": [
                                "background-color: #00a759 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-highlight",
                    "important": true,
                    "replaceWith": "bg-blue-700",
                    "rules": [
                        {
                            "selector": ".bg-highlight",
                            "atRules": [],
                            "declarations": [
                                "background-color: #1d3297 !important"
                            ]
                        },
                        {
                            "selector": "a.bg-highlight:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(8.1503267974%, 14.0522875817%, 42.4379084967%) !important"
                            ]
                        },
                        {
                            "selector": "a.bg-highlight:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(8.1503267974%, 14.0522875817%, 42.4379084967%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-highlight:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(8.1503267974%, 14.0522875817%, 42.4379084967%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-highlight:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(8.1503267974%, 14.0522875817%, 42.4379084967%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-highlight-dark",
                    "important": true,
                    "replaceWith": "bg-blue-600",
                    "rules": [
                        {
                            "selector": ".bg-highlight-dark",
                            "atRules": [],
                            "declarations": [
                                "background-color: #2e46b9 !important"
                            ]
                        },
                        {
                            "selector": "a.bg-highlight-dark:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(14.0565317036%, 21.3903743316%, 56.5317035905%) !important"
                            ]
                        },
                        {
                            "selector": "a.bg-highlight-dark:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(14.0565317036%, 21.3903743316%, 56.5317035905%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-highlight-dark:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(14.0565317036%, 21.3903743316%, 56.5317035905%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-highlight-dark:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(14.0565317036%, 21.3903743316%, 56.5317035905%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-indigo",
                    "important": true,
                    "replaceWith": "bg-blue-700",
                    "rules": [
                        {
                            "selector": ".bg-indigo",
                            "atRules": [],
                            "declarations": [
                                "background-color: #1d3297 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-info",
                    "important": true,
                    "replaceWith": "bg-medium-blue",
                    "rules": [
                        {
                            "selector": ".bg-info",
                            "atRules": [],
                            "declarations": [
                                "background-color: #85b2ff !important"
                            ]
                        },
                        {
                            "selector": "a.bg-info:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(32.1568627451%, 57.180970749%, 100%) !important"
                            ]
                        },
                        {
                            "selector": "a.bg-info:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(32.1568627451%, 57.180970749%, 100%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-info:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(32.1568627451%, 57.180970749%, 100%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-info:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(32.1568627451%, 57.180970749%, 100%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-light",
                    "important": true,
                    "replaceWith": "bg-gray-200",
                    "rules": [
                        {
                            "selector": ".bg-light",
                            "atRules": [],
                            "declarations": [
                                "background-color: #dfe1eb !important"
                            ]
                        },
                        {
                            "selector": "a.bg-light:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(75.1432880845%, 76.6968325792%, 84.4645550528%) !important"
                            ]
                        },
                        {
                            "selector": "a.bg-light:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(75.1432880845%, 76.6968325792%, 84.4645550528%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-light:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(75.1432880845%, 76.6968325792%, 84.4645550528%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-light:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(75.1432880845%, 76.6968325792%, 84.4645550528%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-light-blue",
                    "important": true,
                    "replaceWith": "bg-blue-200",
                    "rules": [
                        {
                            "selector": ".bg-light-blue",
                            "atRules": [],
                            "declarations": [
                                "background-color: #a7c9ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-mid",
                    "important": true,
                    "replaceWith": "bg-gray-300",
                    "rules": [
                        {
                            "selector": ".bg-mid",
                            "atRules": [],
                            "declarations": [
                                "background-color: #cfd1df !important"
                            ]
                        },
                        {
                            "selector": "a.bg-mid:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(69.1764705882%, 70.4607843137%, 79.4509803922%) !important"
                            ]
                        },
                        {
                            "selector": "a.bg-mid:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(69.1764705882%, 70.4607843137%, 79.4509803922%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-mid:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(69.1764705882%, 70.4607843137%, 79.4509803922%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-mid:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(69.1764705882%, 70.4607843137%, 79.4509803922%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-mid-dark",
                    "important": true,
                    "replaceWith": "bg-gray-600",
                    "rules": [
                        {
                            "selector": ".bg-mid-dark",
                            "atRules": [],
                            "declarations": [
                                "background-color: #646776 !important"
                            ]
                        },
                        {
                            "selector": "a.bg-mid-dark:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(30.0413743479%, 30.9426155783%, 35.4488217305%) !important"
                            ]
                        },
                        {
                            "selector": "a.bg-mid-dark:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(30.0413743479%, 30.9426155783%, 35.4488217305%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-mid-dark:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(30.0413743479%, 30.9426155783%, 35.4488217305%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-mid-dark:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(30.0413743479%, 30.9426155783%, 35.4488217305%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-orange",
                    "important": true,
                    "replaceWith": "bg-warm-orange",
                    "rules": [
                        {
                            "selector": ".bg-orange",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ff9133 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-pink",
                    "important": true,
                    "replaceWith": "bg-warm-orange",
                    "rules": [
                        {
                            "selector": ".bg-pink",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ff9133 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-pink-100",
                    "important": true,
                    "replaceWith": "bg-orange-50",
                    "rules": [
                        {
                            "selector": ".bg-pink-100",
                            "atRules": [],
                            "declarations": [
                                "background-color: #fff3df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-pink-200",
                    "important": true,
                    "replaceWith": "bg-orange-200",
                    "rules": [
                        {
                            "selector": ".bg-pink-200",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ffdbb5 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-pink-300",
                    "important": true,
                    "replaceWith": "bg-orange-400",
                    "rules": [
                        {
                            "selector": ".bg-pink-300",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ffc28b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-pink-400",
                    "important": true,
                    "replaceWith": "bg-orange-500",
                    "rules": [
                        {
                            "selector": ".bg-pink-400",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ffb67b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-pink-500",
                    "important": true,
                    "replaceWith": "bg-orange-900",
                    "rules": [
                        {
                            "selector": ".bg-pink-500",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ed7c2b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-pink-600",
                    "important": true,
                    "replaceWith": "bg-orange-900",
                    "rules": [
                        {
                            "selector": ".bg-pink-600",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ed7c2b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-pink-700",
                    "important": true,
                    "replaceWith": "bg-orange-900",
                    "rules": [
                        {
                            "selector": ".bg-pink-700",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ed7c2b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-pink-800",
                    "important": true,
                    "replaceWith": "bg-orange-900",
                    "rules": [
                        {
                            "selector": ".bg-pink-800",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ed7c2b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-primary",
                    "important": true,
                    "replaceWith": "bg-dark-blue",
                    "rules": [
                        {
                            "selector": ".bg-primary",
                            "atRules": [],
                            "declarations": [
                                "background-color: #1b1763 !important"
                            ]
                        },
                        {
                            "selector": "a.bg-primary:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(6.1620057859%, 5.2491160399%, 22.594021215%) !important"
                            ]
                        },
                        {
                            "selector": "a.bg-primary:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(6.1620057859%, 5.2491160399%, 22.594021215%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-primary:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(6.1620057859%, 5.2491160399%, 22.594021215%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-primary:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(6.1620057859%, 5.2491160399%, 22.594021215%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-purple",
                    "important": true,
                    "replaceWith": "bg-blue-600",
                    "rules": [
                        {
                            "selector": ".bg-purple",
                            "atRules": [],
                            "declarations": [
                                "background-color: #2e46b9 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-red",
                    "important": true,
                    "replaceWith": "bg-error-900",
                    "rules": [
                        {
                            "selector": ".bg-red",
                            "atRules": [],
                            "declarations": [
                                "background-color: #de3c50 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-secondary",
                    "important": true,
                    "replaceWith": "bg-gray-900",
                    "rules": [
                        {
                            "selector": ".bg-secondary",
                            "atRules": [],
                            "declarations": [
                                "background-color: #222633 !important"
                            ]
                        },
                        {
                            "selector": "a.bg-secondary:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(5.3333333333%, 5.9607843137%, 8%) !important"
                            ]
                        },
                        {
                            "selector": "a.bg-secondary:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(5.3333333333%, 5.9607843137%, 8%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-secondary:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(5.3333333333%, 5.9607843137%, 8%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-secondary:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(5.3333333333%, 5.9607843137%, 8%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-success",
                    "important": true,
                    "replaceWith": "bg-success-900",
                    "rules": [
                        {
                            "selector": ".bg-success",
                            "atRules": [],
                            "declarations": [
                                "background-color: #00a759 !important"
                            ]
                        },
                        {
                            "selector": "a.bg-success:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(0%, 45.4901960784%, 24.2432781496%) !important"
                            ]
                        },
                        {
                            "selector": "a.bg-success:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(0%, 45.4901960784%, 24.2432781496%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-success:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(0%, 45.4901960784%, 24.2432781496%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-success:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(0%, 45.4901960784%, 24.2432781496%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-teal",
                    "important": true,
                    "replaceWith": "bg-medium-blue",
                    "rules": [
                        {
                            "selector": ".bg-teal",
                            "atRules": [],
                            "declarations": [
                                "background-color: #85b2ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-teal-100",
                    "important": true,
                    "replaceWith": "bg-blue-50",
                    "rules": [
                        {
                            "selector": ".bg-teal-100",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ddedff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-teal-200",
                    "important": true,
                    "replaceWith": "bg-blue-200",
                    "rules": [
                        {
                            "selector": ".bg-teal-200",
                            "atRules": [],
                            "declarations": [
                                "background-color: #a7c9ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-teal-300",
                    "important": true,
                    "replaceWith": "bg-blue-300",
                    "rules": [
                        {
                            "selector": ".bg-teal-300",
                            "atRules": [],
                            "declarations": [
                                "background-color: #85b2ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-teal-400",
                    "important": true,
                    "replaceWith": "bg-blue-400",
                    "rules": [
                        {
                            "selector": ".bg-teal-400",
                            "atRules": [],
                            "declarations": [
                                "background-color: #688aea !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-teal-500",
                    "important": true,
                    "replaceWith": "bg-blue-400",
                    "rules": [
                        {
                            "selector": ".bg-teal-500",
                            "atRules": [],
                            "declarations": [
                                "background-color: #688aea !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-teal-600",
                    "important": true,
                    "replaceWith": "bg-blue-600",
                    "rules": [
                        {
                            "selector": ".bg-teal-600",
                            "atRules": [],
                            "declarations": [
                                "background-color: #2e46b9 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-teal-700",
                    "important": true,
                    "replaceWith": "bg-blue-800",
                    "rules": [
                        {
                            "selector": ".bg-teal-700",
                            "atRules": [],
                            "declarations": [
                                "background-color: #162676 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-teal-800",
                    "important": true,
                    "replaceWith": "bg-blue-900",
                    "rules": [
                        {
                            "selector": ".bg-teal-800",
                            "atRules": [],
                            "declarations": [
                                "background-color: #1b1763 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-warning",
                    "important": true,
                    "replaceWith": "bg-warning-900",
                    "rules": [
                        {
                            "selector": ".bg-warning",
                            "atRules": [],
                            "declarations": [
                                "background-color: #f4ca11 !important"
                            ]
                        },
                        {
                            "selector": "a.bg-warning:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(78.7148594378%, 64.8240018899%, 3.6380817387%) !important"
                            ]
                        },
                        {
                            "selector": "a.bg-warning:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(78.7148594378%, 64.8240018899%, 3.6380817387%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-warning:hover",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(78.7148594378%, 64.8240018899%, 3.6380817387%) !important"
                            ]
                        },
                        {
                            "selector": "button.bg-warning:focus",
                            "atRules": [],
                            "declarations": [
                                "background-color: rgb(78.7148594378%, 64.8240018899%, 3.6380817387%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-yellow",
                    "important": true,
                    "replaceWith": "bg-warm-orange",
                    "rules": [
                        {
                            "selector": ".bg-yellow",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ff9133 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-yellow-100",
                    "important": true,
                    "replaceWith": "bg-orange-50",
                    "rules": [
                        {
                            "selector": ".bg-yellow-100",
                            "atRules": [],
                            "declarations": [
                                "background-color: #fff3df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-yellow-200",
                    "important": true,
                    "replaceWith": "bg-orange-200",
                    "rules": [
                        {
                            "selector": ".bg-yellow-200",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ffdbb5 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-yellow-300",
                    "important": true,
                    "replaceWith": "bg-orange-400",
                    "rules": [
                        {
                            "selector": ".bg-yellow-300",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ffc28b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-yellow-400",
                    "important": true,
                    "replaceWith": "bg-orange-600",
                    "rules": [
                        {
                            "selector": ".bg-yellow-400",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ffaa66 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-yellow-500",
                    "important": true,
                    "replaceWith": "bg-orange-700",
                    "rules": [
                        {
                            "selector": ".bg-yellow-500",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ff9d51 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-yellow-600",
                    "important": true,
                    "replaceWith": "bg-orange-900",
                    "rules": [
                        {
                            "selector": ".bg-yellow-600",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ed7c2b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-yellow-700",
                    "important": true,
                    "replaceWith": "bg-orange-900",
                    "rules": [
                        {
                            "selector": ".bg-yellow-700",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ed7c2b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "bg-yellow-800",
                    "important": true,
                    "replaceWith": "bg-orange-900",
                    "rules": [
                        {
                            "selector": ".bg-yellow-800",
                            "atRules": [],
                            "declarations": [
                                "background-color: #ed7c2b !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "borders",
            "source": "scss/utilities/_borders.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "border-danger",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-danger",
                            "atRules": [],
                            "declarations": [
                                "border-color: #de3c50 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-dark",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-dark",
                            "atRules": [],
                            "declarations": [
                                "border-color: #222633 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-highlight",
                    "important": true,
                    "replaceWith": "border-blue-700",
                    "rules": [
                        {
                            "selector": ".border-highlight",
                            "atRules": [],
                            "declarations": [
                                "border-color: #1d3297 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-highlight-dark",
                    "important": true,
                    "replaceWith": "border-blue-600",
                    "rules": [
                        {
                            "selector": ".border-highlight-dark",
                            "atRules": [],
                            "declarations": [
                                "border-color: #2e46b9 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-info",
                    "important": true,
                    "replaceWith": "border-medium-blue",
                    "rules": [
                        {
                            "selector": ".border-info",
                            "atRules": [],
                            "declarations": [
                                "border-color: #85b2ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-light",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-light",
                            "atRules": [],
                            "declarations": [
                                "border-color: #dfe1eb !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-mid",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-mid",
                            "atRules": [],
                            "declarations": [
                                "border-color: #cfd1df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-mid-dark",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-mid-dark",
                            "atRules": [],
                            "declarations": [
                                "border-color: #646776 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-primary",
                    "important": true,
                    "replaceWith": "border-dark-blue",
                    "rules": [
                        {
                            "selector": ".border-primary",
                            "atRules": [],
                            "declarations": [
                                "border-color: #1b1763 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-secondary",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-secondary",
                            "atRules": [],
                            "declarations": [
                                "border-color: #222633 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-success",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-success",
                            "atRules": [],
                            "declarations": [
                                "border-color: #00a759 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "border-warning",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".border-warning",
                            "atRules": [],
                            "declarations": [
                                "border-color: #f4ca11 !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "margin",
            "source": "scss/utilities/_spacing.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "m-1",
                    "display": "m-*-1",
                    "variants": [
                        "m-sm-1",
                        "m-md-1",
                        "m-lg-1",
                        "m-xl-1",
                        "m-xxl-1"
                    ],
                    "important": true,
                    "replaceWith": "m-25",
                    "replaceWithDisplay": "m-*-25",
                    "rules": [
                        {
                            "selector": ".m-1",
                            "atRules": [],
                            "declarations": [
                                "margin: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-2",
                    "display": "m-*-2",
                    "variants": [
                        "m-sm-2",
                        "m-md-2",
                        "m-lg-2",
                        "m-xl-2",
                        "m-xxl-2"
                    ],
                    "important": true,
                    "replaceWith": "m-50",
                    "replaceWithDisplay": "m-*-50",
                    "rules": [
                        {
                            "selector": ".m-2",
                            "atRules": [],
                            "declarations": [
                                "margin: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-3",
                    "display": "m-*-3",
                    "variants": [
                        "m-sm-3",
                        "m-md-3",
                        "m-lg-3",
                        "m-xl-3",
                        "m-xxl-3"
                    ],
                    "important": true,
                    "replaceWith": "m-100",
                    "replaceWithDisplay": "m-*-100",
                    "rules": [
                        {
                            "selector": ".m-3",
                            "atRules": [],
                            "declarations": [
                                "margin: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-4",
                    "display": "m-*-4",
                    "variants": [
                        "m-sm-4",
                        "m-md-4",
                        "m-lg-4",
                        "m-xl-4",
                        "m-xxl-4"
                    ],
                    "important": true,
                    "replaceWith": "m-200",
                    "replaceWithDisplay": "m-*-200",
                    "rules": [
                        {
                            "selector": ".m-4",
                            "atRules": [],
                            "declarations": [
                                "margin: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-5",
                    "display": "m-*-5",
                    "variants": [
                        "m-sm-5",
                        "m-md-5",
                        "m-lg-5",
                        "m-xl-5",
                        "m-xxl-5"
                    ],
                    "important": true,
                    "replaceWith": "m-500",
                    "replaceWithDisplay": "m-*-500",
                    "rules": [
                        {
                            "selector": ".m-5",
                            "atRules": [],
                            "declarations": [
                                "margin: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-6",
                    "display": "m-*-6",
                    "variants": [
                        "m-sm-6",
                        "m-md-6",
                        "m-lg-6",
                        "m-xl-6",
                        "m-xxl-6"
                    ],
                    "important": true,
                    "replaceWith": "m-800",
                    "replaceWithDisplay": "m-*-800",
                    "rules": [
                        {
                            "selector": ".m-6",
                            "atRules": [],
                            "declarations": [
                                "margin: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-450",
                    "display": "m-*-450",
                    "variants": [
                        "m-sm-450",
                        "m-md-450",
                        "m-lg-450",
                        "m-xl-450",
                        "m-xxl-450"
                    ],
                    "important": true,
                    "replaceWith": "m-500",
                    "replaceWithDisplay": "m-*-500",
                    "rules": [
                        {
                            "selector": ".m-450",
                            "atRules": [],
                            "declarations": [
                                "margin: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n1",
                    "display": "m-*-n1",
                    "variants": [
                        "m-sm-n1",
                        "m-md-n1",
                        "m-lg-n1",
                        "m-xl-n1",
                        "m-xxl-n1"
                    ],
                    "important": true,
                    "replaceWith": "m-n25",
                    "replaceWithDisplay": "m-*-n25",
                    "rules": [
                        {
                            "selector": ".m-n1",
                            "atRules": [],
                            "declarations": [
                                "margin: -0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n2",
                    "display": "m-*-n2",
                    "variants": [
                        "m-sm-n2",
                        "m-md-n2",
                        "m-lg-n2",
                        "m-xl-n2",
                        "m-xxl-n2"
                    ],
                    "important": true,
                    "replaceWith": "m-n50",
                    "replaceWithDisplay": "m-*-n50",
                    "rules": [
                        {
                            "selector": ".m-n2",
                            "atRules": [],
                            "declarations": [
                                "margin: -0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n3",
                    "display": "m-*-n3",
                    "variants": [
                        "m-sm-n3",
                        "m-md-n3",
                        "m-lg-n3",
                        "m-xl-n3",
                        "m-xxl-n3"
                    ],
                    "important": true,
                    "replaceWith": "m-n100",
                    "replaceWithDisplay": "m-*-n100",
                    "rules": [
                        {
                            "selector": ".m-n3",
                            "atRules": [],
                            "declarations": [
                                "margin: -1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n4",
                    "display": "m-*-n4",
                    "variants": [
                        "m-sm-n4",
                        "m-md-n4",
                        "m-lg-n4",
                        "m-xl-n4",
                        "m-xxl-n4"
                    ],
                    "important": true,
                    "replaceWith": "m-n200",
                    "replaceWithDisplay": "m-*-n200",
                    "rules": [
                        {
                            "selector": ".m-n4",
                            "atRules": [],
                            "declarations": [
                                "margin: -2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n5",
                    "display": "m-*-n5",
                    "variants": [
                        "m-sm-n5",
                        "m-md-n5",
                        "m-lg-n5",
                        "m-xl-n5",
                        "m-xxl-n5"
                    ],
                    "important": true,
                    "replaceWith": "m-n500",
                    "replaceWithDisplay": "m-*-n500",
                    "rules": [
                        {
                            "selector": ".m-n5",
                            "atRules": [],
                            "declarations": [
                                "margin: -4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n6",
                    "display": "m-*-n6",
                    "variants": [
                        "m-sm-n6",
                        "m-md-n6",
                        "m-lg-n6",
                        "m-xl-n6",
                        "m-xxl-n6"
                    ],
                    "important": true,
                    "replaceWith": "m-n800",
                    "replaceWithDisplay": "m-*-n800",
                    "rules": [
                        {
                            "selector": ".m-n6",
                            "atRules": [],
                            "declarations": [
                                "margin: -8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "m-n450",
                    "display": "m-*-n450",
                    "variants": [
                        "m-sm-n450",
                        "m-md-n450",
                        "m-lg-n450",
                        "m-xl-n450",
                        "m-xxl-n450"
                    ],
                    "important": true,
                    "replaceWith": "m-n500",
                    "replaceWithDisplay": "m-*-n500",
                    "rules": [
                        {
                            "selector": ".m-n450",
                            "atRules": [],
                            "declarations": [
                                "margin: -4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-1",
                    "display": "mb-*-1",
                    "variants": [
                        "mb-sm-1",
                        "mb-md-1",
                        "mb-lg-1",
                        "mb-xl-1",
                        "mb-xxl-1"
                    ],
                    "important": true,
                    "replaceWith": "mb-25",
                    "replaceWithDisplay": "mb-*-25",
                    "rules": [
                        {
                            "selector": ".mb-1",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-2",
                    "display": "mb-*-2",
                    "variants": [
                        "mb-sm-2",
                        "mb-md-2",
                        "mb-lg-2",
                        "mb-xl-2",
                        "mb-xxl-2"
                    ],
                    "important": true,
                    "replaceWith": "mb-50",
                    "replaceWithDisplay": "mb-*-50",
                    "rules": [
                        {
                            "selector": ".mb-2",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-3",
                    "display": "mb-*-3",
                    "variants": [
                        "mb-sm-3",
                        "mb-md-3",
                        "mb-lg-3",
                        "mb-xl-3",
                        "mb-xxl-3"
                    ],
                    "important": true,
                    "replaceWith": "mb-100",
                    "replaceWithDisplay": "mb-*-100",
                    "rules": [
                        {
                            "selector": ".mb-3",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-4",
                    "display": "mb-*-4",
                    "variants": [
                        "mb-sm-4",
                        "mb-md-4",
                        "mb-lg-4",
                        "mb-xl-4",
                        "mb-xxl-4"
                    ],
                    "important": true,
                    "replaceWith": "mb-200",
                    "replaceWithDisplay": "mb-*-200",
                    "rules": [
                        {
                            "selector": ".mb-4",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-5",
                    "display": "mb-*-5",
                    "variants": [
                        "mb-sm-5",
                        "mb-md-5",
                        "mb-lg-5",
                        "mb-xl-5",
                        "mb-xxl-5"
                    ],
                    "important": true,
                    "replaceWith": "mb-500",
                    "replaceWithDisplay": "mb-*-500",
                    "rules": [
                        {
                            "selector": ".mb-5",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-6",
                    "display": "mb-*-6",
                    "variants": [
                        "mb-sm-6",
                        "mb-md-6",
                        "mb-lg-6",
                        "mb-xl-6",
                        "mb-xxl-6"
                    ],
                    "important": true,
                    "replaceWith": "mb-800",
                    "replaceWithDisplay": "mb-*-800",
                    "rules": [
                        {
                            "selector": ".mb-6",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-450",
                    "display": "mb-*-450",
                    "variants": [
                        "mb-sm-450",
                        "mb-md-450",
                        "mb-lg-450",
                        "mb-xl-450",
                        "mb-xxl-450"
                    ],
                    "important": true,
                    "replaceWith": "mb-500",
                    "replaceWithDisplay": "mb-*-500",
                    "rules": [
                        {
                            "selector": ".mb-450",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n1",
                    "display": "mb-*-n1",
                    "variants": [
                        "mb-sm-n1",
                        "mb-md-n1",
                        "mb-lg-n1",
                        "mb-xl-n1",
                        "mb-xxl-n1"
                    ],
                    "important": true,
                    "replaceWith": "mb-n25",
                    "replaceWithDisplay": "mb-*-n25",
                    "rules": [
                        {
                            "selector": ".mb-n1",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n2",
                    "display": "mb-*-n2",
                    "variants": [
                        "mb-sm-n2",
                        "mb-md-n2",
                        "mb-lg-n2",
                        "mb-xl-n2",
                        "mb-xxl-n2"
                    ],
                    "important": true,
                    "replaceWith": "mb-n50",
                    "replaceWithDisplay": "mb-*-n50",
                    "rules": [
                        {
                            "selector": ".mb-n2",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n3",
                    "display": "mb-*-n3",
                    "variants": [
                        "mb-sm-n3",
                        "mb-md-n3",
                        "mb-lg-n3",
                        "mb-xl-n3",
                        "mb-xxl-n3"
                    ],
                    "important": true,
                    "replaceWith": "mb-n100",
                    "replaceWithDisplay": "mb-*-n100",
                    "rules": [
                        {
                            "selector": ".mb-n3",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n4",
                    "display": "mb-*-n4",
                    "variants": [
                        "mb-sm-n4",
                        "mb-md-n4",
                        "mb-lg-n4",
                        "mb-xl-n4",
                        "mb-xxl-n4"
                    ],
                    "important": true,
                    "replaceWith": "mb-n200",
                    "replaceWithDisplay": "mb-*-n200",
                    "rules": [
                        {
                            "selector": ".mb-n4",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n5",
                    "display": "mb-*-n5",
                    "variants": [
                        "mb-sm-n5",
                        "mb-md-n5",
                        "mb-lg-n5",
                        "mb-xl-n5",
                        "mb-xxl-n5"
                    ],
                    "important": true,
                    "replaceWith": "mb-n500",
                    "replaceWithDisplay": "mb-*-n500",
                    "rules": [
                        {
                            "selector": ".mb-n5",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n6",
                    "display": "mb-*-n6",
                    "variants": [
                        "mb-sm-n6",
                        "mb-md-n6",
                        "mb-lg-n6",
                        "mb-xl-n6",
                        "mb-xxl-n6"
                    ],
                    "important": true,
                    "replaceWith": "mb-n800",
                    "replaceWithDisplay": "mb-*-n800",
                    "rules": [
                        {
                            "selector": ".mb-n6",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mb-n450",
                    "display": "mb-*-n450",
                    "variants": [
                        "mb-sm-n450",
                        "mb-md-n450",
                        "mb-lg-n450",
                        "mb-xl-n450",
                        "mb-xxl-n450"
                    ],
                    "important": true,
                    "replaceWith": "mb-n500",
                    "replaceWithDisplay": "mb-*-n500",
                    "rules": [
                        {
                            "selector": ".mb-n450",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-1",
                    "display": "ml-*-1",
                    "variants": [
                        "ml-sm-1",
                        "ml-md-1",
                        "ml-lg-1",
                        "ml-xl-1",
                        "ml-xxl-1"
                    ],
                    "important": true,
                    "replaceWith": "ml-25",
                    "replaceWithDisplay": "ml-*-25",
                    "rules": [
                        {
                            "selector": ".ml-1",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-2",
                    "display": "ml-*-2",
                    "variants": [
                        "ml-sm-2",
                        "ml-md-2",
                        "ml-lg-2",
                        "ml-xl-2",
                        "ml-xxl-2"
                    ],
                    "important": true,
                    "replaceWith": "ml-50",
                    "replaceWithDisplay": "ml-*-50",
                    "rules": [
                        {
                            "selector": ".ml-2",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-3",
                    "display": "ml-*-3",
                    "variants": [
                        "ml-sm-3",
                        "ml-md-3",
                        "ml-lg-3",
                        "ml-xl-3",
                        "ml-xxl-3"
                    ],
                    "important": true,
                    "replaceWith": "ml-100",
                    "replaceWithDisplay": "ml-*-100",
                    "rules": [
                        {
                            "selector": ".ml-3",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-4",
                    "display": "ml-*-4",
                    "variants": [
                        "ml-sm-4",
                        "ml-md-4",
                        "ml-lg-4",
                        "ml-xl-4",
                        "ml-xxl-4"
                    ],
                    "important": true,
                    "replaceWith": "ml-200",
                    "replaceWithDisplay": "ml-*-200",
                    "rules": [
                        {
                            "selector": ".ml-4",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-5",
                    "display": "ml-*-5",
                    "variants": [
                        "ml-sm-5",
                        "ml-md-5",
                        "ml-lg-5",
                        "ml-xl-5",
                        "ml-xxl-5"
                    ],
                    "important": true,
                    "replaceWith": "ml-500",
                    "replaceWithDisplay": "ml-*-500",
                    "rules": [
                        {
                            "selector": ".ml-5",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-6",
                    "display": "ml-*-6",
                    "variants": [
                        "ml-sm-6",
                        "ml-md-6",
                        "ml-lg-6",
                        "ml-xl-6",
                        "ml-xxl-6"
                    ],
                    "important": true,
                    "replaceWith": "ml-800",
                    "replaceWithDisplay": "ml-*-800",
                    "rules": [
                        {
                            "selector": ".ml-6",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-450",
                    "display": "ml-*-450",
                    "variants": [
                        "ml-sm-450",
                        "ml-md-450",
                        "ml-lg-450",
                        "ml-xl-450",
                        "ml-xxl-450"
                    ],
                    "important": true,
                    "replaceWith": "ml-500",
                    "replaceWithDisplay": "ml-*-500",
                    "rules": [
                        {
                            "selector": ".ml-450",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n1",
                    "display": "ml-*-n1",
                    "variants": [
                        "ml-sm-n1",
                        "ml-md-n1",
                        "ml-lg-n1",
                        "ml-xl-n1",
                        "ml-xxl-n1"
                    ],
                    "important": true,
                    "replaceWith": "ml-n25",
                    "replaceWithDisplay": "ml-*-n25",
                    "rules": [
                        {
                            "selector": ".ml-n1",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n2",
                    "display": "ml-*-n2",
                    "variants": [
                        "ml-sm-n2",
                        "ml-md-n2",
                        "ml-lg-n2",
                        "ml-xl-n2",
                        "ml-xxl-n2"
                    ],
                    "important": true,
                    "replaceWith": "ml-n50",
                    "replaceWithDisplay": "ml-*-n50",
                    "rules": [
                        {
                            "selector": ".ml-n2",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n3",
                    "display": "ml-*-n3",
                    "variants": [
                        "ml-sm-n3",
                        "ml-md-n3",
                        "ml-lg-n3",
                        "ml-xl-n3",
                        "ml-xxl-n3"
                    ],
                    "important": true,
                    "replaceWith": "ml-n100",
                    "replaceWithDisplay": "ml-*-n100",
                    "rules": [
                        {
                            "selector": ".ml-n3",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n4",
                    "display": "ml-*-n4",
                    "variants": [
                        "ml-sm-n4",
                        "ml-md-n4",
                        "ml-lg-n4",
                        "ml-xl-n4",
                        "ml-xxl-n4"
                    ],
                    "important": true,
                    "replaceWith": "ml-n200",
                    "replaceWithDisplay": "ml-*-n200",
                    "rules": [
                        {
                            "selector": ".ml-n4",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n5",
                    "display": "ml-*-n5",
                    "variants": [
                        "ml-sm-n5",
                        "ml-md-n5",
                        "ml-lg-n5",
                        "ml-xl-n5",
                        "ml-xxl-n5"
                    ],
                    "important": true,
                    "replaceWith": "ml-n500",
                    "replaceWithDisplay": "ml-*-n500",
                    "rules": [
                        {
                            "selector": ".ml-n5",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n6",
                    "display": "ml-*-n6",
                    "variants": [
                        "ml-sm-n6",
                        "ml-md-n6",
                        "ml-lg-n6",
                        "ml-xl-n6",
                        "ml-xxl-n6"
                    ],
                    "important": true,
                    "replaceWith": "ml-n800",
                    "replaceWithDisplay": "ml-*-n800",
                    "rules": [
                        {
                            "selector": ".ml-n6",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "ml-n450",
                    "display": "ml-*-n450",
                    "variants": [
                        "ml-sm-n450",
                        "ml-md-n450",
                        "ml-lg-n450",
                        "ml-xl-n450",
                        "ml-xxl-n450"
                    ],
                    "important": true,
                    "replaceWith": "ml-n500",
                    "replaceWithDisplay": "ml-*-n500",
                    "rules": [
                        {
                            "selector": ".ml-n450",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-1",
                    "display": "mr-*-1",
                    "variants": [
                        "mr-sm-1",
                        "mr-md-1",
                        "mr-lg-1",
                        "mr-xl-1",
                        "mr-xxl-1"
                    ],
                    "important": true,
                    "replaceWith": "mr-25",
                    "replaceWithDisplay": "mr-*-25",
                    "rules": [
                        {
                            "selector": ".mr-1",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-2",
                    "display": "mr-*-2",
                    "variants": [
                        "mr-sm-2",
                        "mr-md-2",
                        "mr-lg-2",
                        "mr-xl-2",
                        "mr-xxl-2"
                    ],
                    "important": true,
                    "replaceWith": "mr-50",
                    "replaceWithDisplay": "mr-*-50",
                    "rules": [
                        {
                            "selector": ".mr-2",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-3",
                    "display": "mr-*-3",
                    "variants": [
                        "mr-sm-3",
                        "mr-md-3",
                        "mr-lg-3",
                        "mr-xl-3",
                        "mr-xxl-3"
                    ],
                    "important": true,
                    "replaceWith": "mr-100",
                    "replaceWithDisplay": "mr-*-100",
                    "rules": [
                        {
                            "selector": ".mr-3",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-4",
                    "display": "mr-*-4",
                    "variants": [
                        "mr-sm-4",
                        "mr-md-4",
                        "mr-lg-4",
                        "mr-xl-4",
                        "mr-xxl-4"
                    ],
                    "important": true,
                    "replaceWith": "mr-200",
                    "replaceWithDisplay": "mr-*-200",
                    "rules": [
                        {
                            "selector": ".mr-4",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-5",
                    "display": "mr-*-5",
                    "variants": [
                        "mr-sm-5",
                        "mr-md-5",
                        "mr-lg-5",
                        "mr-xl-5",
                        "mr-xxl-5"
                    ],
                    "important": true,
                    "replaceWith": "mr-500",
                    "replaceWithDisplay": "mr-*-500",
                    "rules": [
                        {
                            "selector": ".mr-5",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-6",
                    "display": "mr-*-6",
                    "variants": [
                        "mr-sm-6",
                        "mr-md-6",
                        "mr-lg-6",
                        "mr-xl-6",
                        "mr-xxl-6"
                    ],
                    "important": true,
                    "replaceWith": "mr-800",
                    "replaceWithDisplay": "mr-*-800",
                    "rules": [
                        {
                            "selector": ".mr-6",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-450",
                    "display": "mr-*-450",
                    "variants": [
                        "mr-sm-450",
                        "mr-md-450",
                        "mr-lg-450",
                        "mr-xl-450",
                        "mr-xxl-450"
                    ],
                    "important": true,
                    "replaceWith": "mr-500",
                    "replaceWithDisplay": "mr-*-500",
                    "rules": [
                        {
                            "selector": ".mr-450",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n1",
                    "display": "mr-*-n1",
                    "variants": [
                        "mr-sm-n1",
                        "mr-md-n1",
                        "mr-lg-n1",
                        "mr-xl-n1",
                        "mr-xxl-n1"
                    ],
                    "important": true,
                    "replaceWith": "mr-n25",
                    "replaceWithDisplay": "mr-*-n25",
                    "rules": [
                        {
                            "selector": ".mr-n1",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n2",
                    "display": "mr-*-n2",
                    "variants": [
                        "mr-sm-n2",
                        "mr-md-n2",
                        "mr-lg-n2",
                        "mr-xl-n2",
                        "mr-xxl-n2"
                    ],
                    "important": true,
                    "replaceWith": "mr-n50",
                    "replaceWithDisplay": "mr-*-n50",
                    "rules": [
                        {
                            "selector": ".mr-n2",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n3",
                    "display": "mr-*-n3",
                    "variants": [
                        "mr-sm-n3",
                        "mr-md-n3",
                        "mr-lg-n3",
                        "mr-xl-n3",
                        "mr-xxl-n3"
                    ],
                    "important": true,
                    "replaceWith": "mr-n100",
                    "replaceWithDisplay": "mr-*-n100",
                    "rules": [
                        {
                            "selector": ".mr-n3",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n4",
                    "display": "mr-*-n4",
                    "variants": [
                        "mr-sm-n4",
                        "mr-md-n4",
                        "mr-lg-n4",
                        "mr-xl-n4",
                        "mr-xxl-n4"
                    ],
                    "important": true,
                    "replaceWith": "mr-n200",
                    "replaceWithDisplay": "mr-*-n200",
                    "rules": [
                        {
                            "selector": ".mr-n4",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n5",
                    "display": "mr-*-n5",
                    "variants": [
                        "mr-sm-n5",
                        "mr-md-n5",
                        "mr-lg-n5",
                        "mr-xl-n5",
                        "mr-xxl-n5"
                    ],
                    "important": true,
                    "replaceWith": "mr-n500",
                    "replaceWithDisplay": "mr-*-n500",
                    "rules": [
                        {
                            "selector": ".mr-n5",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n6",
                    "display": "mr-*-n6",
                    "variants": [
                        "mr-sm-n6",
                        "mr-md-n6",
                        "mr-lg-n6",
                        "mr-xl-n6",
                        "mr-xxl-n6"
                    ],
                    "important": true,
                    "replaceWith": "mr-n800",
                    "replaceWithDisplay": "mr-*-n800",
                    "rules": [
                        {
                            "selector": ".mr-n6",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mr-n450",
                    "display": "mr-*-n450",
                    "variants": [
                        "mr-sm-n450",
                        "mr-md-n450",
                        "mr-lg-n450",
                        "mr-xl-n450",
                        "mr-xxl-n450"
                    ],
                    "important": true,
                    "replaceWith": "mr-n500",
                    "replaceWithDisplay": "mr-*-n500",
                    "rules": [
                        {
                            "selector": ".mr-n450",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-1",
                    "display": "mt-*-1",
                    "variants": [
                        "mt-sm-1",
                        "mt-md-1",
                        "mt-lg-1",
                        "mt-xl-1",
                        "mt-xxl-1"
                    ],
                    "important": true,
                    "replaceWith": "mt-25",
                    "replaceWithDisplay": "mt-*-25",
                    "rules": [
                        {
                            "selector": ".mt-1",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-2",
                    "display": "mt-*-2",
                    "variants": [
                        "mt-sm-2",
                        "mt-md-2",
                        "mt-lg-2",
                        "mt-xl-2",
                        "mt-xxl-2"
                    ],
                    "important": true,
                    "replaceWith": "mt-50",
                    "replaceWithDisplay": "mt-*-50",
                    "rules": [
                        {
                            "selector": ".mt-2",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-3",
                    "display": "mt-*-3",
                    "variants": [
                        "mt-sm-3",
                        "mt-md-3",
                        "mt-lg-3",
                        "mt-xl-3",
                        "mt-xxl-3"
                    ],
                    "important": true,
                    "replaceWith": "mt-100",
                    "replaceWithDisplay": "mt-*-100",
                    "rules": [
                        {
                            "selector": ".mt-3",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-4",
                    "display": "mt-*-4",
                    "variants": [
                        "mt-sm-4",
                        "mt-md-4",
                        "mt-lg-4",
                        "mt-xl-4",
                        "mt-xxl-4"
                    ],
                    "important": true,
                    "replaceWith": "mt-200",
                    "replaceWithDisplay": "mt-*-200",
                    "rules": [
                        {
                            "selector": ".mt-4",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-5",
                    "display": "mt-*-5",
                    "variants": [
                        "mt-sm-5",
                        "mt-md-5",
                        "mt-lg-5",
                        "mt-xl-5",
                        "mt-xxl-5"
                    ],
                    "important": true,
                    "replaceWith": "mt-500",
                    "replaceWithDisplay": "mt-*-500",
                    "rules": [
                        {
                            "selector": ".mt-5",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-6",
                    "display": "mt-*-6",
                    "variants": [
                        "mt-sm-6",
                        "mt-md-6",
                        "mt-lg-6",
                        "mt-xl-6",
                        "mt-xxl-6"
                    ],
                    "important": true,
                    "replaceWith": "mt-800",
                    "replaceWithDisplay": "mt-*-800",
                    "rules": [
                        {
                            "selector": ".mt-6",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-450",
                    "display": "mt-*-450",
                    "variants": [
                        "mt-sm-450",
                        "mt-md-450",
                        "mt-lg-450",
                        "mt-xl-450",
                        "mt-xxl-450"
                    ],
                    "important": true,
                    "replaceWith": "mt-500",
                    "replaceWithDisplay": "mt-*-500",
                    "rules": [
                        {
                            "selector": ".mt-450",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n1",
                    "display": "mt-*-n1",
                    "variants": [
                        "mt-sm-n1",
                        "mt-md-n1",
                        "mt-lg-n1",
                        "mt-xl-n1",
                        "mt-xxl-n1"
                    ],
                    "important": true,
                    "replaceWith": "mt-n25",
                    "replaceWithDisplay": "mt-*-n25",
                    "rules": [
                        {
                            "selector": ".mt-n1",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n2",
                    "display": "mt-*-n2",
                    "variants": [
                        "mt-sm-n2",
                        "mt-md-n2",
                        "mt-lg-n2",
                        "mt-xl-n2",
                        "mt-xxl-n2"
                    ],
                    "important": true,
                    "replaceWith": "mt-n50",
                    "replaceWithDisplay": "mt-*-n50",
                    "rules": [
                        {
                            "selector": ".mt-n2",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n3",
                    "display": "mt-*-n3",
                    "variants": [
                        "mt-sm-n3",
                        "mt-md-n3",
                        "mt-lg-n3",
                        "mt-xl-n3",
                        "mt-xxl-n3"
                    ],
                    "important": true,
                    "replaceWith": "mt-n100",
                    "replaceWithDisplay": "mt-*-n100",
                    "rules": [
                        {
                            "selector": ".mt-n3",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n4",
                    "display": "mt-*-n4",
                    "variants": [
                        "mt-sm-n4",
                        "mt-md-n4",
                        "mt-lg-n4",
                        "mt-xl-n4",
                        "mt-xxl-n4"
                    ],
                    "important": true,
                    "replaceWith": "mt-n200",
                    "replaceWithDisplay": "mt-*-n200",
                    "rules": [
                        {
                            "selector": ".mt-n4",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n5",
                    "display": "mt-*-n5",
                    "variants": [
                        "mt-sm-n5",
                        "mt-md-n5",
                        "mt-lg-n5",
                        "mt-xl-n5",
                        "mt-xxl-n5"
                    ],
                    "important": true,
                    "replaceWith": "mt-n500",
                    "replaceWithDisplay": "mt-*-n500",
                    "rules": [
                        {
                            "selector": ".mt-n5",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n6",
                    "display": "mt-*-n6",
                    "variants": [
                        "mt-sm-n6",
                        "mt-md-n6",
                        "mt-lg-n6",
                        "mt-xl-n6",
                        "mt-xxl-n6"
                    ],
                    "important": true,
                    "replaceWith": "mt-n800",
                    "replaceWithDisplay": "mt-*-n800",
                    "rules": [
                        {
                            "selector": ".mt-n6",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mt-n450",
                    "display": "mt-*-n450",
                    "variants": [
                        "mt-sm-n450",
                        "mt-md-n450",
                        "mt-lg-n450",
                        "mt-xl-n450",
                        "mt-xxl-n450"
                    ],
                    "important": true,
                    "replaceWith": "mt-n500",
                    "replaceWithDisplay": "mt-*-n500",
                    "rules": [
                        {
                            "selector": ".mt-n450",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-1",
                    "display": "mx-*-1",
                    "variants": [
                        "mx-sm-1",
                        "mx-md-1",
                        "mx-lg-1",
                        "mx-xl-1",
                        "mx-xxl-1"
                    ],
                    "important": true,
                    "replaceWith": "mx-25",
                    "replaceWithDisplay": "mx-*-25",
                    "rules": [
                        {
                            "selector": ".mx-1",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 0.25rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-1",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-2",
                    "display": "mx-*-2",
                    "variants": [
                        "mx-sm-2",
                        "mx-md-2",
                        "mx-lg-2",
                        "mx-xl-2",
                        "mx-xxl-2"
                    ],
                    "important": true,
                    "replaceWith": "mx-50",
                    "replaceWithDisplay": "mx-*-50",
                    "rules": [
                        {
                            "selector": ".mx-2",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 0.5rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-2",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-3",
                    "display": "mx-*-3",
                    "variants": [
                        "mx-sm-3",
                        "mx-md-3",
                        "mx-lg-3",
                        "mx-xl-3",
                        "mx-xxl-3"
                    ],
                    "important": true,
                    "replaceWith": "mx-100",
                    "replaceWithDisplay": "mx-*-100",
                    "rules": [
                        {
                            "selector": ".mx-3",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 1rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-3",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-4",
                    "display": "mx-*-4",
                    "variants": [
                        "mx-sm-4",
                        "mx-md-4",
                        "mx-lg-4",
                        "mx-xl-4",
                        "mx-xxl-4"
                    ],
                    "important": true,
                    "replaceWith": "mx-200",
                    "replaceWithDisplay": "mx-*-200",
                    "rules": [
                        {
                            "selector": ".mx-4",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 2rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-4",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-5",
                    "display": "mx-*-5",
                    "variants": [
                        "mx-sm-5",
                        "mx-md-5",
                        "mx-lg-5",
                        "mx-xl-5",
                        "mx-xxl-5"
                    ],
                    "important": true,
                    "replaceWith": "mx-500",
                    "replaceWithDisplay": "mx-*-500",
                    "rules": [
                        {
                            "selector": ".mx-5",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 4.5rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-5",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-6",
                    "display": "mx-*-6",
                    "variants": [
                        "mx-sm-6",
                        "mx-md-6",
                        "mx-lg-6",
                        "mx-xl-6",
                        "mx-xxl-6"
                    ],
                    "important": true,
                    "replaceWith": "mx-800",
                    "replaceWithDisplay": "mx-*-800",
                    "rules": [
                        {
                            "selector": ".mx-6",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 8rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-6",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-450",
                    "display": "mx-*-450",
                    "variants": [
                        "mx-sm-450",
                        "mx-md-450",
                        "mx-lg-450",
                        "mx-xl-450",
                        "mx-xxl-450"
                    ],
                    "important": true,
                    "replaceWith": "mx-500",
                    "replaceWithDisplay": "mx-*-500",
                    "rules": [
                        {
                            "selector": ".mx-450",
                            "atRules": [],
                            "declarations": [
                                "margin-right: 4.5rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-450",
                            "atRules": [],
                            "declarations": [
                                "margin-left: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n1",
                    "display": "mx-*-n1",
                    "variants": [
                        "mx-sm-n1",
                        "mx-md-n1",
                        "mx-lg-n1",
                        "mx-xl-n1",
                        "mx-xxl-n1"
                    ],
                    "important": true,
                    "replaceWith": "mx-n25",
                    "replaceWithDisplay": "mx-*-n25",
                    "rules": [
                        {
                            "selector": ".mx-n1",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -0.25rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n1",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n2",
                    "display": "mx-*-n2",
                    "variants": [
                        "mx-sm-n2",
                        "mx-md-n2",
                        "mx-lg-n2",
                        "mx-xl-n2",
                        "mx-xxl-n2"
                    ],
                    "important": true,
                    "replaceWith": "mx-n50",
                    "replaceWithDisplay": "mx-*-n50",
                    "rules": [
                        {
                            "selector": ".mx-n2",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -0.5rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n2",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n3",
                    "display": "mx-*-n3",
                    "variants": [
                        "mx-sm-n3",
                        "mx-md-n3",
                        "mx-lg-n3",
                        "mx-xl-n3",
                        "mx-xxl-n3"
                    ],
                    "important": true,
                    "replaceWith": "mx-n100",
                    "replaceWithDisplay": "mx-*-n100",
                    "rules": [
                        {
                            "selector": ".mx-n3",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -1rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n3",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n4",
                    "display": "mx-*-n4",
                    "variants": [
                        "mx-sm-n4",
                        "mx-md-n4",
                        "mx-lg-n4",
                        "mx-xl-n4",
                        "mx-xxl-n4"
                    ],
                    "important": true,
                    "replaceWith": "mx-n200",
                    "replaceWithDisplay": "mx-*-n200",
                    "rules": [
                        {
                            "selector": ".mx-n4",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -2rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n4",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n5",
                    "display": "mx-*-n5",
                    "variants": [
                        "mx-sm-n5",
                        "mx-md-n5",
                        "mx-lg-n5",
                        "mx-xl-n5",
                        "mx-xxl-n5"
                    ],
                    "important": true,
                    "replaceWith": "mx-n500",
                    "replaceWithDisplay": "mx-*-n500",
                    "rules": [
                        {
                            "selector": ".mx-n5",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -4.5rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n5",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n6",
                    "display": "mx-*-n6",
                    "variants": [
                        "mx-sm-n6",
                        "mx-md-n6",
                        "mx-lg-n6",
                        "mx-xl-n6",
                        "mx-xxl-n6"
                    ],
                    "important": true,
                    "replaceWith": "mx-n800",
                    "replaceWithDisplay": "mx-*-n800",
                    "rules": [
                        {
                            "selector": ".mx-n6",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -8rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n6",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "mx-n450",
                    "display": "mx-*-n450",
                    "variants": [
                        "mx-sm-n450",
                        "mx-md-n450",
                        "mx-lg-n450",
                        "mx-xl-n450",
                        "mx-xxl-n450"
                    ],
                    "important": true,
                    "replaceWith": "mx-n500",
                    "replaceWithDisplay": "mx-*-n500",
                    "rules": [
                        {
                            "selector": ".mx-n450",
                            "atRules": [],
                            "declarations": [
                                "margin-right: -4.5rem !important"
                            ]
                        },
                        {
                            "selector": ".mx-n450",
                            "atRules": [],
                            "declarations": [
                                "margin-left: -4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-1",
                    "display": "my-*-1",
                    "variants": [
                        "my-sm-1",
                        "my-md-1",
                        "my-lg-1",
                        "my-xl-1",
                        "my-xxl-1"
                    ],
                    "important": true,
                    "replaceWith": "my-25",
                    "replaceWithDisplay": "my-*-25",
                    "rules": [
                        {
                            "selector": ".my-1",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 0.25rem !important"
                            ]
                        },
                        {
                            "selector": ".my-1",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-2",
                    "display": "my-*-2",
                    "variants": [
                        "my-sm-2",
                        "my-md-2",
                        "my-lg-2",
                        "my-xl-2",
                        "my-xxl-2"
                    ],
                    "important": true,
                    "replaceWith": "my-50",
                    "replaceWithDisplay": "my-*-50",
                    "rules": [
                        {
                            "selector": ".my-2",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 0.5rem !important"
                            ]
                        },
                        {
                            "selector": ".my-2",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-3",
                    "display": "my-*-3",
                    "variants": [
                        "my-sm-3",
                        "my-md-3",
                        "my-lg-3",
                        "my-xl-3",
                        "my-xxl-3"
                    ],
                    "important": true,
                    "replaceWith": "my-100",
                    "replaceWithDisplay": "my-*-100",
                    "rules": [
                        {
                            "selector": ".my-3",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 1rem !important"
                            ]
                        },
                        {
                            "selector": ".my-3",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-4",
                    "display": "my-*-4",
                    "variants": [
                        "my-sm-4",
                        "my-md-4",
                        "my-lg-4",
                        "my-xl-4",
                        "my-xxl-4"
                    ],
                    "important": true,
                    "replaceWith": "my-200",
                    "replaceWithDisplay": "my-*-200",
                    "rules": [
                        {
                            "selector": ".my-4",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 2rem !important"
                            ]
                        },
                        {
                            "selector": ".my-4",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-5",
                    "display": "my-*-5",
                    "variants": [
                        "my-sm-5",
                        "my-md-5",
                        "my-lg-5",
                        "my-xl-5",
                        "my-xxl-5"
                    ],
                    "important": true,
                    "replaceWith": "my-500",
                    "replaceWithDisplay": "my-*-500",
                    "rules": [
                        {
                            "selector": ".my-5",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 4.5rem !important"
                            ]
                        },
                        {
                            "selector": ".my-5",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-6",
                    "display": "my-*-6",
                    "variants": [
                        "my-sm-6",
                        "my-md-6",
                        "my-lg-6",
                        "my-xl-6",
                        "my-xxl-6"
                    ],
                    "important": true,
                    "replaceWith": "my-800",
                    "replaceWithDisplay": "my-*-800",
                    "rules": [
                        {
                            "selector": ".my-6",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 8rem !important"
                            ]
                        },
                        {
                            "selector": ".my-6",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-450",
                    "display": "my-*-450",
                    "variants": [
                        "my-sm-450",
                        "my-md-450",
                        "my-lg-450",
                        "my-xl-450",
                        "my-xxl-450"
                    ],
                    "important": true,
                    "replaceWith": "my-500",
                    "replaceWithDisplay": "my-*-500",
                    "rules": [
                        {
                            "selector": ".my-450",
                            "atRules": [],
                            "declarations": [
                                "margin-top: 4.5rem !important"
                            ]
                        },
                        {
                            "selector": ".my-450",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n1",
                    "display": "my-*-n1",
                    "variants": [
                        "my-sm-n1",
                        "my-md-n1",
                        "my-lg-n1",
                        "my-xl-n1",
                        "my-xxl-n1"
                    ],
                    "important": true,
                    "replaceWith": "my-n25",
                    "replaceWithDisplay": "my-*-n25",
                    "rules": [
                        {
                            "selector": ".my-n1",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -0.25rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n1",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n2",
                    "display": "my-*-n2",
                    "variants": [
                        "my-sm-n2",
                        "my-md-n2",
                        "my-lg-n2",
                        "my-xl-n2",
                        "my-xxl-n2"
                    ],
                    "important": true,
                    "replaceWith": "my-n50",
                    "replaceWithDisplay": "my-*-n50",
                    "rules": [
                        {
                            "selector": ".my-n2",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -0.5rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n2",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n3",
                    "display": "my-*-n3",
                    "variants": [
                        "my-sm-n3",
                        "my-md-n3",
                        "my-lg-n3",
                        "my-xl-n3",
                        "my-xxl-n3"
                    ],
                    "important": true,
                    "replaceWith": "my-n100",
                    "replaceWithDisplay": "my-*-n100",
                    "rules": [
                        {
                            "selector": ".my-n3",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -1rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n3",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n4",
                    "display": "my-*-n4",
                    "variants": [
                        "my-sm-n4",
                        "my-md-n4",
                        "my-lg-n4",
                        "my-xl-n4",
                        "my-xxl-n4"
                    ],
                    "important": true,
                    "replaceWith": "my-n200",
                    "replaceWithDisplay": "my-*-n200",
                    "rules": [
                        {
                            "selector": ".my-n4",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -2rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n4",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n5",
                    "display": "my-*-n5",
                    "variants": [
                        "my-sm-n5",
                        "my-md-n5",
                        "my-lg-n5",
                        "my-xl-n5",
                        "my-xxl-n5"
                    ],
                    "important": true,
                    "replaceWith": "my-n500",
                    "replaceWithDisplay": "my-*-n500",
                    "rules": [
                        {
                            "selector": ".my-n5",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -4.5rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n5",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n6",
                    "display": "my-*-n6",
                    "variants": [
                        "my-sm-n6",
                        "my-md-n6",
                        "my-lg-n6",
                        "my-xl-n6",
                        "my-xxl-n6"
                    ],
                    "important": true,
                    "replaceWith": "my-n800",
                    "replaceWithDisplay": "my-*-n800",
                    "rules": [
                        {
                            "selector": ".my-n6",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -8rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n6",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "my-n450",
                    "display": "my-*-n450",
                    "variants": [
                        "my-sm-n450",
                        "my-md-n450",
                        "my-lg-n450",
                        "my-xl-n450",
                        "my-xxl-n450"
                    ],
                    "important": true,
                    "replaceWith": "my-n500",
                    "replaceWithDisplay": "my-*-n500",
                    "rules": [
                        {
                            "selector": ".my-n450",
                            "atRules": [],
                            "declarations": [
                                "margin-top: -4.5rem !important"
                            ]
                        },
                        {
                            "selector": ".my-n450",
                            "atRules": [],
                            "declarations": [
                                "margin-bottom: -4.5rem !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "padding",
            "source": "scss/utilities/_spacing.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "p-1",
                    "display": "p-*-1",
                    "variants": [
                        "p-sm-1",
                        "p-md-1",
                        "p-lg-1",
                        "p-xl-1",
                        "p-xxl-1"
                    ],
                    "important": true,
                    "replaceWith": "p-25",
                    "replaceWithDisplay": "p-*-25",
                    "rules": [
                        {
                            "selector": ".p-1",
                            "atRules": [],
                            "declarations": [
                                "padding: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-2",
                    "display": "p-*-2",
                    "variants": [
                        "p-sm-2",
                        "p-md-2",
                        "p-lg-2",
                        "p-xl-2",
                        "p-xxl-2"
                    ],
                    "important": true,
                    "replaceWith": "p-50",
                    "replaceWithDisplay": "p-*-50",
                    "rules": [
                        {
                            "selector": ".p-2",
                            "atRules": [],
                            "declarations": [
                                "padding: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-3",
                    "display": "p-*-3",
                    "variants": [
                        "p-sm-3",
                        "p-md-3",
                        "p-lg-3",
                        "p-xl-3",
                        "p-xxl-3"
                    ],
                    "important": true,
                    "replaceWith": "p-100",
                    "replaceWithDisplay": "p-*-100",
                    "rules": [
                        {
                            "selector": ".p-3",
                            "atRules": [],
                            "declarations": [
                                "padding: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-4",
                    "display": "p-*-4",
                    "variants": [
                        "p-sm-4",
                        "p-md-4",
                        "p-lg-4",
                        "p-xl-4",
                        "p-xxl-4"
                    ],
                    "important": true,
                    "replaceWith": "p-200",
                    "replaceWithDisplay": "p-*-200",
                    "rules": [
                        {
                            "selector": ".p-4",
                            "atRules": [],
                            "declarations": [
                                "padding: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-5",
                    "display": "p-*-5",
                    "variants": [
                        "p-sm-5",
                        "p-md-5",
                        "p-lg-5",
                        "p-xl-5",
                        "p-xxl-5"
                    ],
                    "important": true,
                    "replaceWith": "p-500",
                    "replaceWithDisplay": "p-*-500",
                    "rules": [
                        {
                            "selector": ".p-5",
                            "atRules": [],
                            "declarations": [
                                "padding: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-6",
                    "display": "p-*-6",
                    "variants": [
                        "p-sm-6",
                        "p-md-6",
                        "p-lg-6",
                        "p-xl-6",
                        "p-xxl-6"
                    ],
                    "important": true,
                    "replaceWith": "p-800",
                    "replaceWithDisplay": "p-*-800",
                    "rules": [
                        {
                            "selector": ".p-6",
                            "atRules": [],
                            "declarations": [
                                "padding: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "p-450",
                    "display": "p-*-450",
                    "variants": [
                        "p-sm-450",
                        "p-md-450",
                        "p-lg-450",
                        "p-xl-450",
                        "p-xxl-450"
                    ],
                    "important": true,
                    "replaceWith": "p-500",
                    "replaceWithDisplay": "p-*-500",
                    "rules": [
                        {
                            "selector": ".p-450",
                            "atRules": [],
                            "declarations": [
                                "padding: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-1",
                    "display": "pb-*-1",
                    "variants": [
                        "pb-sm-1",
                        "pb-md-1",
                        "pb-lg-1",
                        "pb-xl-1",
                        "pb-xxl-1"
                    ],
                    "important": true,
                    "replaceWith": "pb-25",
                    "replaceWithDisplay": "pb-*-25",
                    "rules": [
                        {
                            "selector": ".pb-1",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-2",
                    "display": "pb-*-2",
                    "variants": [
                        "pb-sm-2",
                        "pb-md-2",
                        "pb-lg-2",
                        "pb-xl-2",
                        "pb-xxl-2"
                    ],
                    "important": true,
                    "replaceWith": "pb-50",
                    "replaceWithDisplay": "pb-*-50",
                    "rules": [
                        {
                            "selector": ".pb-2",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-3",
                    "display": "pb-*-3",
                    "variants": [
                        "pb-sm-3",
                        "pb-md-3",
                        "pb-lg-3",
                        "pb-xl-3",
                        "pb-xxl-3"
                    ],
                    "important": true,
                    "replaceWith": "pb-100",
                    "replaceWithDisplay": "pb-*-100",
                    "rules": [
                        {
                            "selector": ".pb-3",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-4",
                    "display": "pb-*-4",
                    "variants": [
                        "pb-sm-4",
                        "pb-md-4",
                        "pb-lg-4",
                        "pb-xl-4",
                        "pb-xxl-4"
                    ],
                    "important": true,
                    "replaceWith": "pb-200",
                    "replaceWithDisplay": "pb-*-200",
                    "rules": [
                        {
                            "selector": ".pb-4",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-5",
                    "display": "pb-*-5",
                    "variants": [
                        "pb-sm-5",
                        "pb-md-5",
                        "pb-lg-5",
                        "pb-xl-5",
                        "pb-xxl-5"
                    ],
                    "important": true,
                    "replaceWith": "pb-500",
                    "replaceWithDisplay": "pb-*-500",
                    "rules": [
                        {
                            "selector": ".pb-5",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-6",
                    "display": "pb-*-6",
                    "variants": [
                        "pb-sm-6",
                        "pb-md-6",
                        "pb-lg-6",
                        "pb-xl-6",
                        "pb-xxl-6"
                    ],
                    "important": true,
                    "replaceWith": "pb-800",
                    "replaceWithDisplay": "pb-*-800",
                    "rules": [
                        {
                            "selector": ".pb-6",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pb-450",
                    "display": "pb-*-450",
                    "variants": [
                        "pb-sm-450",
                        "pb-md-450",
                        "pb-lg-450",
                        "pb-xl-450",
                        "pb-xxl-450"
                    ],
                    "important": true,
                    "replaceWith": "pb-500",
                    "replaceWithDisplay": "pb-*-500",
                    "rules": [
                        {
                            "selector": ".pb-450",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-1",
                    "display": "pl-*-1",
                    "variants": [
                        "pl-sm-1",
                        "pl-md-1",
                        "pl-lg-1",
                        "pl-xl-1",
                        "pl-xxl-1"
                    ],
                    "important": true,
                    "replaceWith": "pl-25",
                    "replaceWithDisplay": "pl-*-25",
                    "rules": [
                        {
                            "selector": ".pl-1",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-2",
                    "display": "pl-*-2",
                    "variants": [
                        "pl-sm-2",
                        "pl-md-2",
                        "pl-lg-2",
                        "pl-xl-2",
                        "pl-xxl-2"
                    ],
                    "important": true,
                    "replaceWith": "pl-50",
                    "replaceWithDisplay": "pl-*-50",
                    "rules": [
                        {
                            "selector": ".pl-2",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-3",
                    "display": "pl-*-3",
                    "variants": [
                        "pl-sm-3",
                        "pl-md-3",
                        "pl-lg-3",
                        "pl-xl-3",
                        "pl-xxl-3"
                    ],
                    "important": true,
                    "replaceWith": "pl-100",
                    "replaceWithDisplay": "pl-*-100",
                    "rules": [
                        {
                            "selector": ".pl-3",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-4",
                    "display": "pl-*-4",
                    "variants": [
                        "pl-sm-4",
                        "pl-md-4",
                        "pl-lg-4",
                        "pl-xl-4",
                        "pl-xxl-4"
                    ],
                    "important": true,
                    "replaceWith": "pl-200",
                    "replaceWithDisplay": "pl-*-200",
                    "rules": [
                        {
                            "selector": ".pl-4",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-5",
                    "display": "pl-*-5",
                    "variants": [
                        "pl-sm-5",
                        "pl-md-5",
                        "pl-lg-5",
                        "pl-xl-5",
                        "pl-xxl-5"
                    ],
                    "important": true,
                    "replaceWith": "pl-500",
                    "replaceWithDisplay": "pl-*-500",
                    "rules": [
                        {
                            "selector": ".pl-5",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-6",
                    "display": "pl-*-6",
                    "variants": [
                        "pl-sm-6",
                        "pl-md-6",
                        "pl-lg-6",
                        "pl-xl-6",
                        "pl-xxl-6"
                    ],
                    "important": true,
                    "replaceWith": "pl-800",
                    "replaceWithDisplay": "pl-*-800",
                    "rules": [
                        {
                            "selector": ".pl-6",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pl-450",
                    "display": "pl-*-450",
                    "variants": [
                        "pl-sm-450",
                        "pl-md-450",
                        "pl-lg-450",
                        "pl-xl-450",
                        "pl-xxl-450"
                    ],
                    "important": true,
                    "replaceWith": "pl-500",
                    "replaceWithDisplay": "pl-*-500",
                    "rules": [
                        {
                            "selector": ".pl-450",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-1",
                    "display": "pr-*-1",
                    "variants": [
                        "pr-sm-1",
                        "pr-md-1",
                        "pr-lg-1",
                        "pr-xl-1",
                        "pr-xxl-1"
                    ],
                    "important": true,
                    "replaceWith": "pr-25",
                    "replaceWithDisplay": "pr-*-25",
                    "rules": [
                        {
                            "selector": ".pr-1",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-2",
                    "display": "pr-*-2",
                    "variants": [
                        "pr-sm-2",
                        "pr-md-2",
                        "pr-lg-2",
                        "pr-xl-2",
                        "pr-xxl-2"
                    ],
                    "important": true,
                    "replaceWith": "pr-50",
                    "replaceWithDisplay": "pr-*-50",
                    "rules": [
                        {
                            "selector": ".pr-2",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-3",
                    "display": "pr-*-3",
                    "variants": [
                        "pr-sm-3",
                        "pr-md-3",
                        "pr-lg-3",
                        "pr-xl-3",
                        "pr-xxl-3"
                    ],
                    "important": true,
                    "replaceWith": "pr-100",
                    "replaceWithDisplay": "pr-*-100",
                    "rules": [
                        {
                            "selector": ".pr-3",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-4",
                    "display": "pr-*-4",
                    "variants": [
                        "pr-sm-4",
                        "pr-md-4",
                        "pr-lg-4",
                        "pr-xl-4",
                        "pr-xxl-4"
                    ],
                    "important": true,
                    "replaceWith": "pr-200",
                    "replaceWithDisplay": "pr-*-200",
                    "rules": [
                        {
                            "selector": ".pr-4",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-5",
                    "display": "pr-*-5",
                    "variants": [
                        "pr-sm-5",
                        "pr-md-5",
                        "pr-lg-5",
                        "pr-xl-5",
                        "pr-xxl-5"
                    ],
                    "important": true,
                    "replaceWith": "pr-500",
                    "replaceWithDisplay": "pr-*-500",
                    "rules": [
                        {
                            "selector": ".pr-5",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-6",
                    "display": "pr-*-6",
                    "variants": [
                        "pr-sm-6",
                        "pr-md-6",
                        "pr-lg-6",
                        "pr-xl-6",
                        "pr-xxl-6"
                    ],
                    "important": true,
                    "replaceWith": "pr-800",
                    "replaceWithDisplay": "pr-*-800",
                    "rules": [
                        {
                            "selector": ".pr-6",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pr-450",
                    "display": "pr-*-450",
                    "variants": [
                        "pr-sm-450",
                        "pr-md-450",
                        "pr-lg-450",
                        "pr-xl-450",
                        "pr-xxl-450"
                    ],
                    "important": true,
                    "replaceWith": "pr-500",
                    "replaceWithDisplay": "pr-*-500",
                    "rules": [
                        {
                            "selector": ".pr-450",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-1",
                    "display": "pt-*-1",
                    "variants": [
                        "pt-sm-1",
                        "pt-md-1",
                        "pt-lg-1",
                        "pt-xl-1",
                        "pt-xxl-1"
                    ],
                    "important": true,
                    "replaceWith": "pt-25",
                    "replaceWithDisplay": "pt-*-25",
                    "rules": [
                        {
                            "selector": ".pt-1",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-2",
                    "display": "pt-*-2",
                    "variants": [
                        "pt-sm-2",
                        "pt-md-2",
                        "pt-lg-2",
                        "pt-xl-2",
                        "pt-xxl-2"
                    ],
                    "important": true,
                    "replaceWith": "pt-50",
                    "replaceWithDisplay": "pt-*-50",
                    "rules": [
                        {
                            "selector": ".pt-2",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-3",
                    "display": "pt-*-3",
                    "variants": [
                        "pt-sm-3",
                        "pt-md-3",
                        "pt-lg-3",
                        "pt-xl-3",
                        "pt-xxl-3"
                    ],
                    "important": true,
                    "replaceWith": "pt-100",
                    "replaceWithDisplay": "pt-*-100",
                    "rules": [
                        {
                            "selector": ".pt-3",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-4",
                    "display": "pt-*-4",
                    "variants": [
                        "pt-sm-4",
                        "pt-md-4",
                        "pt-lg-4",
                        "pt-xl-4",
                        "pt-xxl-4"
                    ],
                    "important": true,
                    "replaceWith": "pt-200",
                    "replaceWithDisplay": "pt-*-200",
                    "rules": [
                        {
                            "selector": ".pt-4",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-5",
                    "display": "pt-*-5",
                    "variants": [
                        "pt-sm-5",
                        "pt-md-5",
                        "pt-lg-5",
                        "pt-xl-5",
                        "pt-xxl-5"
                    ],
                    "important": true,
                    "replaceWith": "pt-500",
                    "replaceWithDisplay": "pt-*-500",
                    "rules": [
                        {
                            "selector": ".pt-5",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-6",
                    "display": "pt-*-6",
                    "variants": [
                        "pt-sm-6",
                        "pt-md-6",
                        "pt-lg-6",
                        "pt-xl-6",
                        "pt-xxl-6"
                    ],
                    "important": true,
                    "replaceWith": "pt-800",
                    "replaceWithDisplay": "pt-*-800",
                    "rules": [
                        {
                            "selector": ".pt-6",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "pt-450",
                    "display": "pt-*-450",
                    "variants": [
                        "pt-sm-450",
                        "pt-md-450",
                        "pt-lg-450",
                        "pt-xl-450",
                        "pt-xxl-450"
                    ],
                    "important": true,
                    "replaceWith": "pt-500",
                    "replaceWithDisplay": "pt-*-500",
                    "rules": [
                        {
                            "selector": ".pt-450",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-1",
                    "display": "px-*-1",
                    "variants": [
                        "px-sm-1",
                        "px-md-1",
                        "px-lg-1",
                        "px-xl-1",
                        "px-xxl-1"
                    ],
                    "important": true,
                    "replaceWith": "px-25",
                    "replaceWithDisplay": "px-*-25",
                    "rules": [
                        {
                            "selector": ".px-1",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 0.25rem !important"
                            ]
                        },
                        {
                            "selector": ".px-1",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-2",
                    "display": "px-*-2",
                    "variants": [
                        "px-sm-2",
                        "px-md-2",
                        "px-lg-2",
                        "px-xl-2",
                        "px-xxl-2"
                    ],
                    "important": true,
                    "replaceWith": "px-50",
                    "replaceWithDisplay": "px-*-50",
                    "rules": [
                        {
                            "selector": ".px-2",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 0.5rem !important"
                            ]
                        },
                        {
                            "selector": ".px-2",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-3",
                    "display": "px-*-3",
                    "variants": [
                        "px-sm-3",
                        "px-md-3",
                        "px-lg-3",
                        "px-xl-3",
                        "px-xxl-3"
                    ],
                    "important": true,
                    "replaceWith": "px-100",
                    "replaceWithDisplay": "px-*-100",
                    "rules": [
                        {
                            "selector": ".px-3",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 1rem !important"
                            ]
                        },
                        {
                            "selector": ".px-3",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-4",
                    "display": "px-*-4",
                    "variants": [
                        "px-sm-4",
                        "px-md-4",
                        "px-lg-4",
                        "px-xl-4",
                        "px-xxl-4"
                    ],
                    "important": true,
                    "replaceWith": "px-200",
                    "replaceWithDisplay": "px-*-200",
                    "rules": [
                        {
                            "selector": ".px-4",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 2rem !important"
                            ]
                        },
                        {
                            "selector": ".px-4",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-5",
                    "display": "px-*-5",
                    "variants": [
                        "px-sm-5",
                        "px-md-5",
                        "px-lg-5",
                        "px-xl-5",
                        "px-xxl-5"
                    ],
                    "important": true,
                    "replaceWith": "px-500",
                    "replaceWithDisplay": "px-*-500",
                    "rules": [
                        {
                            "selector": ".px-5",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 4.5rem !important"
                            ]
                        },
                        {
                            "selector": ".px-5",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-6",
                    "display": "px-*-6",
                    "variants": [
                        "px-sm-6",
                        "px-md-6",
                        "px-lg-6",
                        "px-xl-6",
                        "px-xxl-6"
                    ],
                    "important": true,
                    "replaceWith": "px-800",
                    "replaceWithDisplay": "px-*-800",
                    "rules": [
                        {
                            "selector": ".px-6",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 8rem !important"
                            ]
                        },
                        {
                            "selector": ".px-6",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "px-450",
                    "display": "px-*-450",
                    "variants": [
                        "px-sm-450",
                        "px-md-450",
                        "px-lg-450",
                        "px-xl-450",
                        "px-xxl-450"
                    ],
                    "important": true,
                    "replaceWith": "px-500",
                    "replaceWithDisplay": "px-*-500",
                    "rules": [
                        {
                            "selector": ".px-450",
                            "atRules": [],
                            "declarations": [
                                "padding-right: 4.5rem !important"
                            ]
                        },
                        {
                            "selector": ".px-450",
                            "atRules": [],
                            "declarations": [
                                "padding-left: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-1",
                    "display": "py-*-1",
                    "variants": [
                        "py-sm-1",
                        "py-md-1",
                        "py-lg-1",
                        "py-xl-1",
                        "py-xxl-1"
                    ],
                    "important": true,
                    "replaceWith": "py-25",
                    "replaceWithDisplay": "py-*-25",
                    "rules": [
                        {
                            "selector": ".py-1",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 0.25rem !important"
                            ]
                        },
                        {
                            "selector": ".py-1",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 0.25rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-2",
                    "display": "py-*-2",
                    "variants": [
                        "py-sm-2",
                        "py-md-2",
                        "py-lg-2",
                        "py-xl-2",
                        "py-xxl-2"
                    ],
                    "important": true,
                    "replaceWith": "py-50",
                    "replaceWithDisplay": "py-*-50",
                    "rules": [
                        {
                            "selector": ".py-2",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 0.5rem !important"
                            ]
                        },
                        {
                            "selector": ".py-2",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 0.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-3",
                    "display": "py-*-3",
                    "variants": [
                        "py-sm-3",
                        "py-md-3",
                        "py-lg-3",
                        "py-xl-3",
                        "py-xxl-3"
                    ],
                    "important": true,
                    "replaceWith": "py-100",
                    "replaceWithDisplay": "py-*-100",
                    "rules": [
                        {
                            "selector": ".py-3",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 1rem !important"
                            ]
                        },
                        {
                            "selector": ".py-3",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 1rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-4",
                    "display": "py-*-4",
                    "variants": [
                        "py-sm-4",
                        "py-md-4",
                        "py-lg-4",
                        "py-xl-4",
                        "py-xxl-4"
                    ],
                    "important": true,
                    "replaceWith": "py-200",
                    "replaceWithDisplay": "py-*-200",
                    "rules": [
                        {
                            "selector": ".py-4",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 2rem !important"
                            ]
                        },
                        {
                            "selector": ".py-4",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 2rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-5",
                    "display": "py-*-5",
                    "variants": [
                        "py-sm-5",
                        "py-md-5",
                        "py-lg-5",
                        "py-xl-5",
                        "py-xxl-5"
                    ],
                    "important": true,
                    "replaceWith": "py-500",
                    "replaceWithDisplay": "py-*-500",
                    "rules": [
                        {
                            "selector": ".py-5",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 4.5rem !important"
                            ]
                        },
                        {
                            "selector": ".py-5",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 4.5rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-6",
                    "display": "py-*-6",
                    "variants": [
                        "py-sm-6",
                        "py-md-6",
                        "py-lg-6",
                        "py-xl-6",
                        "py-xxl-6"
                    ],
                    "important": true,
                    "replaceWith": "py-800",
                    "replaceWithDisplay": "py-*-800",
                    "rules": [
                        {
                            "selector": ".py-6",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 8rem !important"
                            ]
                        },
                        {
                            "selector": ".py-6",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 8rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "py-450",
                    "display": "py-*-450",
                    "variants": [
                        "py-sm-450",
                        "py-md-450",
                        "py-lg-450",
                        "py-xl-450",
                        "py-xxl-450"
                    ],
                    "important": true,
                    "replaceWith": "py-500",
                    "replaceWithDisplay": "py-*-500",
                    "rules": [
                        {
                            "selector": ".py-450",
                            "atRules": [],
                            "declarations": [
                                "padding-top: 4.5rem !important"
                            ]
                        },
                        {
                            "selector": ".py-450",
                            "atRules": [],
                            "declarations": [
                                "padding-bottom: 4.5rem !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "text color",
            "source": "scss/utilities/_text.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "text-cyan",
                    "important": true,
                    "replaceWith": "text-dark-blue",
                    "rules": [
                        {
                            "selector": ".text-cyan",
                            "atRules": [],
                            "declarations": [
                                "color: #1b1763 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-cyan-100",
                    "important": true,
                    "replaceWith": "text-blue-50",
                    "rules": [
                        {
                            "selector": ".text-cyan-100",
                            "atRules": [],
                            "declarations": [
                                "color: #ddedff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-cyan-200",
                    "important": true,
                    "replaceWith": "text-blue-100",
                    "rules": [
                        {
                            "selector": ".text-cyan-200",
                            "atRules": [],
                            "declarations": [
                                "color: #c8dfff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-cyan-300",
                    "important": true,
                    "replaceWith": "text-blue-200",
                    "rules": [
                        {
                            "selector": ".text-cyan-300",
                            "atRules": [],
                            "declarations": [
                                "color: #a7c9ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-cyan-400",
                    "important": true,
                    "replaceWith": "text-blue-500",
                    "rules": [
                        {
                            "selector": ".text-cyan-400",
                            "atRules": [],
                            "declarations": [
                                "color: #4a62d4 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-cyan-500",
                    "important": true,
                    "replaceWith": "text-blue-600",
                    "rules": [
                        {
                            "selector": ".text-cyan-500",
                            "atRules": [],
                            "declarations": [
                                "color: #2e46b9 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-cyan-600",
                    "important": true,
                    "replaceWith": "text-blue-700",
                    "rules": [
                        {
                            "selector": ".text-cyan-600",
                            "atRules": [],
                            "declarations": [
                                "color: #1d3297 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-cyan-700",
                    "important": true,
                    "replaceWith": "text-blue-800",
                    "rules": [
                        {
                            "selector": ".text-cyan-700",
                            "atRules": [],
                            "declarations": [
                                "color: #162676 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-cyan-800",
                    "important": true,
                    "replaceWith": "text-blue-900",
                    "rules": [
                        {
                            "selector": ".text-cyan-800",
                            "atRules": [],
                            "declarations": [
                                "color: #1b1763 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-danger",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-danger",
                            "atRules": [],
                            "declarations": [
                                "color: #de3c50 !important"
                            ]
                        },
                        {
                            "selector": "a.text-danger:hover",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(68.9241486068%, 11.6640866873%, 18.7332301342%) !important"
                            ]
                        },
                        {
                            "selector": "a.text-danger:focus",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(68.9241486068%, 11.6640866873%, 18.7332301342%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-dark",
                    "important": true,
                    "replaceWith": "text-body",
                    "rules": [
                        {
                            "selector": ".text-dark",
                            "atRules": [],
                            "declarations": [
                                "color: #222633 !important"
                            ]
                        },
                        {
                            "selector": "a.text-dark:hover",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(1.3333333333%, 1.4901960784%, 2%) !important"
                            ]
                        },
                        {
                            "selector": "a.text-dark:focus",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(1.3333333333%, 1.4901960784%, 2%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray",
                    "important": true,
                    "replaceWith": "text-gray-900",
                    "rules": [
                        {
                            "selector": ".text-gray",
                            "atRules": [],
                            "declarations": [
                                "color: #222633 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray-1000",
                    "important": true,
                    "replaceWith": "text-gray-900",
                    "rules": [
                        {
                            "selector": ".text-gray-1000",
                            "atRules": [],
                            "declarations": [
                                "color: #222633 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray-1100",
                    "important": true,
                    "replaceWith": "text-gray-900",
                    "rules": [
                        {
                            "selector": ".text-gray-1100",
                            "atRules": [],
                            "declarations": [
                                "color: #222633 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray-1200",
                    "important": true,
                    "replaceWith": "text-gray-900",
                    "rules": [
                        {
                            "selector": ".text-gray-1200",
                            "atRules": [],
                            "declarations": [
                                "color: #222633 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray-blue",
                    "important": true,
                    "replaceWith": "text-soft-blue",
                    "rules": [
                        {
                            "selector": ".text-gray-blue",
                            "atRules": [],
                            "declarations": [
                                "color: #c8dfff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-gray-dark",
                    "important": true,
                    "replaceWith": "text-gray-800",
                    "rules": [
                        {
                            "selector": ".text-gray-dark",
                            "atRules": [],
                            "declarations": [
                                "color: #323543 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-green",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-green",
                            "atRules": [],
                            "declarations": [
                                "color: #00a759 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-highlight",
                    "important": true,
                    "replaceWith": "text-blue-700",
                    "rules": [
                        {
                            "selector": ".text-highlight",
                            "atRules": [],
                            "declarations": [
                                "color: #1d3297 !important"
                            ]
                        },
                        {
                            "selector": "a.text-highlight:hover",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(6.5392156863%, 11.2745098039%, 34.0490196078%) !important"
                            ]
                        },
                        {
                            "selector": "a.text-highlight:focus",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(6.5392156863%, 11.2745098039%, 34.0490196078%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-highlight-dark",
                    "important": true,
                    "replaceWith": "text-blue-600",
                    "rules": [
                        {
                            "selector": ".text-highlight-dark",
                            "atRules": [],
                            "declarations": [
                                "color: #2e46b9 !important"
                            ]
                        },
                        {
                            "selector": "a.text-highlight-dark:hover",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(12.0651897122%, 18.3600713012%, 48.5230455819%) !important"
                            ]
                        },
                        {
                            "selector": "a.text-highlight-dark:focus",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(12.0651897122%, 18.3600713012%, 48.5230455819%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-indigo",
                    "important": true,
                    "replaceWith": "text-blue-700",
                    "rules": [
                        {
                            "selector": ".text-indigo",
                            "atRules": [],
                            "declarations": [
                                "color: #1d3297 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-info",
                    "important": true,
                    "replaceWith": "text-medium-blue",
                    "rules": [
                        {
                            "selector": ".text-info",
                            "atRules": [],
                            "declarations": [
                                "color: #85b2ff !important"
                            ]
                        },
                        {
                            "selector": "a.text-info:hover",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(22.1568627451%, 50.8694953391%, 100%) !important"
                            ]
                        },
                        {
                            "selector": "a.text-info:focus",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(22.1568627451%, 50.8694953391%, 100%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-light",
                    "important": true,
                    "replaceWith": "text-gray-200",
                    "rules": [
                        {
                            "selector": ".text-light",
                            "atRules": [],
                            "declarations": [
                                "color: #dfe1eb !important"
                            ]
                        },
                        {
                            "selector": "a.text-light:hover",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(68.9894419306%, 70.92760181%, 80.6184012066%) !important"
                            ]
                        },
                        {
                            "selector": "a.text-light:focus",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(68.9894419306%, 70.92760181%, 80.6184012066%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-light-blue",
                    "important": true,
                    "replaceWith": "text-blue-200",
                    "rules": [
                        {
                            "selector": ".text-light-blue",
                            "atRules": [],
                            "declarations": [
                                "color: #a7c9ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-mid",
                    "important": true,
                    "replaceWith": "text-gray-300",
                    "rules": [
                        {
                            "selector": ".text-mid",
                            "atRules": [],
                            "declarations": [
                                "color: #cfd1df !important"
                            ]
                        },
                        {
                            "selector": "a.text-mid:hover",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(63.1764705882%, 64.7107843137%, 75.4509803922%) !important"
                            ]
                        },
                        {
                            "selector": "a.text-mid:focus",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(63.1764705882%, 64.7107843137%, 75.4509803922%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-mid-dark",
                    "important": true,
                    "replaceWith": "text-muted",
                    "rules": [
                        {
                            "selector": ".text-mid-dark",
                            "atRules": [],
                            "declarations": [
                                "color: #646776 !important"
                            ]
                        },
                        {
                            "selector": "a.text-mid-dark:hover",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(25.4542183846%, 26.2178449361%, 30.0359776938%) !important"
                            ]
                        },
                        {
                            "selector": "a.text-mid-dark:focus",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(25.4542183846%, 26.2178449361%, 30.0359776938%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-orange",
                    "important": true,
                    "replaceWith": "text-warm-orange",
                    "rules": [
                        {
                            "selector": ".text-orange",
                            "atRules": [],
                            "declarations": [
                                "color: #ff9133 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-pink",
                    "important": true,
                    "replaceWith": "text-warm-orange",
                    "rules": [
                        {
                            "selector": ".text-pink",
                            "atRules": [],
                            "declarations": [
                                "color: #ff9133 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-pink-100",
                    "important": true,
                    "replaceWith": "text-orange-50",
                    "rules": [
                        {
                            "selector": ".text-pink-100",
                            "atRules": [],
                            "declarations": [
                                "color: #fff3df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-pink-200",
                    "important": true,
                    "replaceWith": "text-orange-200",
                    "rules": [
                        {
                            "selector": ".text-pink-200",
                            "atRules": [],
                            "declarations": [
                                "color: #ffdbb5 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-pink-300",
                    "important": true,
                    "replaceWith": "text-orange-400",
                    "rules": [
                        {
                            "selector": ".text-pink-300",
                            "atRules": [],
                            "declarations": [
                                "color: #ffc28b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-pink-400",
                    "important": true,
                    "replaceWith": "text-orange-500",
                    "rules": [
                        {
                            "selector": ".text-pink-400",
                            "atRules": [],
                            "declarations": [
                                "color: #ffb67b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-pink-500",
                    "important": true,
                    "replaceWith": "text-orange-900",
                    "rules": [
                        {
                            "selector": ".text-pink-500",
                            "atRules": [],
                            "declarations": [
                                "color: #ed7c2b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-pink-600",
                    "important": true,
                    "replaceWith": "text-orange-900",
                    "rules": [
                        {
                            "selector": ".text-pink-600",
                            "atRules": [],
                            "declarations": [
                                "color: #ed7c2b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-pink-700",
                    "important": true,
                    "replaceWith": "text-orange-900",
                    "rules": [
                        {
                            "selector": ".text-pink-700",
                            "atRules": [],
                            "declarations": [
                                "color: #ed7c2b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-pink-800",
                    "important": true,
                    "replaceWith": "text-orange-900",
                    "rules": [
                        {
                            "selector": ".text-pink-800",
                            "atRules": [],
                            "declarations": [
                                "color: #ed7c2b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-primary",
                    "important": true,
                    "replaceWith": "text-dark-blue",
                    "rules": [
                        {
                            "selector": ".text-primary",
                            "atRules": [],
                            "declarations": [
                                "color: #1b1763 !important"
                            ]
                        },
                        {
                            "selector": "a.text-primary:hover",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(3.9488910318%, 3.3638701382%, 14.4792671167%) !important"
                            ]
                        },
                        {
                            "selector": "a.text-primary:focus",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(3.9488910318%, 3.3638701382%, 14.4792671167%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-purple",
                    "important": true,
                    "replaceWith": "text-blue-600",
                    "rules": [
                        {
                            "selector": ".text-purple",
                            "atRules": [],
                            "declarations": [
                                "color: #2e46b9 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-red",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-red",
                            "atRules": [],
                            "declarations": [
                                "color: #de3c50 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-secondary",
                    "important": true,
                    "replaceWith": "text-body",
                    "rules": [
                        {
                            "selector": ".text-secondary",
                            "atRules": [],
                            "declarations": [
                                "color: #222633 !important"
                            ]
                        },
                        {
                            "selector": "a.text-secondary:hover",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(1.3333333333%, 1.4901960784%, 2%) !important"
                            ]
                        },
                        {
                            "selector": "a.text-secondary:focus",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(1.3333333333%, 1.4901960784%, 2%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-success",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-success",
                            "atRules": [],
                            "declarations": [
                                "color: #00a759 !important"
                            ]
                        },
                        {
                            "selector": "a.text-success:hover",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(0%, 35.4901960784%, 18.9139368322%) !important"
                            ]
                        },
                        {
                            "selector": "a.text-success:focus",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(0%, 35.4901960784%, 18.9139368322%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-teal",
                    "important": true,
                    "replaceWith": "text-medium-blue",
                    "rules": [
                        {
                            "selector": ".text-teal",
                            "atRules": [],
                            "declarations": [
                                "color: #85b2ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-teal-100",
                    "important": true,
                    "replaceWith": "text-blue-50",
                    "rules": [
                        {
                            "selector": ".text-teal-100",
                            "atRules": [],
                            "declarations": [
                                "color: #ddedff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-teal-200",
                    "important": true,
                    "replaceWith": "text-blue-200",
                    "rules": [
                        {
                            "selector": ".text-teal-200",
                            "atRules": [],
                            "declarations": [
                                "color: #a7c9ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-teal-300",
                    "important": true,
                    "replaceWith": "text-blue-300",
                    "rules": [
                        {
                            "selector": ".text-teal-300",
                            "atRules": [],
                            "declarations": [
                                "color: #85b2ff !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-teal-400",
                    "important": true,
                    "replaceWith": "text-blue-400",
                    "rules": [
                        {
                            "selector": ".text-teal-400",
                            "atRules": [],
                            "declarations": [
                                "color: #688aea !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-teal-500",
                    "important": true,
                    "replaceWith": "text-blue-400",
                    "rules": [
                        {
                            "selector": ".text-teal-500",
                            "atRules": [],
                            "declarations": [
                                "color: #688aea !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-teal-600",
                    "important": true,
                    "replaceWith": "text-blue-600",
                    "rules": [
                        {
                            "selector": ".text-teal-600",
                            "atRules": [],
                            "declarations": [
                                "color: #2e46b9 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-teal-700",
                    "important": true,
                    "replaceWith": "text-blue-800",
                    "rules": [
                        {
                            "selector": ".text-teal-700",
                            "atRules": [],
                            "declarations": [
                                "color: #162676 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-teal-800",
                    "important": true,
                    "replaceWith": "text-blue-900",
                    "rules": [
                        {
                            "selector": ".text-teal-800",
                            "atRules": [],
                            "declarations": [
                                "color: #1b1763 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-warning",
                    "important": true,
                    "rules": [
                        {
                            "selector": ".text-warning",
                            "atRules": [],
                            "declarations": [
                                "color: #f4ca11 !important"
                            ]
                        },
                        {
                            "selector": "a.text-warning:hover",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(69.156626506%, 56.9525159461%, 3.1963146704%) !important"
                            ]
                        },
                        {
                            "selector": "a.text-warning:focus",
                            "atRules": [],
                            "declarations": [
                                "color: rgb(69.156626506%, 56.9525159461%, 3.1963146704%) !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-yellow",
                    "important": true,
                    "replaceWith": "text-warm-orange",
                    "rules": [
                        {
                            "selector": ".text-yellow",
                            "atRules": [],
                            "declarations": [
                                "color: #ff9133 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-yellow-100",
                    "important": true,
                    "replaceWith": "text-orange-50",
                    "rules": [
                        {
                            "selector": ".text-yellow-100",
                            "atRules": [],
                            "declarations": [
                                "color: #fff3df !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-yellow-200",
                    "important": true,
                    "replaceWith": "text-orange-200",
                    "rules": [
                        {
                            "selector": ".text-yellow-200",
                            "atRules": [],
                            "declarations": [
                                "color: #ffdbb5 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-yellow-300",
                    "important": true,
                    "replaceWith": "text-orange-400",
                    "rules": [
                        {
                            "selector": ".text-yellow-300",
                            "atRules": [],
                            "declarations": [
                                "color: #ffc28b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-yellow-400",
                    "important": true,
                    "replaceWith": "text-orange-600",
                    "rules": [
                        {
                            "selector": ".text-yellow-400",
                            "atRules": [],
                            "declarations": [
                                "color: #ffaa66 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-yellow-500",
                    "important": true,
                    "replaceWith": "text-orange-700",
                    "rules": [
                        {
                            "selector": ".text-yellow-500",
                            "atRules": [],
                            "declarations": [
                                "color: #ff9d51 !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-yellow-600",
                    "important": true,
                    "replaceWith": "text-orange-900",
                    "rules": [
                        {
                            "selector": ".text-yellow-600",
                            "atRules": [],
                            "declarations": [
                                "color: #ed7c2b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-yellow-700",
                    "important": true,
                    "replaceWith": "text-orange-900",
                    "rules": [
                        {
                            "selector": ".text-yellow-700",
                            "atRules": [],
                            "declarations": [
                                "color: #ed7c2b !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "text-yellow-800",
                    "important": true,
                    "replaceWith": "text-orange-900",
                    "rules": [
                        {
                            "selector": ".text-yellow-800",
                            "atRules": [],
                            "declarations": [
                                "color: #ed7c2b !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "text style",
            "source": "scss/utilities/_text.scss",
            "allClassesUseImportant": true,
            "classes": [
                {
                    "name": "font-size-xl",
                    "display": "font-size-*-xl",
                    "variants": [
                        "font-size-sm-xl",
                        "font-size-md-xl",
                        "font-size-lg-xl",
                        "font-size-xl-xl",
                        "font-size-xxl-xl"
                    ],
                    "important": true,
                    "replaceWith": "font-size-400",
                    "replaceWithDisplay": "font-size-*-400",
                    "rules": [
                        {
                            "selector": ".font-size-xl",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.5rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-xl",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.5rem !important",
                                "line-height: 1.75rem !important"
                            ]
                        }
                    ]
                },
                {
                    "name": "font-size-xxl",
                    "display": "font-size-*-xxl",
                    "variants": [
                        "font-size-sm-xxl",
                        "font-size-md-xxl",
                        "font-size-lg-xxl",
                        "font-size-xl-xxl",
                        "font-size-xxl-xxl"
                    ],
                    "important": true,
                    "replaceWith": "font-size-500",
                    "replaceWithDisplay": "font-size-*-500",
                    "rules": [
                        {
                            "selector": ".font-size-xxl",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.875rem !important"
                            ]
                        },
                        {
                            "selector": ".font-size-xxl",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.875rem !important",
                                "line-height: 2.25rem !important"
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "typography",
            "source": "scss/_type.scss",
            "allClassesUseImportant": false,
            "classes": [
                {
                    "name": "display-1",
                    "important": false,
                    "replaceWith": "post1",
                    "rules": [
                        {
                            "selector": ".display-1",
                            "atRules": [],
                            "declarations": [
                                "color: #222633",
                                "font-family: \"Plus Jakarta Sans\", \"Helvetica Neue\", Roboto, \"Segoe UI\", -apple-system, BlinkMacSystemFont, Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
                                "margin-bottom: 1rem"
                            ]
                        },
                        {
                            "selector": ".display-1",
                            "atRules": [],
                            "declarations": [
                                "font-size: 3rem",
                                "font-weight: 700",
                                "line-height: 3.5rem"
                            ]
                        },
                        {
                            "selector": ".display-1",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 3.875rem",
                                "font-weight: 700",
                                "line-height: 4.375rem"
                            ]
                        }
                    ]
                },
                {
                    "name": "display-2",
                    "important": false,
                    "replaceWith": "post2",
                    "rules": [
                        {
                            "selector": ".display-2",
                            "atRules": [],
                            "declarations": [
                                "color: #222633",
                                "font-family: \"Plus Jakarta Sans\", \"Helvetica Neue\", Roboto, \"Segoe UI\", -apple-system, BlinkMacSystemFont, Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
                                "margin-bottom: 1rem"
                            ]
                        },
                        {
                            "selector": ".display-2",
                            "atRules": [],
                            "declarations": [
                                "font-size: 2.375rem",
                                "font-weight: 700",
                                "line-height: 3rem"
                            ]
                        },
                        {
                            "selector": ".display-2",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 3.375rem",
                                "font-weight: 700",
                                "line-height: 4rem"
                            ]
                        }
                    ]
                },
                {
                    "name": "display-3",
                    "important": false,
                    "replaceWith": "post3",
                    "rules": [
                        {
                            "selector": ".display-3",
                            "atRules": [],
                            "declarations": [
                                "color: #222633",
                                "font-family: \"Plus Jakarta Sans\", \"Helvetica Neue\", Roboto, \"Segoe UI\", -apple-system, BlinkMacSystemFont, Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
                                "margin-bottom: 1rem"
                            ]
                        },
                        {
                            "selector": ".display-3",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.875rem",
                                "font-weight: 700",
                                "line-height: 2.25rem"
                            ]
                        },
                        {
                            "selector": ".display-3",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 3rem",
                                "font-weight: 700",
                                "line-height: 3.5rem"
                            ]
                        }
                    ]
                },
                {
                    "name": "display-4",
                    "important": false,
                    "replaceWith": "h1",
                    "rules": [
                        {
                            "selector": ".display-4",
                            "atRules": [],
                            "declarations": [
                                "color: #222633",
                                "font-family: \"Plus Jakarta Sans\", \"Helvetica Neue\", Roboto, \"Segoe UI\", -apple-system, BlinkMacSystemFont, Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
                                "margin-bottom: 1rem"
                            ]
                        },
                        {
                            "selector": ".display-4",
                            "atRules": [],
                            "declarations": [
                                "font-size: 1.5rem",
                                "font-weight: 600",
                                "line-height: 1.75rem"
                            ]
                        },
                        {
                            "selector": ".display-4",
                            "atRules": [
                                "@media (min-width: 992px)"
                            ],
                            "declarations": [
                                "font-size: 2.375rem",
                                "font-weight: 600",
                                "line-height: 3rem"
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}
